









































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { State, Action, Getter, Mutation } from 'vuex-class';
import { BModal } from 'bootstrap-vue/esm/components/modal';
import { Camera } from '@/models/camera';
import { Project } from '@/models/project';
import { User } from '@/models/user';
import { Photo, DetectionBox, CropBox } from '@/models/photo';
import { Storage } from 'aws-amplify';
import { Crop, Position } from '@/models/enums';
import Gallery from '../components/gallery/gallery.component.vue';
import AWS from 'aws-sdk';
import axios from 'axios';
import { Auth } from 'aws-amplify';
// @ts-ignore: no d.ts file
import { vTeleport } from '@desislavsd/vue-teleport';
import { NotificationMessage, Socket } from '@/store/types';
import { Logger } from 'aws-amplify';
import * as d3 from 'd3';
import * as d3Array from 'd3-array';
import * as Plotly from 'plotly.js';
import { ModeBarDefaultButtons } from 'plotly.js';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
// @ts-ignore: no d.ts file
import Datepicker from 'vuejs-datepicker';
// @ts-ignore: no d.ts file
import { en, fr } from 'vuejs-datepicker/dist/locale';
// @ts-ignore: no d.ts file
import logoImage from '@/assets/img/logo_bleu.png';
// @ts-ignore: no d.ts file
import logoImageWhite from '@/assets/img/logo-blanc-transparent.png';
const logger = new Logger('Timelapse');

// Définir l'interface
interface BoundingBoxImage {
  url: string;
  label: string;
  confidence: string;
  key: string;
}

interface SafetyHighlight {
  date: Date;
  type: 'NO_SAFETY_SPIKE' | 'FIRE' | 'COACTIVITY' | 'CAR';
  score: number;
  metrics: {
    no_safety: number;
    coactivity: number;
    fire: number;
    car: number;
  };
  photoIds: string[];
}

interface SecurityKPIs {
  avgNoSafety: number;
  avgCoactivity: number;
  totalFire: number;
  totalCar: number;
}

interface SafetyAnalysisMeta {
  safety_score: number;
  housekeeping_score: number;
  progress_phase: string;
  weather: string;
  lighting: string;
  safety_score_auto?: number;
  housekeeping_score_auto?: number;
}

interface SafetyWorkers {
  total_workers: number;
  with_full_ppe: number;
  with_partial_ppe: number;
  without_ppe: number;
}

interface SafetyPpeNonCompliance {
  category: string; // ex: "head", "body"…
  description: string;
  severity: number; // 1–3
}

interface SafetyHazardPosition {
  x_min: number;
  y_min: number;
  x_max: number;
  y_max: number;
}

interface SafetyHazard {
  type: string;
  severity: number;
  certainty: number;
  approx_position?: SafetyHazardPosition;
  description: string;
}

interface SafetySiteOrganization {
  access_paths_clear: boolean;
  material_storage_ok: boolean;
  waste_management_ok: boolean;
  comment?: string;
}

interface SafetyProgress {
  visible_storeys_built?: number;
  scaffolding_present?: boolean;
  facade_closure_estimated_percent?: number;
}

interface SafetyAnalysis {
  meta: SafetyAnalysisMeta;
  workers: SafetyWorkers;
  ppe_non_compliance: SafetyPpeNonCompliance[];
  hazards: SafetyHazard[];
  site_organization: SafetySiteOrganization;
  progress: SafetyProgress;
}

interface ManualAnnoBox {
  id: string;
  label: string;
  xMin: number;
  yMin: number;
  xMax: number;
  yMax: number;
}

interface ManualAnnoPersistedBox {
  id: string;
  label: string;
  xMin: number;
  yMin: number;
  xMax: number;
  yMax: number;
  createdAt: number;
  createdBy?: string;
}

interface ManualSegPolygon {
  id: string;
  label: string;
  points: { x: number; y: number }[]; // coords image (pixels)
}

interface ManualSegPersistedPolygon {
  id: string;
  label: string;
  pointsNorm: { x: number; y: number }[]; // coords normalisées [0..1]
  createdAt: number;
  createdBy?: string;
}

declare module 'jspdf' {
  interface jsPDF {
    getNumberOfPages(): number;
    putTotalPages(totalPagesExp: string): void;
  }
}

@Component({
  components: {
    Gallery,
    vTeleport,
    Datepicker,
  },
})
export default class IA extends Vue {
  @Prop(String) private id!: string;
  @Prop({ required: true, default: () => [] }) readonly dataImagesKey!: { data: Photo }[];

  @State('projects', { namespace: 'projects' }) private projects!: Project[];
  @State('premium', { namespace: 'profile' }) readonly isPremium!: boolean;
  @Getter('projectWithId', { namespace: 'projects' }) private projectWithId!: (id: string) => Project;

  @State('premium', { namespace: 'project' }) readonly ownerPremium!: boolean;
  @State('user', { namespace: 'profile' }) private user!: User;
  @Action('setProject', { namespace: 'project' }) private setProject!: (project: Project) => Promise<void>;
  @Action('loadTimelapse', { namespace: 'project' }) private loadTimelapse!: () => Promise<void>;
  @Action('findAllFor', { namespace: 'photo' }) private findPhotoAllForProject!: (payload: {
    projectId: string;
    cameraId: string;
  }) => Promise<Photo[]>;
  @State('photos', { namespace: 'photo' }) private readonly photosStore?: Photo[];
  @State('locale', { namespace: 'profile' }) private locale!: string;

  @State('socket') private socketMessage!: Socket;
  @Action('connectSocket') private connectSocket!: () => Promise<void>;
  @Action('disconnectSocket') private disconnectSocket!: () => Promise<void>;
  @Mutation('SOCKET_ONMESSAGE') private resetSocketMessage!: (object: string) => void;

  private loading = true;
  private isProjectLoading = true;
  private project: Project | null = null;
  private guest = false;
  private leftPanelVisible = true;
  private galleryVisible = true;
  private newPhotoAvailable = false;
  private galleryComparaison: string | null = null;
  private showChart = true;
  public hoverInfoPosition = { x: 0, y: 0 };
  private originalData: any[] = [];
  private currentXRange: [number, number] | null = null;
  private isChartInitialized = false;
  private boundingBoxImages: BoundingBoxImage[] = [];
  private weeklySafetyHighlights: SafetyHighlight[] = [];
  private weeklyClickedDate: Date | null = null;
  private lastActivityScore: number | null = null;
  private leftActivityScore: number | null = null;
  private lastPersonScore: number | null = null;
  private leftPersonScore: number | null = null;
  private lastNosafetyScore: number | null = null;
  private leftNosafetyScore: number | null = null;
  private lastDensityScore: number | null = null;
  private leftDensityScore: number | null = null;
  private lastHelmetScore: number | null = null;
  private leftHelmetScore: number | null = null;
  private lastFireScore: number | null = null;
  private leftFireScore: number | null = null;
  private lastCarScore: number | null = null;
  private leftCarScore: number | null = null;
  private lastCoactivityScore: number | null = null;
  private leftCoactivityScore: number | null = null;
  private startDate: string | null = null;
  private endDate: string | null = null;
  private firstPhotoDate: Date | null = null;
  private lastPhotoDate: Date | null = null;
  private updatingFromChart = false;
  private chartReady = false;
  private chartInitialized = false;
  private selectedRange: string | null = null;
  private selectedButton: number | null = null;
  private updatingFromDateRange = false;
  private timelapseRending = false;
  private loadingTimelapse = false;
  private selectedPhotos: Photo[] = [];
  private falseDetections: BoundingBoxImage[] = [];
  private logoUrl: string | null = null;
  private showLogoActions = false;
  private manualSegIgnoreNextMouseDown = false;
  private preloadedImage: HTMLImageElement | null = null;

  private polygonPoints: { x: number; y: number }[] = [];
  private polygonDrawing = false;
  private polygonCanvas: HTMLCanvasElement | null = null;
  private polygonCtx: CanvasRenderingContext2D | null = null;
  private originalPolygonPoints: { x: number; y: number }[] = [];
  private hasSavedPolygon = false;

  private backgroundImage: HTMLImageElement | null = null;
  private bgX = 0;
  private bgY = 0;
  private bgScale = 1;

  private photoIdsByDay: Record<string, string[]> = {};
  private chartUpdateTimeout: number | null = null;

  private safetyPanelOpen = false;
  private safetyPanelExpanded = false;

  private modeSelected = 'Détection';
  private modeOptions: { text: string; value: string }[] = [
    { text: 'Détection', value: 'Détection' },
    { text: 'Sécurité', value: 'Sécurité' },
  ];

  private toggleSafetyPanel() {
    this.safetyPanelOpen = !this.safetyPanelOpen;
  }

  private annotationPhoto: Photo | null = null;
  private annotationPhotoUrl: string | null = null;

  private manualAnnoCanvas: HTMLCanvasElement | null = null;
  private manualAnnoCtx: CanvasRenderingContext2D | null = null;
  private manualAnnoBgImage: HTMLImageElement | null = null;

  private manualAnnoScale = 1;
  private manualAnnoX = 0;
  private manualAnnoY = 0;

  private manualAnnoBoxes: ManualAnnoBox[] = [];
  private manualAnnoIsDrawing = false;
  private manualAnnoStart: { x: number; y: number } | null = null;
  private manualAnnoPreviewBox: ManualAnnoBox | null = null;
  private manualAnnoSelectedBoxId: string | null = null;

  private manualAnnoCurrentLabel = 'Person';
  private manualAnnoLabels: string[] = [
    'benne',
    'camion',
    'car',
    'chariot',
    'compacteuse',
    'crane',
    'foreuse',
    'goutte',
    'gruemobile',
    'helmet',
    'ladder',
    'nacelle',
    'pelle',
    'Person',
    'toupie',
    'vest',
  ];

  private manualAnnoNewLabel = '';
  private manualAnnoDataset: string = (process.env.VUE_APP_ROBOFLOW_DATASET as string) || '';
  private manualAnnoUploadStatus = '';

  // handlers pour add/remove listeners proprement
  private onManualAnnoMouseDown = (e: MouseEvent) => this.handleManualAnnoMouseDown(e);
  private onManualAnnoMouseMove = (e: MouseEvent) => this.handleManualAnnoMouseMove(e);
  private onManualAnnoMouseUp = (e: MouseEvent) => this.handleManualAnnoMouseUp(e);
  private onManualAnnoKeyDown = (e: KeyboardEvent) => this.handleManualAnnoKeyDown(e);
  private onManualAnnoContextMenu = (e: MouseEvent) => {
    e.preventDefault();
    if (!this.isDetectionMode(this.modeSelected)) {
      this.completeManualSegPolygon();
    }
  };

  // === Zoom/Pan view state (annotation canvas) ===
  private manualAnnoBaseScale = 1; // scale "fit to canvas"
  private manualAnnoMinScale = 0.2; // clamp min
  private manualAnnoMaxScale = 10; // clamp max

  private manualAnnoIsPanning = false;
  private manualAnnoPanStart: { xCanvas: number; yCanvas: number; originX: number; originY: number } | null = null;

  private manualAnnoSpaceDown = false;

  // handlers propres (pour add/remove listeners)
  private onManualAnnoWheel = (e: WheelEvent) => this.handleManualAnnoWheel(e);
  private onManualAnnoKeyUp = (e: KeyboardEvent) => this.handleManualAnnoKeyUp(e);
  private onManualAnnoDblClick = (e: MouseEvent) => this.resetManualAnnoView(); // optionnel

  private manualAnnoCrosshairCanvas: HTMLCanvasElement | null = null;
  private manualAnnoCrosshairCtx: CanvasRenderingContext2D | null = null;
  private manualAnnoMousePosCanvas: { x: number; y: number } | null = null;

  private onManualAnnoMouseLeave = () => {
    this.manualAnnoMousePosCanvas = null;
    this.renderManualAnnoCrosshair();
  };

  private manualAnnoLabelColorCache: Record<string, string> = {};

  private manualAnnoLastPhotoId: string | null = null;
  private manualAnnoImportedFromIA = false;
  private manualAnnoConstraintBox: ManualAnnoBox | null = null;

  private manualAnnoMouseDown = false;
  private manualAnnoDown: { xCanvas: number; yCanvas: number; xImg: number; yImg: number } | null = null;

  private manualAnnoPendingHitId: string | null = null;

  // Seuil (en pixels canvas) avant de considérer que c'est un drag => dessin
  private manualAnnoDragThresholdPx = 4;

  private isDetectionMode(mode: string): boolean {
    // Tu as déjà normalizeLabel() dans ta classe : "Détection" -> "detection"
    return this.normalizeLabel(mode) === 'detection';
  }

  private manualSegPolygons: ManualSegPolygon[] = [];
  private manualSegIsDrawing = false;
  private manualSegCurrentPoints: { x: number; y: number }[] = [];
  private manualSegSelectedPolyId: string | null = null;
  private manualSegCurrentLabel = 'no_safety';

  // labels segmentation sécurité (adapte à ton dataset)
  private manualSegLabels: string[] = [
    'excavation',
    'gc',
    'heras',
    'filet',
    'rubalise',
    'no_safety',
    'coactivity',
    'fire',
    'car',
  ];

  private manualSegCloseThresholdPx = 10;

  private onAnnoMouseDownHandler = (e: MouseEvent) => this.onAnnoMouseDown(e);
  private onAnnoMouseMoveHandler = (e: MouseEvent) => this.onAnnoMouseMove(e);
  private onAnnoMouseUpHandler = (e: MouseEvent) => this.onAnnoMouseUp(e);
  private onAnnoContextMenuHandler = (e: MouseEvent) => this.onAnnoContextMenu(e);
  private onAnnoDblClickHandler = (e: MouseEvent) => this.onAnnoDblClick(e);

  get manualSegLabelOptions() {
    return this.manualSegLabels.map((l) => ({ text: l, value: l }));
  }

  scoreColorClass(score?: number) {
    if (score == null) return '';
    if (score >= 80) return 'score-good';
    if (score >= 60) return 'score-medium';
    return 'score-bad';
  }

  get iaDetections(): DetectionBox[] {
    const p = this.currentPhoto as Photo | null | undefined;

    const dets: DetectionBox[] = p?.detections ?? [];

    return dets
      .filter((d: DetectionBox) => d.source === 'sagemaker_objects')
      .filter((d: DetectionBox) => (d.score ?? 0) >= 60);
  }

  get manualAnnoLabelOptions() {
    return this.manualAnnoLabels.map((l) => ({ text: l, value: l }));
  }

  get annotationPhotoMeta(): string | null {
    const p = this.annotationPhoto;
    if (!p) return null;
    const locale = (this as any).$i18n?.locale || 'fr';
    const d = new Date(p.createdAt);
    return `${d.toLocaleString(locale)} · ${p.id}`;
  }

  get hazardCounts() {
    const analysis = this.currentSafetyAnalysis;
    const counts = { s1: 0, s2: 0, s3: 0 };
    if (!analysis || !analysis.hazards) return counts;

    analysis.hazards.forEach((h) => {
      if (h.severity === 1) counts.s1++;
      else if (h.severity === 2) counts.s2++;
      else if (h.severity === 3) counts.s3++;
    });

    return counts;
  }

  get epiCompliance() {
    const analysis = this.currentSafetyAnalysis;
    if (!analysis || !analysis.workers || !analysis.workers.total_workers) {
      return { ratio: null, level: 'neutral' };
    }
    const total = analysis.workers.total_workers;
    const full = analysis.workers.with_full_ppe || 0;
    const ratio = full / total;

    let level: 'good' | 'medium' | 'bad' | 'neutral' = 'bad';
    if (ratio >= 0.8) level = 'good';
    else if (ratio >= 0.6) level = 'medium';

    return { ratio, level };
  }

  get ppeComplianceRate(): number | null {
    const analysis = this.currentSafetyAnalysis;
    if (!analysis) return null;

    const total = analysis.workers.total_workers || 0;
    if (!total) return null;

    const withFull = analysis.workers.with_full_ppe || 0;
    const withPartial = analysis.workers.with_partial_ppe || 0;

    // pondération simple : full = 1, partiel = 0.5
    const score = (withFull + 0.5 * withPartial) / total;
    return score * 100;
  }

  get ppeStatusLabel(): string {
    const rate = this.ppeComplianceRate;
    if (rate === null) return 'EPI : N/A';
    if (rate >= 90) return 'EPI globalement conformes';
    if (rate >= 70) return 'EPI à surveiller';
    return 'EPI à corriger';
  }

  get ppeStatusClass(): string {
    const rate = this.ppeComplianceRate;
    if (rate === null) return 'epi-unknown';
    if (rate >= 90) return 'epi-good';
    if (rate >= 70) return 'epi-medium';
    return 'epi-bad';
  }

  get hazardCountS1(): number {
    const analysis = this.currentSafetyAnalysis;
    if (!analysis) return 0;
    return analysis.hazards.filter((h) => h.severity === 1).length;
  }

  get hazardCountS2(): number {
    const analysis = this.currentSafetyAnalysis;
    if (!analysis) return 0;
    return analysis.hazards.filter((h) => h.severity === 2).length;
  }

  get hazardCountS3(): number {
    const analysis = this.currentSafetyAnalysis;
    if (!analysis) return 0;
    return analysis.hazards.filter((h) => h.severity === 3).length;
  }

  get variation(): number {
    if (this.lastActivityScore !== null && this.leftActivityScore !== null && this.leftActivityScore !== 0) {
      return ((this.lastActivityScore - this.leftActivityScore) / this.leftActivityScore) * 100;
    }
    return 0;
  }

  get personVariation(): number {
    if (this.lastPersonScore !== null && this.leftPersonScore !== null && this.leftPersonScore !== 0) {
      return ((this.lastPersonScore - this.leftPersonScore) / this.leftPersonScore) * 100;
    }
    return 0;
  }

  get nosafetyVariation(): number {
    if (this.lastNosafetyScore !== null && this.leftNosafetyScore !== null && this.leftNosafetyScore !== 0) {
      return ((this.lastNosafetyScore - this.leftNosafetyScore) / this.leftNosafetyScore) * 100;
    }
    return 0;
  }

  get fireVariation(): number {
    if (this.lastFireScore !== null && this.leftFireScore !== null && this.leftFireScore !== 0) {
      return ((this.lastFireScore - this.leftFireScore) / this.leftFireScore) * 100;
    }
    return 0;
  }

  get carVariation(): number {
    if (this.lastCarScore !== null && this.leftCarScore !== null && this.leftCarScore !== 0) {
      return ((this.lastCarScore - this.leftCarScore) / this.leftCarScore) * 100;
    }
    return 0;
  }

  get coactivityVariation(): number {
    if (this.lastCoactivityScore !== null && this.leftCoactivityScore !== null && this.leftCoactivityScore !== 0) {
      return ((this.lastCoactivityScore - this.leftCoactivityScore) / this.leftCoactivityScore) * 100;
    }
    return 0;
  }

  get densityVariation(): number {
    if (this.lastDensityScore !== null && this.leftDensityScore !== null && this.leftDensityScore !== 0) {
      return ((this.lastDensityScore - this.leftDensityScore) / this.leftDensityScore) * 100;
    }
    return 0;
  }

  get helmetVariation(): number {
    if (this.lastHelmetScore !== null && this.leftHelmetScore !== null && this.leftHelmetScore !== 0) {
      return ((this.lastHelmetScore - this.leftHelmetScore) / this.leftHelmetScore) * 100;
    }
    return 0;
  }

  get epiVariation(): number {
    if (this.lastHelmetScore !== null && this.leftHelmetScore !== null && this.leftHelmetScore !== 0) {
      return ((this.lastHelmetScore - this.leftHelmetScore) / this.leftHelmetScore) * 100;
    }
    return 0;
  }

  public get breadcrumbs(): unknown[] {
    const items = [
      {
        text: this.$tc('global.project', 2),
        to: '/',
      },
    ];
    if (this.project !== null) {
      items.push({
        text: this.project.name,
        to: '/project/' + this.project.id,
      });
    }
    items.push({
      text: this.$tc('global.timelapse'),
      to: '#',
    });
    return items;
  }

  public get datepickerLocal(): unknown {
    return this.locale === 'en' ? en : fr;
  }

  private get roboflowApiKey(): string {
    return (process.env.VUE_APP_ROBOFLOW_API_KEY as string) || '';
  }

  public getRotation(): string {
    return this.camera && this.camera.rotate ? `rotate(${this.camera.rotate}deg)` : '';
  }

  resizing = false;

  private mapAiLabelToUiLabel(raw: string): string {
    const k = this.normalizeLabel(raw);

    // mapping IA/dataset -> UI FR (adapte si besoin)
    const map: Record<string, string> = {
      person: 'Personne',
      Person: 'Personne',
      helmet: 'Casque',
      vest: 'Gilet',
      camion: 'Camion',
      truck: 'Camion',
      crane: 'Grue à tour',
      gruemobile: 'Grue mobile',
      pelle: 'Pelle',
      nacelle: 'Nacelle',
      toupie: 'Toupie',
      benne: 'Benne',
      foreuse: 'Foreuse',
      goutte: 'Goutte',
      chariot: 'Chariot',
      car: 'Voiture',
      ladder: 'Ladder', // ou "Échelle" si tu veux

      // sécurité (si tu as aussi ces labels en IA)
      no_safety: 'Non sécurisé',
      fire: 'Feu',
      smoke: 'Fumée',
      coactivity: 'Coactivité',
    };

    // priorité au mapping connu
    if (map[k]) return map[k];

    // fallback: label brut "propre"
    return (raw || '').trim() || 'Objet';
  }

  private readonly ROBOFLOW_SEG_CLASS_ID: Record<string, number> = {
    excavation: 0,
    gc: 1,
    heras: 2,
    filet: 3,
    rubalise: 4,
    no_safety: 5,
    coactivity: 6,
    fire: 7,
    car: 8,
  };

  private buildRoboflowSegLabelmap(): Record<string, string> {
    return {
      '0': 'excavation',
      '1': 'gc',
      '2': 'heras',
      '3': 'filet',
      '4': 'rubalise',
      '5': 'no_safety',
      '6': 'coactivity',
      '7': 'fire',
      '8': 'car',
    };
  }

  private manualSegLastDownKey: string | null = null;
  private manualSegLastDownAt = 0;

  /**
   * Ignore le "2e passage" d'un même clic (quand l'event est déclenché 2 fois)
   * Exemple fréquent : @mousedown dans le template + addEventListener('mousedown', ...)
   */
  private shouldIgnoreDuplicateSegMouseDown(e: MouseEvent, xCanvas: number, yCanvas: number): boolean {
    const t = typeof e.timeStamp === 'number' ? e.timeStamp : performance.now();
    const key = `${e.button}|${Math.round(xCanvas)}|${Math.round(yCanvas)}`;

    // Fenêtre très courte : double déclenchement quasi immédiat
    if (this.manualSegLastDownKey === key && t - this.manualSegLastDownAt < 12) {
      return true;
    }

    this.manualSegLastDownKey = key;
    this.manualSegLastDownAt = t;
    return false;
  }

  // --- Comparaison points (évite points doublons) ---
  private samePoint(a: { x: number; y: number }, b: { x: number; y: number }, eps = 0.5): boolean {
    return Math.abs(a.x - b.x) <= eps && Math.abs(a.y - b.y) <= eps;
  }

  private dedupeSegPoints(points: Array<{ x: number; y: number }>): Array<{ x: number; y: number }> {
    if (!points || points.length === 0) return [];

    const out: Array<{ x: number; y: number }> = [];
    for (const p of points) {
      if (!out.length) {
        out.push(p);
        continue;
      }
      const last = out[out.length - 1];
      if (!this.samePoint(last, p, 0.5)) out.push(p);
    }

    // Si le dernier point == premier (cas où quelqu’un a ajouté le point de fermeture),
    // on le retire : on stocke un polygone "ouvert" (la fermeture est implicite).
    if (out.length >= 3 && this.samePoint(out[0], out[out.length - 1], 0.5)) {
      out.pop();
    }

    return out;
  }

  private isNearFirstSegPoint(pImg: { x: number; y: number }): boolean {
    if (!this.manualSegCurrentPoints || this.manualSegCurrentPoints.length === 0) return false;

    const first = this.manualSegCurrentPoints[0];

    // Seuil en pixels CANVAS, converti en pixels IMAGE (pour être cohérent avec zoom)
    const scale = (this as any).manualAnnoScale ?? 1;
    const thresholdImg = this.manualSegCloseThresholdPx / Math.max(scale, 0.0001);

    const dx = pImg.x - first.x;
    const dy = pImg.y - first.y;
    return Math.hypot(dx, dy) <= thresholdImg;
  }

  // YOLOv8 Seg: class x1 y1 x2 y2 ... (coordonnées normalisées)
  private buildYoloV8SegTxt(params: { width: number; height: number; polygons: ManualSegPolygon[] }): string {
    const { width, height, polygons } = params;
    const lines: string[] = [];

    for (const p of polygons) {
      if (!p.points || p.points.length < 3) continue;

      const key = (p.label || '').trim();
      const classId = this.ROBOFLOW_SEG_CLASS_ID[key];
      if (classId === undefined) {
        throw new Error(`Label segmentation non mappé: "${p.label}"`);
      }

      const coords: string[] = [];
      for (const pt of p.points) {
        const x = Math.max(0, Math.min(width, pt.x)) / width;
        const y = Math.max(0, Math.min(height, pt.y)) / height;
        coords.push(x.toFixed(6), y.toFixed(6));
      }

      lines.push(`${classId} ${coords.join(' ')}`);
    }

    return lines.join('\n');
  }

  private getDetectionsForAnnotationPhoto(): any[] {
    const p: any = this.annotationPhoto as any;

    const raw = p?.detections;
    const list = this.asDetectionList(raw);

    // Convertit {M:{...}} -> objet plat, et garde tel quel si déjà plat
    const dets = list
      .map((d: any) => this.ddbUnwrap(d?.M ? d : d)) // d peut être {M:{...}} ou déjà normal
      .filter(Boolean);

    return dets
      .filter((d: any) => String(d?.source ?? '').toLowerCase() === 'sagemaker_objects')
      .filter((d: any) => {
        const sRaw = d?.score ?? d?.confidence ?? 0;
        const s = Number(sRaw);
        const score01 = s > 1 ? s / 100 : s; // 82 -> 0.82 ; 0.82 -> 0.82
        return score01 >= 0.6;
      });
  }

  private manualSegCloseHover = false;

  // Taille “écran” (en pixels canvas) du carré fluo
  private readonly MANUAL_SEG_CLOSE_SQUARE_PX: number = 14;

  // Zone de clic/hover autour du 1er point (en pixels canvas)
  private readonly MANUAL_SEG_CLOSE_HIT_PX: number = 10;

  private isNearPoint(px: number, py: number, x: number, y: number, r: number): boolean {
    const dx = px - x;
    const dy = py - y;
    return dx * dx + dy * dy <= r * r;
  }

  /**
   * Dessine un carré fluo centré sur le point.
   * hover=true => un peu plus “fort” (optionnel)
   */
  private drawFluoCloseSquare(ctx: CanvasRenderingContext2D, x: number, y: number, hover: boolean): void {
    ctx.save();

    const size = hover ? this.MANUAL_SEG_CLOSE_SQUARE_PX * 1.15 : this.MANUAL_SEG_CLOSE_SQUARE_PX;

    ctx.shadowBlur = hover ? 18 : 12;
    ctx.shadowColor = 'rgba(0, 255, 140, 0.95)';
    ctx.lineWidth = hover ? 3 : 2;
    ctx.strokeStyle = 'rgba(0, 255, 140, 1)';
    ctx.fillStyle = 'rgba(0, 255, 140, 0.20)';

    const half = size / 2;
    ctx.beginPath();
    ctx.rect(x - half, y - half, size, size);
    ctx.fill();
    ctx.stroke();

    ctx.restore();
  }

  private extractBBoxFromDetection(
    det: any,
    iw: number,
    ih: number
  ): { xMin: number; yMin: number; xMax: number; yMax: number } | null {
    // Plusieurs formats fréquents :
    // 1) {x_min,y_min,x_max,y_max}
    // 2) {xmin,ymin,xmax,ymax}
    // 3) {bbox:{x_min,...}} ou {bbox:{left,top,right,bottom}}
    // 4) {bbox:[x,y,w,h]} ou [xMin,yMin,xMax,yMax]
    // 5) {box:{left,top,width,height}} etc.

    const pick = (obj: any, keys: string[]) => {
      for (const k of keys) if (obj && obj[k] !== undefined && obj[k] !== null) return obj[k];
      return undefined;
    };

    const src = det?.bbox ?? det?.box ?? det?.boundingBox ?? det;

    let xMin = pick(src, ['x_min', 'xmin', 'left', 'xMin', 'x1', 'xMinNorm', 'xminNorm', 'x_min_norm']);
    let yMin = pick(src, ['y_min', 'ymin', 'top', 'yMin', 'y1', 'yMinNorm', 'yminNorm', 'y_min_norm']);
    let xMax = pick(src, ['x_max', 'xmax', 'right', 'xMax', 'x2', 'xMaxNorm', 'xmaxNorm', 'x_max_norm']);
    let yMax = pick(src, ['y_max', 'ymax', 'bottom', 'yMax', 'y2', 'yMaxNorm', 'ymaxNorm', 'y_max_norm']);

    // Format width/height
    const w = pick(src, ['w', 'width']);
    const h = pick(src, ['h', 'height']);

    // Format array
    if (Array.isArray(src) && src.length >= 4) {
      const a0 = Number(src[0]),
        a1 = Number(src[1]),
        a2 = Number(src[2]),
        a3 = Number(src[3]);
      // Heuristique : si a2/a3 <= 1.5 et (a0/a1 <= 1.5) => probablement normalisé
      // mais ici on ne sait pas si [x,y,w,h] ou [x1,y1,x2,y2].
      // On teste : si a2 > a0 ET a3 > a1 -> probablement x2,y2
      if (a2 > a0 && a3 > a1) {
        xMin = a0;
        yMin = a1;
        xMax = a2;
        yMax = a3;
      } else {
        // sinon on suppose [x,y,w,h]
        xMin = a0;
        yMin = a1;
        xMax = a0 + a2;
        yMax = a1 + a3;
      }
    }

    // Si xMax/yMax absents mais width/height présents
    if (
      (xMax === undefined || yMax === undefined) &&
      xMin !== undefined &&
      yMin !== undefined &&
      w !== undefined &&
      h !== undefined
    ) {
      xMax = Number(xMin) + Number(w);
      yMax = Number(yMin) + Number(h);
    }

    if ([xMin, yMin, xMax, yMax].some((v) => v === undefined || v === null)) return null;

    let fxMin = Number(xMin),
      fyMin = Number(yMin),
      fxMax = Number(xMax),
      fyMax = Number(yMax);

    // Si bbox est normalisée [0..1], on convertit en pixels
    const maxVal = Math.max(fxMin, fyMin, fxMax, fyMax);
    const looksNormalized = maxVal <= 1.5; // tolérance
    if (looksNormalized) {
      fxMin *= iw;
      fxMax *= iw;
      fyMin *= ih;
      fyMax *= ih;
    }

    // Si la détection donne des dimensions source différentes, on scale (optionnel mais utile)
    const detW = Number(det?.image_width ?? det?.width ?? det?.img_width ?? 0);
    const detH = Number(det?.image_height ?? det?.height ?? det?.img_height ?? 0);
    if (detW > 0 && detH > 0 && (detW !== iw || detH !== ih) && !looksNormalized) {
      fxMin = (fxMin / detW) * iw;
      fxMax = (fxMax / detW) * iw;
      fyMin = (fyMin / detH) * ih;
      fyMax = (fyMax / detH) * ih;
    }

    // clamp + ordonner
    const xmin = Math.max(0, Math.min(iw, Math.min(fxMin, fxMax)));
    const xmax = Math.max(0, Math.min(iw, Math.max(fxMin, fxMax)));
    const ymin = Math.max(0, Math.min(ih, Math.min(fyMin, fyMax)));
    const ymax = Math.max(0, Math.min(ih, Math.max(fyMin, fyMax)));

    if (xmax - xmin < 2 || ymax - ymin < 2) return null;

    return { xMin: Math.round(xmin), yMin: Math.round(ymin), xMax: Math.round(xmax), yMax: Math.round(ymax) };
  }

  private async loadDetectionsForAnnotationPhoto(): Promise<void> {
    if (!this.annotationPhoto?.id) return;

    // Si déjà chargé → skip
    if (this.annotationPhoto.detections && this.annotationPhoto.detections.length > 0) {
      return;
    }

    try {
      const credentials = await Auth.currentCredentials();
      const dynamo = new AWS.DynamoDB.DocumentClient({
        region: 'eu-west-3',
        credentials,
      });

      const params = {
        TableName: 'erige-photos-prod', // ← à remplacer !
        Key: {
          id: this.annotationPhoto.id,
        },
        // Optionnel : ne charger QUE detections pour économiser bandwidth
        ProjectionExpression: 'detections',
      };

      const result = await dynamo.get(params).promise();

      if (result.Item?.detections) {
        const raw = result.Item.detections;
        const list = this.asDetectionList(raw);
        const unwrapped = list.map((d: any) => this.ddbUnwrap(d?.M || d)).filter(Boolean);

        // Injecte dans l'objet (réactif avec Vue.set ou $set)
        this.$set(this.annotationPhoto, 'detections', unwrapped);

        console.log('Detections chargées dynamiquement :', unwrapped.length);
      }
    } catch (err) {
      console.error('Erreur chargement detections Dynamo :', err);
    }
  }

  private importIADetectionsIntoManualBoxes(): void {
    if (!this.annotationPhoto || !this.manualAnnoBgImage) return;

    const photoId = this.annotationPhoto.id;
    console.log('Import IA detections for photo:', photoId);

    // si on est déjà sur cette photo et déjà importé, on ne réécrase pas
    if (this.manualAnnoLastPhotoId === photoId && this.manualAnnoImportedFromIA) {
      return;
    }

    // si on change de photo : reset (à toi de décider si tu veux conserver)
    if (this.manualAnnoLastPhotoId !== photoId) {
      this.manualAnnoBoxes = [];
      this.manualAnnoSelectedBoxId = null;
    }

    const dets = this.getDetectionsForAnnotationPhoto();
    console.log('Detections found:', dets.length, dets);
    if (!dets.length) {
      this.manualAnnoLastPhotoId = photoId;
      this.manualAnnoImportedFromIA = true;
      return;
    }

    const iw = this.manualAnnoBgImage.width;
    const ih = this.manualAnnoBgImage.height;
    console.log('Image dimensions:', iw, 'x', ih);

    const newBoxes: ManualAnnoBox[] = [];
    dets.forEach((d: any, idx: number) => {
      const rawLabel = String(d?.label ?? d?.class ?? d?.name ?? 'Objet');
      const uiLabel = this.mapAiLabelToUiLabel(rawLabel);

      const bb = this.extractBBoxFromDetection(d, iw, ih);
      console.log('Extracted bbox for detection', idx, ':', bb);
      if (!bb) return;

      // injecte le label dans la liste si nécessaire (pour le b-select)
      if (!this.manualAnnoLabels.includes(uiLabel)) {
        this.manualAnnoLabels.push(uiLabel);
      }

      newBoxes.push({
        id: `ai-${photoId}-${idx}-${Date.now()}`,
        label: uiLabel,
        xMin: bb.xMin,
        yMin: bb.yMin,
        xMax: bb.xMax,
        yMax: bb.yMax,
      });
    });

    if (newBoxes.length) {
      this.manualAnnoBoxes = [...this.manualAnnoBoxes, ...newBoxes];
      // sélectionne la première box importée
      this.manualAnnoSelectedBoxId = newBoxes[0].id;
      this.manualAnnoCurrentLabel = newBoxes[0].label;
    }

    this.manualAnnoLastPhotoId = photoId;
    this.manualAnnoImportedFromIA = true;
    console.log('New boxes added:', newBoxes.length);
    console.log('Total manualAnnoBoxes after import:', this.manualAnnoBoxes.length);
  }

  private getManualAnnoCanvasCoords(clientX: number, clientY: number): { xCanvas: number; yCanvas: number } {
    if (!this.manualAnnoCanvas) return { xCanvas: 0, yCanvas: 0 };

    const rect = this.manualAnnoCanvas.getBoundingClientRect();
    const xCanvas = ((clientX - rect.left) / (rect.right - rect.left)) * this.manualAnnoCanvas.width;
    const yCanvas = ((clientY - rect.top) / (rect.bottom - rect.top)) * this.manualAnnoCanvas.height;
    return { xCanvas, yCanvas };
  }

  startResize(event: MouseEvent) {
    this.resizing = true;
    window.addEventListener('mousemove', this.performResize);
    window.addEventListener('mouseup', this.stopResize);
  }

  performResize(event: MouseEvent) {
    if (this.resizing) {
      const leftElement = this.$el.querySelector('.left') as HTMLElement;
      const galleryContainer = this.$el.querySelector('.gallery-container') as HTMLElement;
      if (leftElement && galleryContainer) {
        // Calcul de la nouvelle largeur en pourcentage de la fenêtre
        const newWidthPercentage = (event.clientX / window.innerWidth) * 100;

        // Limiter la largeur entre 30vw et 70vw pour .left
        const adjustedWidth = Math.min(Math.max(newWidthPercentage, 30), 100); // Ajustez les limites si nécessaire

        // Appliquer la nouvelle largeur à .left et ajuster .gallery-container
        leftElement.style.width = `${adjustedWidth}vw`;
        galleryContainer.style.width = `${100 - adjustedWidth}vw`;

        // Redimensionner le graphique si nécessaire
        const plotDiv = this.$refs.chart as HTMLElement;
        if (plotDiv) {
          Plotly.Plots.resize(plotDiv);
        }
      }
    }
  }

  stopResize() {
    if (this.resizing) {
      this.resizing = false;
      window.removeEventListener('mousemove', this.performResize);
      window.removeEventListener('mouseup', this.stopResize);
    }
  }

  public openAnnotationModal(): void {
    const photo = this.currentPhoto;
    if (!photo) {
      this.$bvToast?.toast('Aucune photo sélectionnée.', { title: 'Info', variant: 'warning', solid: true });
      return;
    }

    this.annotationPhoto = photo;

    // dataset par défaut depuis env si pas déjà saisi
    if (!this.manualAnnoDataset) {
      this.manualAnnoDataset = (process.env.VUE_APP_ROBOFLOW_DATASET as string) || '';
    }

    if (this.isDetectionMode(this.modeSelected)) {
      this.manualAnnoDataset = 'erige';
    } else {
      this.manualAnnoDataset = 'excavation-2';
    }

    (this.$refs.annotationModal as BModal).show();
  }

  public closeAnnotationModal(): void {
    (this.$refs.annotationModal as BModal).hide();
  }

  private onAnnoMouseDown(e: MouseEvent): void {
    // IMPORTANT : handleManualAnnoMouseDown sait déjà déléguer à la segmentation
    this.handleManualAnnoMouseDown(e);
  }

  private onAnnoMouseMove(e: MouseEvent): void {
    // IMPORTANT : handleManualAnnoMouseMove gère crosshair + pan, puis délègue à la seg si besoin
    this.handleManualAnnoMouseMove(e);
  }

  private onAnnoMouseUp(e: MouseEvent): void {
    // IMPORTANT : doit être appelé dans les DEUX modes pour arrêter le pan
    this.handleManualAnnoMouseUp(e);
  }

  // Double-clic : on ferme le polygone (seg uniquement)
  private onAnnoDblClick(e: MouseEvent): void {
    if (!this.isDetectionMode(this.modeSelected)) {
      this.handleManualSegDblClick(e);
    }
  }

  // Clic droit : on ferme le polygone (seg uniquement)
  private onAnnoContextMenu(e: MouseEvent): void {
    if (!this.isDetectionMode(this.modeSelected)) {
      this.handleManualSegContextMenu(e);
    }
  }

  private handleManualSegDblClick(_: MouseEvent): void {
    if (!this.manualSegIsDrawing) return;
    if (this.manualSegCurrentPoints.length < 3) return;
    this.completeManualSegPolygon();
  }

  private handleManualSegContextMenu(_: MouseEvent): void {
    if (!this.manualSegIsDrawing) return;
    if (this.manualSegCurrentPoints.length < 3) return;
    this.completeManualSegPolygon();
  }

  private deepUnwrap(v: any): any {
    if (v == null) return v;
    if (typeof v !== 'object') return v;

    // Primitives DynamoDB
    if (v.S !== undefined) return String(v.S);
    if (v.N !== undefined) {
      const n = parseFloat(v.N);
      return isNaN(n) ? 0 : n;
    }
    if (v.BOOL !== undefined) return Boolean(v.BOOL);

    // List
    if (v.L && Array.isArray(v.L)) {
      return v.L.map((x: any) => this.deepUnwrap(x));
    }

    // Map
    if (v.M) {
      const out: any = {};
      for (const k of Object.keys(v.M)) {
        out[k] = this.deepUnwrap(v.M[k]);
      }
      return out;
    }

    // Cas pathologiques : nesting inutile comme {"S": {"S": "val"}} ou {"M": {"label": ...}}
    const keys = Object.keys(v);
    if (keys.length === 1) {
      const innerKey = keys[0];
      const innerVal = v[innerKey];
      // Si c'est un wrapper inutile (ex: {"S": {"S": "val"}}), on descend
      if (innerKey === 'S' || innerKey === 'N' || innerKey === 'M' || innerKey === 'L') {
        return this.deepUnwrap(innerVal);
      }
    }

    // Fallback : retourne tel quel
    return v;
  }

  // Fonction pour extraire la liste même si ultra-nestée
  private extractDetectionList(raw: any): any[] {
    if (!raw) return [];

    let current: any = raw;

    // On descend tant qu'on trouve des wrappers M/L ou single-key objects
    let depth = 0;
    while (current && typeof current === 'object' && !Array.isArray(current) && depth < 20) {
      depth++;
      const keys = Object.keys(current);
      if (keys.length === 1) {
        const key = keys[0];
        if (key === 'L' || key === 'M') {
          current = current[key];
          continue;
        }
      }
      if (current.L && Array.isArray(current.L)) {
        current = current.L;
        break;
      }
      if (current.M) {
        current = current.M;
      } else {
        break;
      }
    }

    if (Array.isArray(current)) {
      return current;
    }
    return [];
  }

  private ddbUnwrap(v: any): any {
    if (v == null) return v;

    // Déjà un objet "normal"
    if (typeof v !== 'object') return v;

    // DynamoDB AttributeValue
    if (v.S !== undefined) return String(v.S);
    if (v.N !== undefined) return Number(v.N);
    if (v.BOOL !== undefined) return Boolean(v.BOOL);

    if (v.M !== undefined) {
      const out: any = {};
      for (const k of Object.keys(v.M)) out[k] = this.ddbUnwrap(v.M[k]);
      return out;
    }

    if (v.L !== undefined && Array.isArray(v.L)) {
      return v.L.map((x: any) => this.ddbUnwrap(x));
    }

    // fallback
    return v;
  }

  private asDetectionList(raw: any): any[] {
    if (!raw) return [];
    // cas 1: déjà array
    if (Array.isArray(raw)) return raw;
    // cas 2: Dynamo { L: [...] }
    if (raw.L && Array.isArray(raw.L)) return raw.L;
    return [];
  }

  public async onAnnotationModalShown(): Promise<void> {
    // ===== 0) Nettoyage défensif (évite doublons si la modale est ré-ouverte) =====
    window.removeEventListener('keydown', this.onManualAnnoKeyDown);
    window.removeEventListener('keyup', this.onManualAnnoKeyUp);
    window.removeEventListener('mouseup', this.onManualAnnoMouseUp);

    if (this.manualAnnoCanvas) {
      this.manualAnnoCanvas.removeEventListener('mousedown', this.onManualAnnoMouseDown);
      this.manualAnnoCanvas.removeEventListener('mousemove', this.onManualAnnoMouseMove);
      this.manualAnnoCanvas.removeEventListener('mouseleave', this.onManualAnnoMouseLeave);
      this.manualAnnoCanvas.removeEventListener('contextmenu', this.onManualAnnoContextMenu);
      this.manualAnnoCanvas.removeEventListener('wheel', this.onManualAnnoWheel as any);
      this.manualAnnoCanvas.removeEventListener('dblclick', this.onManualAnnoDblClick);
    }

    // ===== 1) Reset états =====
    this.manualAnnoUploadStatus = '';

    // bbox
    this.manualAnnoIsDrawing = false;
    this.manualAnnoStart = null;
    this.manualAnnoPreviewBox = null;
    this.manualAnnoSelectedBoxId = null;

    this.manualAnnoMouseDown = false;
    this.manualAnnoDown = null;
    this.manualAnnoPendingHitId = null;

    // zoom/pan
    this.manualAnnoSpaceDown = false;
    this.manualAnnoIsPanning = false;
    this.manualAnnoPanStart = null;

    // crosshair
    this.manualAnnoMousePosCanvas = null;

    // import flags
    this.manualAnnoImportedFromIA = false;
    this.manualAnnoLastPhotoId = null;

    // seg
    this.manualSegIsDrawing = false;
    this.manualSegCurrentPoints = [];
    this.manualSegCloseHover = false;
    this.manualSegSelectedPolyId = null;
    this.manualSegIgnoreNextMouseDown = false;

    // IMPORTANT : on repart à zéro pour éviter les doublons d’import
    this.manualAnnoBoxes = [];

    // ===== 2) Refs canvas =====
    this.manualAnnoCanvas = document.getElementById('annotation-canvas') as HTMLCanvasElement;
    this.manualAnnoCtx = this.manualAnnoCanvas?.getContext('2d') || null;

    this.manualAnnoCrosshairCanvas = document.getElementById('annotation-crosshair') as HTMLCanvasElement;
    this.manualAnnoCrosshairCtx = this.manualAnnoCrosshairCanvas?.getContext('2d') || null;

    if (!this.manualAnnoCanvas || !this.manualAnnoCtx) {
      this.$bvToast?.toast('Canvas indisponible.', { title: 'Erreur', variant: 'danger', solid: true });
      return;
    }
    if (!this.manualAnnoCrosshairCanvas || !this.manualAnnoCrosshairCtx) {
      this.$bvToast?.toast('Canvas crosshair indisponible.', { title: 'Erreur', variant: 'danger', solid: true });
      return;
    }

    // S’assure que l’overlay a la même résolution que le canvas principal
    if (
      this.manualAnnoCrosshairCanvas.width !== this.manualAnnoCanvas.width ||
      this.manualAnnoCrosshairCanvas.height !== this.manualAnnoCanvas.height
    ) {
      this.manualAnnoCrosshairCanvas.width = this.manualAnnoCanvas.width;
      this.manualAnnoCrosshairCanvas.height = this.manualAnnoCanvas.height;
    }
    // Important si ton overlay est au-dessus : ne pas bloquer la souris
    (this.manualAnnoCrosshairCanvas.style as any).pointerEvents = 'none';
    this.applyManualAnnoCursor();

    // ===== 3) DblClick hybride (Détection: reset view / Sécurité: fermer poly) =====
    this.onManualAnnoDblClick = (e: MouseEvent) => {
      if (this.isDetectionMode(this.modeSelected)) {
        this.resetManualAnnoView();
      } else {
        this.handleManualSegDblClick(e);
      }
    };

    // ===== 4) Listeners (les mêmes refs que remove dans onAnnotationModalHidden) =====
    this.manualAnnoCanvas.addEventListener('mousedown', this.onManualAnnoMouseDown);
    this.manualAnnoCanvas.addEventListener('mousemove', this.onManualAnnoMouseMove); // <-- crosshair + pan OK dans les 2 modes
    this.manualAnnoCanvas.addEventListener('mouseleave', this.onManualAnnoMouseLeave);
    this.manualAnnoCanvas.addEventListener('contextmenu', this.onManualAnnoContextMenu);
    this.manualAnnoCanvas.addEventListener('wheel', this.onManualAnnoWheel, { passive: false } as any);
    this.manualAnnoCanvas.addEventListener('dblclick', this.onManualAnnoDblClick);

    window.addEventListener('mouseup', this.onManualAnnoMouseUp);
    window.addEventListener('keydown', this.onManualAnnoKeyDown); // <-- SPACE pan + raccourcis seg/bbox
    window.addEventListener('keyup', this.onManualAnnoKeyUp);

    // Render crosshair initial (vide)
    this.renderManualAnnoCrosshair();

    // ===== 5) Chargement image =====
    await this.loadManualAnnoPhoto();

    // ===== 6) Chargement annotations selon mode =====
    if (this.isDetectionMode(this.modeSelected)) {
      // 1) manualDetections prioritaire
      await this.loadManualDetections();
      if ((this.annotationPhoto as any).manualDetections?.length > 0) {
        this.importManualDetectionsIntoBoxes();
      } else {
        // 2) fallback IA
        await this.loadDetectionsForAnnotationPhoto();
        this.importIADetectionsIntoManualBoxes();
      }
    } else {
      // Sécurité: charger les polygons sauvegardés
      this.manualSegPolygons = [];
      await this.loadManualSegmentations();
      this.importManualSegmentationsIntoPolygons();
    }

    // ===== 7) Render final =====
    this.renderManualAnno();
    this.renderManualAnnoCrosshair();
  }

  private async uploadManualAnnotations(): Promise<void> {
    if (this.isDetectionMode(this.modeSelected)) {
      return this.uploadManualAnnotationsToRoboflow();
    }
    return this.uploadManualSegmentationToRoboflow();
  }

  private buildPersistedManualSegPolygons(): ManualSegPersistedPolygon[] {
    if (!this.manualAnnoBgImage) return [];
    const iw = this.manualAnnoBgImage.width;
    const ih = this.manualAnnoBgImage.height;

    const now = Date.now();
    const createdBy = (this.user as any)?.id || (this.user as any)?.sub || (this.user as any)?.username || undefined;

    return (this.manualSegPolygons || [])
      .filter((p) => p.points && p.points.length >= 3)
      .map((p) => ({
        id: p.id,
        label: (p.label || '').trim(),
        pointsNorm: p.points.map((pt) => ({
          x: Math.max(0, Math.min(1, pt.x / iw)),
          y: Math.max(0, Math.min(1, pt.y / ih)),
        })),
        createdAt: now,
        createdBy,
      }));
  }

  private async uploadManualSegmentationToRoboflow(): Promise<void> {
    const apiKey = this.roboflowApiKey;
    const dataset = (this.manualAnnoDataset || '').trim(); // ex: excavation-2
    const split = ((process.env.VUE_APP_ROBOFLOW_SPLIT as string) || 'train').trim();

    if (!apiKey) {
      this.$bvToast?.toast('Clé API Roboflow manquante.', { title: 'Erreur', variant: 'danger', solid: true });
      return;
    }
    if (!dataset) {
      this.$bvToast?.toast('Dataset Roboflow manquant (slug).', { title: 'Erreur', variant: 'danger', solid: true });
      return;
    }
    if (!this.annotationPhoto || !this.manualAnnoBgImage) {
      this.$bvToast?.toast('Photo/Image non chargée.', { title: 'Erreur', variant: 'danger', solid: true });
      return;
    }
    if (this.manualSegPolygons.length === 0) {
      this.$bvToast?.toast('Aucun polygone à envoyer.', { title: 'Info', variant: 'warning', solid: true });
      return;
    }

    try {
      this.manualAnnoUploadStatus = 'Upload Roboflow (seg) en cours...';

      // 1) image blob
      const key = this.annotationPhoto.key || this.annotationPhoto.smallKey;
      let imageUrl: string;
      try {
        imageUrl = (await Storage.get(key, { level: 'public' } as any)) as string;
      } catch {
        const k2 = key.startsWith('public/') ? key.substring('public/'.length) : key;
        imageUrl = (await Storage.get(k2, { level: 'public' } as any)) as string;
      }

      const resp = await fetch(imageUrl);
      const imageBlob = await resp.blob();
      const ext = imageBlob.type === 'image/png' ? 'png' : imageBlob.type === 'image/webp' ? 'webp' : 'jpg';

      const iw = this.manualAnnoBgImage.width;
      const ih = this.manualAnnoBgImage.height;

      const fileBase = `manual-seg-${this.annotationPhoto.id}-${Date.now()}`;
      const imageName = `${fileBase}.${ext}`;
      const txtName = `${fileBase}.txt`;

      // 2) YOLOv8-seg txt
      const yoloSegTxt = this.buildYoloV8SegTxt({ width: iw, height: ih, polygons: this.manualSegPolygons });
      if (!yoloSegTxt || !yoloSegTxt.trim()) {
        throw new Error('YOLO seg txt vide.');
      }

      // 3) upload image
      const formData = new FormData();
      formData.append('file', imageBlob, imageName);

      const uploadRes = await axios.post(`https://api.roboflow.com/dataset/${dataset}/upload`, formData, {
        params: { api_key: apiKey, name: imageName, split },
      });

      const imageId = uploadRes?.data?.id;
      if (!uploadRes?.data?.success || !imageId) {
        throw new Error(`Upload image échoué : ${JSON.stringify(uploadRes?.data)}`);
      }

      // 4) annotate segmentation
      this.manualAnnoUploadStatus = 'Envoi annotations segmentation...';
      const labelmap = this.buildRoboflowSegLabelmap();

      await axios.post(
        `https://api.roboflow.com/dataset/${dataset}/annotate/${imageId}`,
        {
          annotationFile: yoloSegTxt + '\n',
          labelmap,
        },
        {
          params: { api_key: apiKey, name: txtName },
          headers: { 'Content-Type': 'application/json' },
        }
      );

      // 5) save DynamoDB: manualSegmentations + detectedLabels
      this.manualAnnoUploadStatus = 'Sauvegarde en base...';

      const persisted = this.buildPersistedManualSegPolygons();

      const labelCounts: Record<string, number> = {};
      this.manualSegPolygons.forEach((p) => {
        const k = (p.label || '').trim();
        labelCounts[k] = (labelCounts[k] || 0) + 1;
      });

      const credentials = await Auth.currentCredentials();
      const dynamo = new AWS.DynamoDB.DocumentClient({ region: 'eu-west-3', credentials });

      const exprValues: Record<string, any> = { ':segs': persisted, ':zero': 0 };
      const incExpr: string[] = [];

      Object.keys(labelCounts).forEach((k) => {
        const safeKey = k.replace(/[^a-zA-Z0-9_]/g, '');
        const ph = `:inc_${safeKey}`;
        incExpr.push(`detectedLabels.${k} = if_not_exists(detectedLabels.${k}, :zero) + ${ph}`);
        exprValues[ph] = labelCounts[k];
      });

      let updateExpr = 'SET manualSegmentations = :segs';
      if (incExpr.length) updateExpr += ', ' + incExpr.join(', ');

      await dynamo
        .update({
          TableName: this.getPhotosTableName(),
          Key: { id: this.annotationPhoto.id },
          UpdateExpression: updateExpr,
          ExpressionAttributeValues: exprValues,
        })
        .promise();

      // local update
      this.$set(this.annotationPhoto as any, 'manualSegmentations', persisted);

      this.manualAnnoUploadStatus = 'Tout terminé !';
      this.$bvToast?.toast('Segmentation envoyée à Roboflow et sauvegardée en base.', {
        title: 'Succès',
        variant: 'success',
        solid: true,
      });
    } catch (err: any) {
      console.error('Erreur upload segmentation:', err);
      this.manualAnnoUploadStatus = '';
      this.$bvToast?.toast(`Erreur : ${err?.message || 'voir console'}`, {
        title: 'Erreur',
        variant: 'danger',
        solid: true,
      });
    }

    this.closeAnnotationModal();
  }

  private async loadManualSegmentations(): Promise<void> {
    if (!this.annotationPhoto?.id) return;

    try {
      const credentials = await Auth.currentCredentials();
      const dynamo = new AWS.DynamoDB.DocumentClient({ region: 'eu-west-3', credentials });

      const result = await dynamo
        .get({
          TableName: this.getPhotosTableName(),
          Key: { id: this.annotationPhoto.id },
          ProjectionExpression: 'manualSegmentations',
        })
        .promise();

      this.$set(this.annotationPhoto as any, 'manualSegmentations', result.Item?.manualSegmentations || []);
    } catch (e) {
      console.error('Erreur load manualSegmentations:', e);
      this.$set(this.annotationPhoto as any, 'manualSegmentations', []);
    }
  }

  private importManualSegmentationsIntoPolygons(): void {
    if (!this.annotationPhoto || !this.manualAnnoBgImage) return;

    const segs = (this.annotationPhoto as any).manualSegmentations || [];
    if (!Array.isArray(segs) || segs.length === 0) return;

    const iw = this.manualAnnoBgImage.width;
    const ih = this.manualAnnoBgImage.height;

    const polys: ManualSegPolygon[] = [];
    segs.forEach((s: any) => {
      const pts = (s.pointsNorm || []).map((p: any) => ({
        x: Math.round(Number(p.x) * iw),
        y: Math.round(Number(p.y) * ih),
      }));
      if (pts.length < 3) return;

      polys.push({
        id: String(s.id || `seg-${Date.now()}-${Math.random()}`),
        label: String(s.label || 'no_safety'),
        points: pts,
      });
    });

    this.manualSegPolygons = polys;
  }

  public onAnnotationModalHidden(): void {
    // cleanup listeners
    if (this.manualAnnoCanvas) {
      this.manualAnnoCanvas.removeEventListener('mouseleave', this.onManualAnnoMouseLeave);

      // IMPORTANT : retirer EXACTEMENT ce qu’on a ajouté
      this.manualAnnoCanvas.removeEventListener('mousedown', this.onAnnoMouseDownHandler);
      this.manualAnnoCanvas.removeEventListener('mousemove', this.onAnnoMouseMoveHandler);
      this.manualAnnoCanvas.removeEventListener('contextmenu', this.onAnnoContextMenuHandler);
      this.manualAnnoCanvas.removeEventListener('dblclick', this.onAnnoDblClickHandler);
      this.manualAnnoCanvas.removeEventListener('wheel', this.onManualAnnoWheel as any);
    }

    window.removeEventListener('mouseup', this.onAnnoMouseUpHandler);
    window.removeEventListener('keydown', this.onManualAnnoKeyDown);
    window.removeEventListener('keyup', this.onManualAnnoKeyUp);

    // reset états
    this.manualAnnoSpaceDown = false;
    this.manualAnnoIsPanning = false;
    this.manualAnnoPanStart = null;

    this.manualSegIsDrawing = false;
    this.manualSegCurrentPoints = [];
    this.manualSegCloseHover = false;
    this.manualSegSelectedPolyId = null;
    this.manualSegIgnoreNextMouseDown = false;

    // cleanup refs
    this.manualAnnoCrosshairCanvas = null;
    this.manualAnnoCrosshairCtx = null;
    this.manualAnnoMousePosCanvas = null;

    this.manualAnnoCanvas = null;
    this.manualAnnoCtx = null;
    this.manualAnnoBgImage = null;
    this.annotationPhotoUrl = null;
    this.annotationPhoto = null;
  }

  private async loadManualAnnoPhoto(): Promise<void> {
    const photo = this.annotationPhoto;
    if (!photo) return;

    const key = photo.key || photo.smallKey;
    let url: string | null = null;

    try {
      url = (await Storage.get(key, { level: 'public' } as any)) as string;
    } catch (e) {
      // fallback si key contient "public/"
      const k2 = key.startsWith('public/') ? key.substring('public/'.length) : key;
      url = (await Storage.get(k2, { level: 'public' } as any)) as string;
    }

    this.annotationPhotoUrl = url;

    await new Promise<void>((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'Anonymous';
      img.onload = () => {
        this.manualAnnoBgImage = img;
        this.computeManualAnnoTransform();
        resolve();
      };
      img.onerror = () => reject(new Error('Impossible de charger l’image.'));
      img.src = url as string;
    });
  }

  private computeManualAnnoTransform(): void {
    if (!this.manualAnnoCanvas || !this.manualAnnoBgImage) return;

    const cw = this.manualAnnoCanvas.width;
    const ch = this.manualAnnoCanvas.height;
    const iw = this.manualAnnoBgImage.width;
    const ih = this.manualAnnoBgImage.height;

    const fitScale = Math.min(cw / iw, ch / ih);
    const x = (cw - iw * fitScale) / 2;
    const y = (ch - ih * fitScale) / 2;

    this.manualAnnoBaseScale = fitScale;

    // bornes de zoom (tu peux ajuster)
    this.manualAnnoMinScale = fitScale * 0.5;
    this.manualAnnoMaxScale = fitScale * 12;

    // initialise la vue
    this.manualAnnoScale = fitScale;
    this.manualAnnoX = x;
    this.manualAnnoY = y;
  }

  private handleManualAnnoWheel(e: WheelEvent): void {
    if (!this.manualAnnoCanvas || !this.manualAnnoBgImage) return;

    e.preventDefault(); // IMPORTANT sinon scroll page

    const { xCanvas, yCanvas } = this.getManualAnnoCanvasCoords(e.clientX, e.clientY);

    // facteur de zoom (trackpad/mouse)
    const zoomIntensity = 0.0015;
    const factor = Math.exp(-e.deltaY * zoomIntensity);

    const oldScale = this.manualAnnoScale;
    let newScale = oldScale * factor;

    // clamp
    newScale = Math.max(this.manualAnnoMinScale, Math.min(this.manualAnnoMaxScale, newScale));
    const appliedFactor = newScale / oldScale;

    // Zoom centré sur le curseur : on ajuste (X,Y) pour garder le même pixel image sous la souris
    this.manualAnnoX = xCanvas - (xCanvas - this.manualAnnoX) * appliedFactor;
    this.manualAnnoY = yCanvas - (yCanvas - this.manualAnnoY) * appliedFactor;
    this.manualAnnoScale = newScale;

    this.renderManualAnno();
  }

  private canvasToImage(xCanvas: number, yCanvas: number): { x: number; y: number } {
    if (!this.manualAnnoBgImage) return { x: 0, y: 0 };

    const x = (xCanvas - this.manualAnnoX) / this.manualAnnoScale;
    const y = (yCanvas - this.manualAnnoY) / this.manualAnnoScale;

    // clamp
    const cx = Math.max(0, Math.min(this.manualAnnoBgImage.width, x));
    const cy = Math.max(0, Math.min(this.manualAnnoBgImage.height, y));
    return { x: Math.round(cx), y: Math.round(cy) };
  }

  private imageToCanvas(xImg: number, yImg: number): { x: number; y: number } {
    return {
      x: this.manualAnnoX + xImg * this.manualAnnoScale,
      y: this.manualAnnoY + yImg * this.manualAnnoScale,
    };
  }

  private renderManualAnno(): void {
    if (!this.manualAnnoCtx || !this.manualAnnoCanvas) return;

    if (!this.isDetectionMode(this.modeSelected)) {
      this.renderManualSegmentation();
      return;
    }

    const ctx = this.manualAnnoCtx;
    ctx.clearRect(0, 0, this.manualAnnoCanvas.width, this.manualAnnoCanvas.height);

    // image
    if (this.manualAnnoBgImage) {
      ctx.drawImage(
        this.manualAnnoBgImage,
        this.manualAnnoX,
        this.manualAnnoY,
        this.manualAnnoBgImage.width * this.manualAnnoScale,
        this.manualAnnoBgImage.height * this.manualAnnoScale
      );
    }

    // boxes
    const drawBox = (b: ManualAnnoBox, isSelected: boolean, isPreview = false) => {
      const p1 = this.imageToCanvas(b.xMin, b.yMin);
      const p2 = this.imageToCanvas(b.xMax, b.yMax);

      const x = Math.min(p1.x, p2.x);
      const y = Math.min(p1.y, p2.y);
      const w = Math.abs(p2.x - p1.x);
      const h = Math.abs(p2.y - p1.y);

      const baseColor = this.getManualAnnoLabelColor(b.label);

      ctx.save();

      // léger remplissage translucide (lisibilité)
      ctx.globalAlpha = isPreview ? 0.06 : 0.15;
      ctx.fillStyle = baseColor;
      ctx.fillRect(x, y, w, h);
      ctx.globalAlpha = 1;

      // Preview en pointillé
      if (isPreview) {
        ctx.setLineDash([6, 4]);
      } else {
        ctx.setLineDash([]);
      }

      // Stroke
      if (isSelected) {
        // halo de sélection + couleur de classe
        ctx.lineWidth = 5;
        ctx.strokeStyle = 'rgba(0,229,255,0.95)';
        ctx.strokeRect(x, y, w, h);

        ctx.lineWidth = 2.5;
        ctx.strokeStyle = baseColor;
        ctx.strokeRect(x, y, w, h);
      } else {
        ctx.lineWidth = 2;
        ctx.strokeStyle = baseColor;
        ctx.strokeRect(x, y, w, h);
      }

      // Badge label (fond = couleur de classe)
      ctx.font = '14px Arial';
      const padX = 6;
      const badgeH = 18;
      const text = b.label || '';
      const tw = ctx.measureText(text).width;

      // évite badge négatif si box en haut
      const badgeY = Math.max(0, y - badgeH - 2);

      ctx.save();
      ctx.globalAlpha = 0.9;
      ctx.fillStyle = baseColor;
      ctx.fillRect(x, badgeY, tw + padX * 2, badgeH);
      ctx.restore();

      ctx.fillStyle = '#FFFFFF';
      ctx.fillText(text, x + padX, badgeY + 13);

      ctx.restore();
    };

    this.manualAnnoBoxes.forEach((b) => drawBox(b, b.id === this.manualAnnoSelectedBoxId, false));

    // preview box
    if (this.manualAnnoPreviewBox) {
      drawBox(this.manualAnnoPreviewBox, false, true);
    }
    this.renderManualAnnoCrosshair();
  }

  private polygonCentroid(pts: { x: number; y: number }[]): { x: number; y: number } {
    const n = pts.length || 1;
    const sx = pts.reduce((a, p) => a + p.x, 0);
    const sy = pts.reduce((a, p) => a + p.y, 0);
    return { x: sx / n, y: sy / n };
  }

  get manualSegPanelPoints(): Array<{ x: number; y: number }> {
    // pendant le tracé : on affiche les points en cours
    if (this.manualSegIsDrawing) return this.manualSegCurrentPoints || [];

    // sinon : points du polygone sélectionné
    if (this.manualSegSelectedPolyId) {
      const p = this.manualSegPolygons.find((x) => x.id === this.manualSegSelectedPolyId);
      return p?.points || [];
    }

    return [];
  }

  get manualSegPanelPointCount(): number {
    return this.manualSegPanelPoints.length;
  }

  private renderManualSegmentation(): void {
    if (!this.manualAnnoCtx || !this.manualAnnoCanvas) return;

    const ctx = this.manualAnnoCtx;
    ctx.clearRect(0, 0, this.manualAnnoCanvas.width, this.manualAnnoCanvas.height);

    // background image
    if (this.manualAnnoBgImage) {
      ctx.drawImage(
        this.manualAnnoBgImage,
        this.manualAnnoX,
        this.manualAnnoY,
        this.manualAnnoBgImage.width * this.manualAnnoScale,
        this.manualAnnoBgImage.height * this.manualAnnoScale
      );
    }

    const drawPoly = (poly: ManualSegPolygon, selected: boolean, preview = false) => {
      if (!poly.points || poly.points.length < 2) return;

      const color = this.getManualAnnoLabelColor(poly.label);
      const ptsCanvas = poly.points.map((p) => this.imageToCanvas(p.x, p.y));

      ctx.save();

      ctx.beginPath();
      ctx.moveTo(ptsCanvas[0].x, ptsCanvas[0].y);
      for (let i = 1; i < ptsCanvas.length; i++) ctx.lineTo(ptsCanvas[i].x, ptsCanvas[i].y);

      if (!preview && poly.points.length >= 3) ctx.closePath();

      // fill
      ctx.globalAlpha = preview ? 0.08 : 0.18;
      ctx.fillStyle = color;
      if (poly.points.length >= 3) ctx.fill();
      ctx.globalAlpha = 1;

      // stroke
      if (preview) ctx.setLineDash([6, 4]);
      else ctx.setLineDash([]);

      ctx.lineWidth = selected ? 3.5 : 2;
      ctx.strokeStyle = selected ? 'rgba(0,229,255,0.95)' : color;
      ctx.stroke();

      // badge label
      if (!preview && poly.points.length >= 3) {
        const cImg = this.polygonCentroid(poly.points);
        const c = this.imageToCanvas(cImg.x, cImg.y);

        ctx.font = '14px Arial';
        const padX = 6;
        const badgeH = 18;
        const text = poly.label || '';
        const tw = ctx.measureText(text).width;

        ctx.save();
        ctx.globalAlpha = 0.9;
        ctx.fillStyle = color;
        ctx.fillRect(c.x, c.y - badgeH, tw + padX * 2, badgeH);
        ctx.restore();

        ctx.fillStyle = '#FFFFFF';
        ctx.fillText(text, c.x + padX, c.y - 5);
      }

      ctx.restore();
    };

    // existing polys
    this.manualSegPolygons.forEach((p) => drawPoly(p, p.id === this.manualSegSelectedPolyId, false));

    // preview poly (points en cours)
    if (this.manualSegIsDrawing && this.manualSegCurrentPoints.length > 0) {
      drawPoly({ id: 'preview', label: this.manualSegCurrentLabel, points: this.manualSegCurrentPoints }, false, true);

      // indication fermeture (carré fluo) sur le 1er point
      const first = this.manualSegCurrentPoints[0];
      const p0 = this.imageToCanvas(first.x, first.y);

      if (this.manualSegCurrentPoints.length >= 3) {
        this.drawFluoCloseSquare(ctx, p0.x, p0.y, this.manualSegCloseHover);
      } else {
        // repère discret avant 3 points
        ctx.save();
        ctx.fillStyle = 'rgba(0, 255, 140, 0.55)';
        ctx.beginPath();
        ctx.arc(p0.x, p0.y, 3, 0, Math.PI * 2);
        ctx.fill();
        ctx.restore();
      }
    }
  }

  private handleManualAnnoMouseDown(e: MouseEvent): void {
    if (!this.manualAnnoCanvas) return;

    if (!this.isDetectionMode(this.modeSelected)) {
      this.handleManualSegMouseDown(e);
      return;
    }

    const { xCanvas, yCanvas } = this.getManualAnnoCanvasCoords(e.clientX, e.clientY);

    // PAN si : clic molette OU (clic gauche + espace)
    const isMiddleClick = e.button === 1;
    const isSpaceDrag = e.button === 0 && this.manualAnnoSpaceDown;

    if (isMiddleClick || isSpaceDrag) {
      e.preventDefault();
      this.manualAnnoIsPanning = true;
      this.manualAnnoPanStart = {
        xCanvas,
        yCanvas,
        originX: this.manualAnnoX,
        originY: this.manualAnnoY,
      };
      return;
    }

    // Seulement clic gauche pour dessiner/sélectionner
    if (e.button !== 0) return;

    this.manualAnnoMouseDown = true;

    const pImg = this.canvasToImage(xCanvas, yCanvas);
    this.manualAnnoDown = { xCanvas, yCanvas, xImg: pImg.x, yImg: pImg.y };

    // On "note" si on est dans une box, mais on ne sélectionne pas tout de suite :
    // - si l'utilisateur clique (sans bouger) => sélection au mouseup
    // - si l'utilisateur drag => dessin (même si on était dans une box)
    const hit = this.hitTestManualAnnoBox(xCanvas, yCanvas);
    this.manualAnnoPendingHitId = hit ? hit.id : null;

    // On ne démarre PAS le dessin ici. Le dessin démarre seulement si on dépasse le seuil de drag.
    this.manualAnnoIsDrawing = false;
    this.manualAnnoStart = null;
    this.manualAnnoPreviewBox = null;
  }

  private clampPointToBox(p: { x: number; y: number }, b: ManualAnnoBox): { x: number; y: number } {
    const xmin = Math.min(b.xMin, b.xMax);
    const xmax = Math.max(b.xMin, b.xMax);
    const ymin = Math.min(b.yMin, b.yMax);
    const ymax = Math.max(b.yMin, b.yMax);

    return {
      x: Math.max(xmin, Math.min(xmax, p.x)),
      y: Math.max(ymin, Math.min(ymax, p.y)),
    };
  }

  private handleManualAnnoMouseMove(e: MouseEvent): void {
    const { xCanvas, yCanvas } = this.getManualAnnoCanvasCoords(e.clientX, e.clientY);

    // crosshair
    this.manualAnnoMousePosCanvas = { x: xCanvas, y: yCanvas };
    this.renderManualAnnoCrosshair();

    // ✅ PAN doit fonctionner dans les DEUX modes (Détection + Sécurité)
    if (this.manualAnnoIsPanning && this.manualAnnoPanStart) {
      const dx = xCanvas - this.manualAnnoPanStart.xCanvas;
      const dy = yCanvas - this.manualAnnoPanStart.yCanvas;

      this.manualAnnoX = this.manualAnnoPanStart.originX + dx;
      this.manualAnnoY = this.manualAnnoPanStart.originY + dy;

      this.renderManualAnno();
      return;
    }

    // ensuite seulement, on branche selon le mode
    if (!this.isDetectionMode(this.modeSelected)) {
      this.handleManualSegMouseMove(e);
      return;
    }

    // --- CLICK vs DRAG ---
    if (this.manualAnnoMouseDown && !this.manualAnnoIsDrawing && this.manualAnnoDown) {
      const dx = xCanvas - this.manualAnnoDown.xCanvas;
      const dy = yCanvas - this.manualAnnoDown.yCanvas;
      const dist = Math.hypot(dx, dy);

      // Si on dépasse le seuil => on démarre un dessin (même si on était dans une box existante)
      if (dist >= this.manualAnnoDragThresholdPx) {
        this.manualAnnoIsDrawing = true;

        // start = coords image du point de down
        this.manualAnnoStart = { x: this.manualAnnoDown.xImg, y: this.manualAnnoDown.yImg };

        // on annule une éventuelle sélection pending
        this.manualAnnoPendingHitId = null;
        this.manualAnnoSelectedBoxId = null;

        this.manualAnnoPreviewBox = {
          id: 'preview',
          label: this.manualAnnoCurrentLabel,
          xMin: this.manualAnnoStart.x,
          yMin: this.manualAnnoStart.y,
          xMax: this.manualAnnoStart.x,
          yMax: this.manualAnnoStart.y,
        };
      }
    }

    // --- DESSIN EN COURS ---
    if (!this.manualAnnoIsDrawing || !this.manualAnnoStart || !this.manualAnnoPreviewBox) return;

    const p = this.canvasToImage(xCanvas, yCanvas);

    this.manualAnnoPreviewBox.xMin = Math.min(this.manualAnnoStart.x, p.x);
    this.manualAnnoPreviewBox.yMin = Math.min(this.manualAnnoStart.y, p.y);
    this.manualAnnoPreviewBox.xMax = Math.max(this.manualAnnoStart.x, p.x);
    this.manualAnnoPreviewBox.yMax = Math.max(this.manualAnnoStart.y, p.y);

    this.renderManualAnno();
  }

  private isPointInPolygon(pt: { x: number; y: number }, poly: { x: number; y: number }[]): boolean {
    let inside = false;
    for (let i = 0, j = poly.length - 1; i < poly.length; j = i++) {
      const xi = poly[i].x,
        yi = poly[i].y;
      const xj = poly[j].x,
        yj = poly[j].y;

      const intersect = yi > pt.y !== yj > pt.y && pt.x < ((xj - xi) * (pt.y - yi)) / (yj - yi + 1e-9) + xi;
      if (intersect) inside = !inside;
    }
    return inside;
  }

  private hitTestManualSegPolygon(xImg: number, yImg: number): ManualSegPolygon | null {
    for (let i = this.manualSegPolygons.length - 1; i >= 0; i--) {
      const p = this.manualSegPolygons[i];
      if (p.points.length >= 3 && this.isPointInPolygon({ x: xImg, y: yImg }, p.points)) return p;
    }
    return null;
  }

  private handleManualSegMouseDown(e: MouseEvent): void {
    if (!this.manualAnnoCanvas) return;

    const { xCanvas, yCanvas } = this.getManualAnnoCanvasCoords(e.clientX, e.clientY);

    // Anti double-binding
    if (this.shouldIgnoreDuplicateSegMouseDown(e, xCanvas, yCanvas)) return;

    // PAN (milieu, ou espace + gauche)
    const isMiddleClick = e.button === 1;
    const isSpaceDrag = e.button === 0 && (this as any).manualAnnoSpaceDown;
    if (isMiddleClick || isSpaceDrag) {
      e.preventDefault();
      (this as any).manualAnnoIsPanning = true;
      (this as any).manualAnnoPanStart = {
        xCanvas,
        yCanvas,
        originX: (this as any).manualAnnoX,
        originY: (this as any).manualAnnoY,
      };
      return;
    }

    // clic gauche uniquement pour poser des points
    if (e.button !== 0) return;

    const pImg = this.canvasToImage(xCanvas, yCanvas);

    // Pas en dessin => sélection ou démarrage
    if (!this.manualSegIsDrawing) {
      const hit = this.hitTestManualSegPolygon(pImg.x, pImg.y);
      if (hit) {
        this.manualSegSelectedPolyId = hit.id;
        this.manualSegCloseHover = false;
        this.renderManualAnno();
        return;
      }

      // démarrer un nouveau polygone (reset propre)
      this.manualSegSelectedPolyId = null;
      this.manualSegIsDrawing = true;
      this.manualSegCloseHover = false;
      this.manualSegCurrentPoints = [{ x: pImg.x, y: pImg.y }];

      this.renderManualAnno();
      return;
    }

    // Déjà en dessin : clic sur le 1er point => fermeture
    if (this.manualSegCurrentPoints.length >= 3 && this.isNearFirstSegPoint(pImg)) {
      this.completeManualSegPolygon();
      return;
    }

    // Ajout point (évite doublon consécutif)
    const last = this.manualSegCurrentPoints[this.manualSegCurrentPoints.length - 1];
    if (!last || !this.samePoint(last, pImg, 0.5)) {
      this.manualSegCurrentPoints.push({ x: pImg.x, y: pImg.y });
    }

    this.manualSegCloseHover = false;
    this.renderManualAnno();
  }

  private onAnnoKeyDown = (e: KeyboardEvent) => {
    if (this.isDetectionMode(this.modeSelected)) return;

    if (e.key === 'Enter') {
      if (this.manualSegIsDrawing && this.manualSegCurrentPoints.length >= 3) {
        e.preventDefault();
        this.completeManualSegPolygon();
      }
    }
  };

  private getManualAnnoMousePos(e: MouseEvent): { x: number; y: number } | null {
    if (!this.manualAnnoCanvas) return null;
    const { xCanvas, yCanvas } = this.getManualAnnoCanvasCoords(e.clientX, e.clientY);
    return { x: xCanvas, y: yCanvas };
  }

  private handleManualSegMouseMove(e: MouseEvent): void {
    if (!this.manualAnnoCanvas) return;

    const { xCanvas, yCanvas } = this.getManualAnnoCanvasCoords(e.clientX, e.clientY);
    const pImg = this.canvasToImage(xCanvas, yCanvas);

    // Hover fermeture uniquement si polygone en cours
    if (!this.manualSegIsDrawing) {
      if (this.manualSegCloseHover) {
        this.manualSegCloseHover = false;
        this.renderManualAnno();
      }
      return;
    }

    const canClose = this.manualSegCurrentPoints.length >= 3;
    const newHover = canClose ? this.isNearFirstSegPoint(pImg) : false;

    if (newHover !== this.manualSegCloseHover) {
      this.manualSegCloseHover = newHover;
      this.renderManualAnno();
    }
  }

  private getCurrentSegPoints(): Array<{ x: number; y: number }> {
    // 1) si tu as un polygone "draft" séparé
    // return this.manualSegDraftPoints;

    // 2) sinon si tu ajoutes les points directement dans le polygone sélectionné:
    const poly = this.manualSegPolygons.find((p) => p.id === this.manualSegSelectedPolyId);
    return poly ? poly.points : [];
  }

  private applyManualAnnoCursor(): void {
    if (!this.manualAnnoCanvas) return;

    // Option UX (recommandé) : quand SPACE est enfoncé, afficher "grab/grabbing" pour le pan
    // Si tu veux STRICTEMENT crosshair tout le temps, supprime ce bloc.
    if (this.manualAnnoSpaceDown) {
      this.manualAnnoCanvas.style.cursor = this.manualAnnoIsPanning ? 'grabbing' : 'grab';
      return;
    }

    // Détection + Segmentation : crosshair
    this.manualAnnoCanvas.style.cursor = 'crosshair';
  }

  private renderManualAnnoCrosshair(): void {
    if (!this.manualAnnoCrosshairCtx || !this.manualAnnoCrosshairCanvas) return;

    const ctx = this.manualAnnoCrosshairCtx;
    const c = this.manualAnnoCrosshairCanvas;

    ctx.clearRect(0, 0, c.width, c.height);

    const p = this.manualAnnoMousePosCanvas;
    if (!p) return;

    // Si tu veux que les lignes s’arrêtent aux bords de l’IMAGE (pas du canvas)
    if (this.manualAnnoBgImage) {
      const left = this.manualAnnoX;
      const top = this.manualAnnoY;
      const right = this.manualAnnoX + this.manualAnnoBgImage.width * this.manualAnnoScale;
      const bottom = this.manualAnnoY + this.manualAnnoBgImage.height * this.manualAnnoScale;

      // Hors image => on masque le crosshair
      if (p.x < left || p.x > right || p.y < top || p.y > bottom) return;

      ctx.save();
      ctx.lineWidth = 1;
      ctx.strokeStyle = 'rgba(255,255,255,0.85)';

      ctx.beginPath();
      // Horizontal: gauche -> droite (bords image)
      ctx.moveTo(left, p.y);
      ctx.lineTo(right, p.y);
      // Vertical: haut -> bas (bords image)
      ctx.moveTo(p.x, top);
      ctx.lineTo(p.x, bottom);
      ctx.stroke();

      // petit point central (optionnel, utile visuellement)
      ctx.fillStyle = 'rgba(0,0,0,0.35)';
      ctx.beginPath();
      ctx.arc(p.x, p.y, 3, 0, Math.PI * 2);
      ctx.fill();

      ctx.strokeStyle = 'rgba(0,229,255,0.95)';
      ctx.lineWidth = 1.5;
      ctx.beginPath();
      ctx.arc(p.x, p.y, 3, 0, Math.PI * 2);
      ctx.stroke();

      ctx.restore();
      return;
    }

    // Fallback: crosshair sur tout le canvas
    ctx.save();
    ctx.lineWidth = 1;
    ctx.strokeStyle = 'rgba(255,255,255,0.85)';
    ctx.beginPath();
    ctx.moveTo(0, p.y);
    ctx.lineTo(c.width, p.y);
    ctx.moveTo(p.x, 0);
    ctx.lineTo(p.x, c.height);
    ctx.stroke();
    ctx.restore();
  }

  private handleManualAnnoMouseUp(e: MouseEvent): void {
    // Fin de pan
    if (this.manualAnnoIsPanning) {
      this.manualAnnoIsPanning = false;
      this.manualAnnoPanStart = null;
      return;
    }

    // Important : on clôture l'état "mouse down"
    this.manualAnnoMouseDown = false;
    const pendingHit = this.manualAnnoPendingHitId;
    this.manualAnnoPendingHitId = null;
    this.manualAnnoDown = null;

    // Si on n'était pas en train de dessiner => clic simple : sélection (ou désélection)
    if (!this.manualAnnoIsDrawing) {
      if (pendingHit) {
        this.manualAnnoSelectedBoxId = pendingHit;
      } else {
        this.manualAnnoSelectedBoxId = null;
      }
      this.renderManualAnno();
      return;
    }

    // Fin de dessin
    this.manualAnnoIsDrawing = false;

    const box = this.manualAnnoPreviewBox;
    this.manualAnnoPreviewBox = null;
    this.manualAnnoStart = null;

    if (!box) {
      this.renderManualAnno();
      return;
    }

    const w = Math.abs(box.xMax - box.xMin);
    const h = Math.abs(box.yMax - box.yMin);

    // ignore trop petit
    if (w < 5 || h < 5) {
      this.renderManualAnno();
      return;
    }

    const id = `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    const finalBox: ManualAnnoBox = {
      id,
      label: this.manualAnnoCurrentLabel,
      xMin: box.xMin,
      yMin: box.yMin,
      xMax: box.xMax,
      yMax: box.yMax,
    };

    this.manualAnnoBoxes.push(finalBox);
    this.manualAnnoSelectedBoxId = id;
    this.renderManualAnno();
  }

  private handleManualAnnoKeyUp(e: KeyboardEvent): void {
    if (e.code === 'Space') {
      this.manualAnnoSpaceDown = false;
    }
  }

  private resetManualAnnoView(): void {
    this.manualAnnoIsDrawing = false;
    this.manualAnnoStart = null;
    this.manualAnnoPreviewBox = null;
    this.manualAnnoIsPanning = false;
    this.manualAnnoPanStart = null;

    this.computeManualAnnoTransform();
    this.renderManualAnno();
  }

  private hashStringToInt(str: string): number {
    // hash simple et déterministe
    let h = 0;
    for (let i = 0; i < str.length; i++) {
      h = (h << 5) - h + str.charCodeAt(i);
      h |= 0; // int32
    }
    return Math.abs(h);
  }

  private getManualAnnoLabelColor(label: string): string {
    const key = this.normalizeLabel(label || 'unknown') || 'unknown';

    const cached = this.manualAnnoLabelColorCache[key];
    if (cached) return cached;

    // HSL donne une palette quasi infinie et bien répartie
    const hue = this.hashStringToInt(key) % 360;
    const color = `hsl(${hue}, 85%, 55%)`;

    this.manualAnnoLabelColorCache[key] = color;
    return color;
  }

  private handleManualAnnoKeyDown(e: KeyboardEvent): void {
    // SPACE : activer le mode pan
    if (e.code === 'Space') {
      this.manualAnnoSpaceDown = true;
      e.preventDefault(); // évite le scroll page
      return;
    }

    // ===== Branche Segmentation (Sécurité) =====
    if (!this.isDetectionMode(this.modeSelected)) {
      if (e.key === 'Escape') {
        this.cancelManualSegPolygon();
        return;
      }
      if (e.key === 'Enter') {
        this.completeManualSegPolygon();
        return;
      }
      if (e.key === 'Delete' || e.key === 'Backspace') {
        if (this.manualSegSelectedPolyId) this.removeManualSegPolygon(this.manualSegSelectedPolyId);
        return;
      }
      if ((e.ctrlKey || e.metaKey) && (e.key === 'z' || e.key === 'Z')) {
        this.undoManualSegPointOrPolygon();
        e.preventDefault();
        return;
      }
      return; // on n'exécute pas la logique bbox
    }

    // ESC annule un dessin en cours
    if (e.key === 'Escape') {
      this.manualAnnoIsDrawing = false;
      this.manualAnnoStart = null;
      this.manualAnnoPreviewBox = null;
      this.manualAnnoConstraintBox = null; // NOUVEAU
      this.renderManualAnno();
      return;
    }

    // Suppr supprime box sélectionnée
    if (e.key === 'Delete' || e.key === 'Backspace') {
      if (this.manualAnnoSelectedBoxId) {
        this.removeManualAnnoBox(this.manualAnnoSelectedBoxId);
      }
      return;
    }

    // Ctrl+Z = undo
    if ((e.ctrlKey || e.metaKey) && (e.key === 'z' || e.key === 'Z')) {
      this.undoManualAnnoBox();
      e.preventDefault();
    }
  }

  private startNewSegPolygon(): void {
    this.manualSegIsDrawing = true;
    this.manualSegCurrentPoints = [];
    this.manualSegSelectedPolyId = null;
    this.manualSegCloseHover = false;
    this.renderManualAnno();
  }

  private cancelManualSegPolygon(): void {
    this.manualSegIsDrawing = false;
    this.manualSegCurrentPoints = [];
    this.manualSegCloseHover = false;
    this.renderManualAnno();
  }

  private completeManualSegPolygon(): void {
    if (!this.manualSegIsDrawing) return;

    // Normalise points (remove doublons / remove fermeture explicite)
    const clean = this.dedupeSegPoints(this.manualSegCurrentPoints || []);

    if (clean.length < 3) {
      this.cancelManualSegPolygon();
      return;
    }

    const id = `seg-${Date.now()}-${Math.random().toString(16).slice(2)}`;
    this.manualSegPolygons.push({
      id,
      label: this.manualSegCurrentLabel,
      points: clean,
    });

    this.manualSegSelectedPolyId = id;
    this.manualSegIsDrawing = false;
    this.manualSegCurrentPoints = [];
    this.manualSegCloseHover = false;

    this.renderManualAnno();
  }

  private selectManualSegPolygon(id: string): void {
    this.manualSegSelectedPolyId = id;
    this.renderManualAnno();
  }

  private removeManualSegPolygon(id: string): void {
    this.manualSegPolygons = this.manualSegPolygons.filter((p) => p.id !== id);
    if (this.manualSegSelectedPolyId === id) this.manualSegSelectedPolyId = null;
    this.renderManualAnno();
  }

  private undoManualSegPointOrPolygon(): void {
    if (this.manualSegIsDrawing && this.manualSegCurrentPoints.length > 0) {
      this.manualSegCurrentPoints.pop();
      this.renderManualAnno();
      return;
    }

    if (this.manualSegPolygons.length > 0) {
      const removed = this.manualSegPolygons.pop();
      if (removed && this.manualSegSelectedPolyId === removed.id) this.manualSegSelectedPolyId = null;
      this.renderManualAnno();
    }
  }

  private resetManualSegPolygons(): void {
    this.manualSegPolygons = [];
    this.manualSegSelectedPolyId = null;
    this.cancelManualSegPolygon();
  }

  private hitTestManualAnnoBox(xCanvas: number, yCanvas: number): ManualAnnoBox | null {
    // test sur les coords canvas (on convertit les boxes image->canvas)
    for (let i = this.manualAnnoBoxes.length - 1; i >= 0; i--) {
      const b = this.manualAnnoBoxes[i];
      const p1 = this.imageToCanvas(b.xMin, b.yMin);
      const p2 = this.imageToCanvas(b.xMax, b.yMax);

      const x = Math.min(p1.x, p2.x);
      const y = Math.min(p1.y, p2.y);
      const w = Math.abs(p2.x - p1.x);
      const h = Math.abs(p2.y - p1.y);

      if (xCanvas >= x && xCanvas <= x + w && yCanvas >= y && yCanvas <= y + h) {
        return b;
      }
    }
    return null;
  }

  private selectManualAnnoBox(id: string): void {
    this.manualAnnoSelectedBoxId = id;
    this.renderManualAnno();
  }

  private removeManualAnnoBox(id: string): void {
    this.manualAnnoBoxes = this.manualAnnoBoxes.filter((b) => b.id !== id);
    if (this.manualAnnoSelectedBoxId === id) this.manualAnnoSelectedBoxId = null;
    this.renderManualAnno();
  }

  private undoManualAnnoBox(): void {
    if (this.manualAnnoBoxes.length === 0) return;
    const removed = this.manualAnnoBoxes.pop();
    if (removed && this.manualAnnoSelectedBoxId === removed.id) this.manualAnnoSelectedBoxId = null;
    this.renderManualAnno();
  }

  private resetManualAnnoBoxes(): void {
    this.manualAnnoBoxes = [];
    this.manualAnnoSelectedBoxId = null;
    this.manualAnnoIsDrawing = false;
    this.manualAnnoStart = null;
    this.manualAnnoPreviewBox = null;
    this.renderManualAnno();
  }

  private addManualAnnoLabel(): void {
    const v = (this.manualAnnoNewLabel || '').trim();
    if (!v) return;
    if (!this.manualAnnoLabels.includes(v)) {
      this.manualAnnoLabels.push(v);
    }
    this.manualAnnoCurrentLabel = v;
    this.manualAnnoNewLabel = '';
  }

  private escapeXml(value: string): string {
    return value
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&apos;');
  }

  private buildPascalVocXml(params: {
    filename: string;
    width: number;
    height: number;
    boxes: ManualAnnoBox[];
  }): string {
    const { filename, width, height, boxes } = params;

    const objects = boxes
      .map((b) => {
        const name = this.escapeXml((b.label || 'object').trim());

        const xmin = Math.max(0, Math.min(width, Math.round(Math.min(b.xMin, b.xMax))));
        const ymin = Math.max(0, Math.min(height, Math.round(Math.min(b.yMin, b.yMax))));
        const xmax = Math.max(0, Math.min(width, Math.round(Math.max(b.xMin, b.xMax))));
        const ymax = Math.max(0, Math.min(height, Math.round(Math.max(b.yMin, b.yMax))));

        // évite les boxes dégénérées
        if (xmax <= xmin || ymax <= ymin) return '';

        return `
    <object>
      <name>${name}</name>
      <pose>Unspecified</pose>
      <truncated>0</truncated>
      <difficult>0</difficult>
      <bndbox>
        <xmin>${xmin}</xmin>
        <ymin>${ymin}</ymin>
        <xmax>${xmax}</xmax>
        <ymax>${ymax}</ymax>
      </bndbox>
    </object>`;
      })
      .filter(Boolean)
      .join('\n');

    return `<?xml version="1.0" encoding="UTF-8"?>
  <annotation>
    <folder>upload</folder>
    <filename>${this.escapeXml(filename)}</filename>
    <size>
      <width>${Math.round(width)}</width>
      <height>${Math.round(height)}</height>
      <depth>3</depth>
    </size>
    <segmented>0</segmented>
    ${objects}
  </annotation>`;
  }

  private readonly ROBOFLOW_CLASS_ID: Record<string, number> = {
    // labels UI -> class_id Roboflow (data.yaml)
    Compacteuse: 0,
    Casque: 1,
    Gilet: 2,
    Personne: 3,
    'Grue mobile': 4,
    'Grue à tour': 5,
    camion: 6,
    Pelle: 7,
    Chariot: 8,
    Nacelle: 9,
    Toupie: 10,
    benne: 11,
    Goutte: 12,
    Foreuse: 13,
    'Non sécurisé': 14,
    Coactivité: 15,
    Feu: 16,
    Fumée: 17,
    car: 18,

    // variantes tolérées (si tu veux)
    background: 0,
    helmet: 1,
    vest: 2,
    Person: 3,
    gruemobile: 4,
    crane: 5,
    Camion: 6,
    pelle: 7,
    chariot: 8,
    nacelle: 9,
    toupie: 10,
    Benne: 11,
    goutte: 12,
    foreuse: 13,
    no_safety: 14,
    coactivity: 15,
    fire: 16,
    Smoke: 17,
    Bonfire: 16,
    Car: 18,
  };

  private readonly ROBOFLOW_LABELMAP: Record<number, string> = {
    0: 'Compacteuse',
    1: 'Casque',
    2: 'Gilet',
    3: 'Personne',
    4: 'Grue mobile',
    5: 'Grue à tour',
    6: 'Camion',
    7: 'Pelle',
    8: 'Chariot',
    9: 'Nacelle',
    10: 'Toupie',
    11: 'Benne',
    12: 'Goutte',
    13: 'Foreuse',
    14: 'Non sécurisé',
    15: 'Coactivité',
    16: 'Feu',
    17: 'Fumée',
    18: 'Car',
  };

  // Roboflow attend des clés string "0", "1", ...
  private buildRoboflowLabelmapForDarknet(): Record<string, string> {
    // clés "0", "1", ...
    return {
      '0': 'background',
      '1': 'benne',
      '2': 'camion',
      '3': 'car',
      '4': 'chariot',
      '5': 'compacteuse',
      '6': 'crane',
      '7': 'foreuse',
      '8': 'goutte',
      '9': 'gruemobile',
      '10': 'helmet',
      '11': 'ladder',
      '12': 'nacelle',
      '13': 'pelle',
      '14': 'Person',
      '15': 'toupie',
      '16': 'vest',
    };
  }

  private readonly UI_LABEL_TO_ROBOFLOW_NAME: Record<string, string> = {
    // UI FR -> Roboflow
    casque: 'helmet',
    gilet: 'vest',
    personne: 'Person',
    'grue mobile': 'gruemobile',
    'grue à tour': 'crane',
    'grue a tour': 'crane',
    camion: 'camion',
    benne: 'benne',
    compacteuse: 'compacteuse',
    foreuse: 'foreuse',
    goutte: 'goutte',
    pelle: 'pelle',
    chariot: 'chariot',
    nacelle: 'nacelle',
    toupie: 'toupie',
    voiture: 'car',
    car: 'car',

    // déjà Roboflow (si l’IA/ton UI renvoie ces noms)
    helmet: 'helmet',
    vest: 'vest',
    person: 'Person', // attention: dataset = "Person" (P majuscule)
    gruemobile: 'gruemobile',
    crane: 'crane',
    ladder: 'ladder',
    background: 'background',
  };

  private normalizeLabel(value: string): string {
    return (value || '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '') // retire les accents
      .replace(/\s+/g, ' ');
  }

  private readonly ROBOFLOW_CLASS_ID_FROM_DATASET: Record<string, number> = {
    background: 0,
    benne: 1,
    camion: 2,
    car: 3,
    chariot: 4,
    compacteuse: 5,
    crane: 6,
    foreuse: 7,
    goutte: 8,
    gruemobile: 9,
    helmet: 10,
    ladder: 11,
    nacelle: 12,
    pelle: 13,
    Person: 14,
    toupie: 15,
    vest: 16,
  };

  private getRoboflowClassId(uiLabel: string): number | undefined {
    const key = this.normalizeLabel(uiLabel);

    // 1) UI -> Roboflow class_name
    const rfName = this.UI_LABEL_TO_ROBOFLOW_NAME[key] ?? uiLabel; // fallback brut

    // 2) class_name -> id (dataset)
    // Attention à "Person" (case sensitive) : on force via mapping ci-dessus
    if (this.ROBOFLOW_CLASS_ID_FROM_DATASET[rfName] !== undefined) {
      return this.ROBOFLOW_CLASS_ID_FROM_DATASET[rfName];
    }

    // tolérance si rfName arrive en minuscule "person"
    if (rfName.toLowerCase() === 'person') return this.ROBOFLOW_CLASS_ID_FROM_DATASET['Person'];

    return undefined;
  }

  private buildYoloTxt(params: { width: number; height: number; boxes: ManualAnnoBox[] }): string {
    const { width, height, boxes } = params;

    const lines: string[] = [];

    for (const b of boxes) {
      const classId = this.getRoboflowClassId(b.label);
      if (classId === undefined) {
        throw new Error(`Label non mappé vers une classe Roboflow: "${b.label}"`);
      }

      const xMin = Math.max(0, Math.min(width, Math.min(b.xMin, b.xMax)));
      const yMin = Math.max(0, Math.min(height, Math.min(b.yMin, b.yMax)));
      const xMax = Math.max(0, Math.min(width, Math.max(b.xMin, b.xMax)));
      const yMax = Math.max(0, Math.min(height, Math.max(b.yMin, b.yMax)));

      const bw = xMax - xMin;
      const bh = yMax - yMin;
      if (bw <= 1 || bh <= 1) continue;

      const cx = (xMin + xMax) / 2;
      const cy = (yMin + yMax) / 2;

      // Normalisation [0..1]
      const nx = cx / width;
      const ny = cy / height;
      const nw = bw / width;
      const nh = bh / height;

      lines.push(`${classId} ${nx.toFixed(6)} ${ny.toFixed(6)} ${nw.toFixed(6)} ${nh.toFixed(6)}`);
    }

    return lines.join('\n');
  }

  private getPhotosTableName(): string {
    // Recommandé : mettre le nom de table en env
    // sinon fallback sur ta table actuelle
    return (process.env.VUE_APP_PHOTOS_TABLE as string) || 'erige-photos-prod';
  }

  private buildPersistedManualBoxes(): ManualAnnoPersistedBox[] {
    const now = Date.now();
    const createdBy = (this.user as any)?.id || (this.user as any)?.sub || (this.user as any)?.username || undefined;

    return (this.manualAnnoBoxes || []).map((b) => ({
      id: b.id,
      label: (b.label || '').trim(),
      xMin: Math.round(Math.min(b.xMin, b.xMax)),
      yMin: Math.round(Math.min(b.yMin, b.yMax)),
      xMax: Math.round(Math.max(b.xMin, b.xMax)),
      yMax: Math.round(Math.max(b.yMin, b.yMax)),
      createdAt: now,
      createdBy,
    }));
  }

  /**
   * Sauvegarde les boxes tracées dans l'item Photo (DynamoDB).
   * - écrase la valeur précédente (version "last state")
   * - stocke aussi des métas (date, image size, optionnel roboflow)
   */
  private async saveManualAnnotationsIntoPhoto(params?: {
    roboflow?: { dataset: string; split: string; imageId: string };
  }): Promise<void> {
    if (!this.annotationPhoto?.id) return;
    if (!this.manualAnnoBgImage) return;

    const boxes = this.buildPersistedManualBoxes();
    if (!boxes.length) return;

    const credentials = await Auth.currentCredentials();
    const dynamo = new AWS.DynamoDB.DocumentClient({
      region: 'eu-west-3',
      credentials,
    });

    const now = Date.now();

    // Métas utiles (permet de re-projeter / debug)
    const meta = {
      updatedAt: now,
      imageWidth: this.manualAnnoBgImage.width,
      imageHeight: this.manualAnnoBgImage.height,
      count: boxes.length,
    };

    // UpdateExpression propre (évite mots réservés)
    const exprNames: Record<string, string> = {
      '#ma': 'manualAnnotations',
      '#mam': 'manualAnnotationsMeta',
      '#ua': 'updatedAt',
    };
    const exprValues: Record<string, any> = {
      ':boxes': boxes,
      ':meta': meta,
      ':updatedAt': now,
    };

    let updateExpr = 'SET #ma = :boxes, #mam = :meta, #ua = :updatedAt';

    // Optionnel : stocker le dernier upload Roboflow
    if (params?.roboflow) {
      exprNames['#rf'] = 'roboflow';
      exprValues[':rf'] = {
        lastUploadAt: now,
        dataset: params.roboflow.dataset,
        split: params.roboflow.split,
        imageId: params.roboflow.imageId,
      };
      updateExpr += ', #rf = :rf';
    }

    await dynamo
      .update({
        TableName: this.getPhotosTableName(),
        Key: { id: this.annotationPhoto.id },
        UpdateExpression: updateExpr,
        ExpressionAttributeNames: exprNames,
        ExpressionAttributeValues: exprValues,
      })
      .promise();

    // Mise à jour locale (évite d'attendre un refresh)
    this.$set(this.annotationPhoto as any, 'manualAnnotations', boxes);
    this.$set(this.annotationPhoto as any, 'manualAnnotationsMeta', meta);
  }

  private async uploadManualAnnotationsToRoboflow(): Promise<void> {
    const apiKey = this.roboflowApiKey;
    const dataset = (this.manualAnnoDataset || '').trim();
    const split = ((process.env.VUE_APP_ROBOFLOW_SPLIT as string) || 'train').trim();

    if (!apiKey) {
      this.$bvToast?.toast('Clé API Roboflow manquante.', { title: 'Erreur', variant: 'danger', solid: true });
      return;
    }
    if (!dataset) {
      this.$bvToast?.toast('Dataset Roboflow manquant (slug).', { title: 'Erreur', variant: 'danger', solid: true });
      return;
    }
    if (!this.annotationPhoto || !this.manualAnnoBgImage) {
      this.$bvToast?.toast('Photo/Image non chargée.', { title: 'Erreur', variant: 'danger', solid: true });
      return;
    }
    if (this.manualAnnoBoxes.length === 0) {
      this.$bvToast?.toast('Aucune bounding box à envoyer.', { title: 'Info', variant: 'warning', solid: true });
      return;
    }

    try {
      this.manualAnnoUploadStatus = 'Upload Roboflow en cours...';

      // 1) Récupérer le blob de l'image originale
      const key = this.annotationPhoto.key || this.annotationPhoto.smallKey;
      let imageUrl: string;
      try {
        imageUrl = (await Storage.get(key, { level: 'public' } as any)) as string;
      } catch {
        const k2 = key.startsWith('public/') ? key.substring('public/'.length) : key;
        imageUrl = (await Storage.get(k2, { level: 'public' } as any)) as string;
      }

      const resp = await fetch(imageUrl);
      const imageBlob = await resp.blob();

      const ext = imageBlob.type === 'image/png' ? 'png' : imageBlob.type === 'image/webp' ? 'webp' : 'jpg';

      const iw = this.manualAnnoBgImage.width;
      const ih = this.manualAnnoBgImage.height;

      const fileBase = `manual-${this.annotationPhoto.id}-${Date.now()}`;
      const imageName = `${fileBase}.${ext}`;
      const txtName = `${fileBase}.txt`;

      // 2) Construire YOLO TXT
      const yoloTxt = this.buildYoloTxt({ width: iw, height: ih, boxes: this.manualAnnoBoxes });

      if (!yoloTxt || !yoloTxt.trim()) {
        throw new Error('YOLO txt vide — Roboflow ne peut rien afficher.');
      }

      console.groupCollapsed('[Roboflow] YOLO preview');
      console.log('image:', { iw, ih, imageName, txtName, split, dataset });
      console.log('boxes:', this.manualAnnoBoxes);
      console.log('yoloTxt:\n' + yoloTxt);
      console.log('lines:', yoloTxt ? yoloTxt.split('\n').length : 0);
      console.groupEnd();

      // 3) Upload de l’image
      const formData = new FormData();
      formData.append('file', imageBlob, imageName);

      const uploadRes = await axios.post(`https://api.roboflow.com/dataset/${dataset}/upload`, formData, {
        params: {
          api_key: apiKey,
          name: imageName,
          split,
        },
      });

      const imageId = uploadRes?.data?.id;
      if (!uploadRes?.data?.success || !imageId) {
        throw new Error(`Upload image échoué : ${JSON.stringify(uploadRes?.data)}`);
      }

      // 4) Attacher les annotations
      this.manualAnnoUploadStatus = 'Envoi annotations Roboflow...';
      const labelmap = this.buildRoboflowLabelmapForDarknet();

      await axios.post(
        `https://api.roboflow.com/dataset/${dataset}/annotate/${imageId}`,
        {
          annotationFile: yoloTxt + '\n',
          labelmap,
        },
        {
          params: {
            api_key: apiKey,
            name: txtName,
          },
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      // 5) Sauvegarde en base DynamoDB
      this.manualAnnoUploadStatus = 'Sauvegarde en base...';

      const credentials = await Auth.currentCredentials();
      const dynamo = new AWS.DynamoDB.DocumentClient({
        region: 'eu-west-3',
        credentials,
      });

      const photoId = this.annotationPhoto!.id;

      // --- manualDetections (liste normalisée avec norms) ---
      // On crée un array de plain objects (DocumentClient wrapppera automatiquement en {L: [{M: ...}]})
      const manualDetsPlain = this.manualAnnoBoxes.map((box) => ({
        label: box.label,
        score: 100.0,
        source: 'manual',
        xMinNorm: parseFloat((box.xMin / iw).toFixed(6)),
        yMinNorm: parseFloat((box.yMin / ih).toFixed(6)),
        xMaxNorm: parseFloat((box.xMax / iw).toFixed(6)),
        yMaxNorm: parseFloat((box.yMax / ih).toFixed(6)),
      }));

      // --- Mapping UI → detectedLabels ---
      const reverseLabelMap: Record<string, string> = {
        Personne: 'person',
        Casque: 'helmet',
        Gilet: 'vest',
        Camion: 'camion',
        'Grue à tour': 'crane',
        'Grue mobile': 'gruemobile',
        Pelle: 'pelle',
        Nacelle: 'nacelle',
        Toupie: 'toupie',
        Benne: 'benne',
        Foreuse: 'foreuse',
        Voiture: 'car',
        Feu: 'fire',
        'Non sécurisé': 'no_safety',
        Coactivité: 'coactivity',
      };

      const labelCounts: Record<string, number> = {};
      this.manualAnnoBoxes.forEach((box) => {
        const uiLabel = box.label.trim();
        let key =
          reverseLabelMap[uiLabel] ||
          uiLabel
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/\s+/g, '');
        labelCounts[key] = (labelCounts[key] || 0) + 1;
      });

      // UpdateExpression
      const detectedLabelsExpr: string[] = [];
      const exprValues: Record<string, any> = {
        ':dets': manualDetsPlain, // ← plain array, DocumentClient wrappe auto
        ':zero': 0,
      };

      Object.keys(labelCounts).forEach((key) => {
        const placeholder = `:inc_${key.replace(/[^a-zA-Z0-9]/g, '')}`;
        detectedLabelsExpr.push(`detectedLabels.${key} = if_not_exists(detectedLabels.${key}, :zero) + ${placeholder}`);
        exprValues[placeholder] = labelCounts[key];
      });

      let updateExpr = 'SET manualDetections = :dets';
      if (detectedLabelsExpr.length > 0) {
        updateExpr += ', ' + detectedLabelsExpr.join(', ');
      }

      await dynamo
        .update({
          TableName: 'erige-photos-prod',
          Key: { id: photoId },
          UpdateExpression: updateExpr,
          ExpressionAttributeValues: exprValues,
        })
        .promise();

      console.log('Sauvegarde réussie : manualDetections + detectedLabels mis à jour');

      // === Merge manual → detections (sans wrapping manuel) ===
      try {
        // Récupère detections actuelles
        let currentDetsRaw = (this.annotationPhoto as any).detections || [];
        const currentList = this.asDetectionList(currentDetsRaw);

        // Garde seulement non-manuelles
        const existingIA = currentList.filter((d: any) => String(d.source || '').toLowerCase() !== 'manual');

        // Plain objects pour manuelles
        const manualAsDetectionPlain = this.manualAnnoBoxes.map((box: ManualAnnoBox) => ({
          label: box.label,
          score: 100.0,
          source: 'manual',
          x_min_norm: parseFloat((box.xMin / iw).toFixed(6)),
          y_min_norm: parseFloat((box.yMin / ih).toFixed(6)),
          x_max_norm: parseFloat((box.xMax / iw).toFixed(6)),
          y_max_norm: parseFloat((box.yMax / ih).toFixed(6)),
        }));

        // Merge
        const mergedDetectionsPlain = [...existingIA, ...manualAsDetectionPlain];

        console.log(
          'Merge detections : IA existantes',
          existingIA.length,
          '+ manuelles',
          manualAsDetectionPlain.length,
          '→ total',
          mergedDetectionsPlain.length
        );

        // Update detections (plain array → DocumentClient wrappe auto)
        await dynamo
          .update({
            TableName: 'erige-photos-prod',
            Key: { id: photoId },
            UpdateExpression: 'SET detections = :mergedDets',
            ExpressionAttributeValues: {
              ':mergedDets': mergedDetectionsPlain,
            },
          })
          .promise();

        // Mise à jour locale
        this.$set(this.annotationPhoto as any, 'detections', mergedDetectionsPlain);

        console.log('Merge detections → sauvegardé avec succès (sans nesting excessif)');
      } catch (mergeErr) {
        console.error('Erreur merge detections :', mergeErr);
        this.$bvToast?.toast('Merge detections partiel (voir console)', {
          title: 'Attention',
          variant: 'warning',
          solid: true,
        });
      }

      this.manualAnnoUploadStatus = 'Tout terminé !';
      this.$bvToast?.toast('Annotations envoyées à Roboflow et sauvegardées en base.', {
        title: 'Succès',
        variant: 'success',
        solid: true,
      });
    } catch (err: any) {
      console.error('Erreur upload/sauvegarde :', err);
      this.manualAnnoUploadStatus = '';
      this.$bvToast?.toast(`Erreur : ${err?.message || 'voir console'}`, {
        title: 'Erreur',
        variant: 'danger',
        solid: true,
      });
    }

    this.closeAnnotationModal();
  }

  private async loadManualDetections(): Promise<void> {
    if (!this.annotationPhoto?.id) return;

    // Si déjà chargé et non vide → skip
    if ((this.annotationPhoto as any).manualDetections?.length > 0) {
      console.log('Manual detections déjà chargées, skip reload');
      return;
    }

    try {
      const credentials = await Auth.currentCredentials();
      const dynamo = new AWS.DynamoDB.DocumentClient({
        region: 'eu-west-3',
        credentials,
      });

      const params = {
        TableName: 'erige-photos-prod',
        Key: { id: this.annotationPhoto.id },
        ProjectionExpression: 'manualDetections',
      };

      const result = await dynamo.get(params).promise();

      if (result.Item?.manualDetections) {
        const raw = result.Item.manualDetections;

        console.log('Raw manualDetections from DB :', JSON.stringify(raw, null, 2));

        const list = this.extractDetectionList(raw);

        console.log('Liste extraite (longueur) :', list.length);

        const unwrapped = list
          .map((d: any) => this.deepUnwrap(d))
          .map((item: any) => {
            if (typeof item === 'object' && item !== null) {
              // Normalisation forcée des champs critiques
              item.label = String(item.label ?? 'Objet').trim() || 'Objet';
              item.score = parseFloat(item.score ?? item.confidence ?? 100);
              item.source = String(item.source ?? 'manual');
              item.xMinNorm = parseFloat(item.xMinNorm ?? item.x_min_norm ?? 0);
              item.yMinNorm = parseFloat(item.yMinNorm ?? item.y_min_norm ?? 0);
              item.xMaxNorm = parseFloat(item.xMaxNorm ?? item.x_max_norm ?? 1);
              item.yMaxNorm = parseFloat(item.yMaxNorm ?? item.y_max_norm ?? 1);
            }
            return item;
          })
          .filter(Boolean);

        console.log('Detections unwrappées & normalisées :', unwrapped.length, unwrapped);

        this.$set(this.annotationPhoto as any, 'manualDetections', unwrapped);
      } else {
        this.$set(this.annotationPhoto as any, 'manualDetections', []);
      }
    } catch (err) {
      console.error('Erreur chargement manualDetections :', err);
      this.$set(this.annotationPhoto as any, 'manualDetections', []);
    }
  }

  private importManualDetectionsIntoBoxes(): void {
    if (!this.annotationPhoto || !this.manualAnnoBgImage) return;
    const manualDets = (this.annotationPhoto as any).manualDetections || [];
    if (manualDets.length === 0) return;

    const photoId = this.annotationPhoto.id;
    const iw = this.manualAnnoBgImage.width;
    const ih = this.manualAnnoBgImage.height;

    console.log('Import manual detections for photo:', photoId, 'count:', manualDets.length);

    // Reset boxes si on change de photo
    if (this.manualAnnoLastPhotoId !== photoId) {
      this.manualAnnoBoxes = [];
      this.manualAnnoSelectedBoxId = null;
    }

    const newBoxes: ManualAnnoBox[] = [];
    manualDets.forEach((det: any, idx: number) => {
      const uiLabel = String(det?.label ?? 'Objet').trim();
      // Ajoute le label à la liste du select si nécessaire
      if (!this.manualAnnoLabels.includes(uiLabel)) {
        this.manualAnnoLabels.push(uiLabel);
      }
      const xMin = Math.round(Number(det?.xMinNorm ?? 0) * iw);
      const yMin = Math.round(Number(det?.yMinNorm ?? 0) * ih);
      const xMax = Math.round(Number(det?.xMaxNorm ?? 1) * iw);
      const yMax = Math.round(Number(det?.yMaxNorm ?? 1) * ih);

      // Sécurité : clamp + évite boxes dégénérées
      const finalXMin = Math.max(0, Math.min(iw, Math.min(xMin, xMax)));
      const finalXMax = Math.max(0, Math.min(iw, Math.max(xMin, xMax)));
      const finalYMin = Math.max(0, Math.min(ih, Math.min(yMin, yMax)));
      const finalYMax = Math.max(0, Math.min(ih, Math.max(yMin, yMax)));
      if (finalXMax - finalXMin < 5 || finalYMax - finalYMin < 5) return;

      newBoxes.push({
        id: `manual-${photoId}-${idx}-${Date.now()}`,
        label: uiLabel,
        xMin: finalXMin,
        yMin: finalYMin,
        xMax: finalXMax,
        yMax: finalYMax,
      });
    });

    if (newBoxes.length > 0) {
      this.manualAnnoBoxes = [...this.manualAnnoBoxes, ...newBoxes];
      this.manualAnnoSelectedBoxId = newBoxes[0].id;
      this.manualAnnoCurrentLabel = newBoxes[0].label;
    }

    this.manualAnnoLastPhotoId = photoId;
    // On marque que ce sont des manuelles (pour éviter de ré-importer IA par erreur)
    this.manualAnnoImportedFromIA = false;
    console.log('Manual boxes importées :', newBoxes.length);
  }

  private getPhotoDates(): void {
    if (this.dataImagesKey.length > 0) {
      // Trier les photos par date
      const sortedPhotos = this.dataImagesKey.slice().sort((a, b) => {
        return new Date(a.data.createdAt).getTime() - new Date(b.data.createdAt).getTime();
      });
      this.firstPhotoDate = new Date(sortedPhotos[0].data.createdAt);
      this.lastPhotoDate = new Date(sortedPhotos[sortedPhotos.length - 1].data.createdAt);
    }
  }

  private scheduleChartUpdate() {
    if (this.chartUpdateTimeout !== null) {
      window.clearTimeout(this.chartUpdateTimeout);
    }
    this.chartUpdateTimeout = window.setTimeout(() => {
      this.chartUpdateTimeout = null;

      if (!this.originalData || !this.originalData.length) return;

      if (this.modeSelected === 'Sécurité') {
        this.createSecurityChart();
      } else {
        this.createChart();
      }
    }, 150); // 150–200ms : fluide mais pas spammy
  }

  public toggleLeftPanel() {
    // Basculer l'état du panneau de gauche
    this.leftPanelVisible = !this.leftPanelVisible;

    // Sélectionner les éléments du DOM
    const leftElement = this.$el.querySelector('.left') as HTMLElement;
    const galleryContainer = this.$el.querySelector('.gallery-container') as HTMLElement;

    if (leftElement && galleryContainer) {
      if (this.leftPanelVisible) {
        // Restaurer les largeurs initiales
        leftElement.style.width = '60vw';
        galleryContainer.style.width = '40vw';
        galleryContainer.classList.remove('hidden');
      } else {
        // Agrandir le panneau gauche et masquer la galerie
        leftElement.style.width = '100vw';
        galleryContainer.style.width = '0vw';
        galleryContainer.classList.add('hidden');
      }

      // Redimensionner le graphique après la mise à jour du DOM
      this.$nextTick(() => {
        const plotDiv = this.$refs.chart as HTMLElement;
        if (plotDiv && this.isChartInitialized) {
          Plotly.Plots.resize(plotDiv);
        }
      });
    }
  }

  public get cameraSelected(): string | null {
    return (this.$route.query.camera as string) || null;
  }
  public set cameraSelected(s: string | null) {
    logger.info('set cameraSelected', s);
    if (s !== null) {
      this.$router.push({ path: this.$route.path, query: { ...this.$route.query, camera: s } });
    }
  }

  public get camera(): Camera | undefined {
    //logger.info('get camera ' + this.cameraSelected);
    return (
      this.project?.cameras?.find((camera: Camera) => camera.id === this.cameraSelected) ||
      this.project?.previousCameras?.find((camera: Camera) => camera.id === this.cameraSelected)
    );
  }

  public get camerasOptions(): unknown[] {
    const project = this.project;
    const data = [
      ...(project?.cameras?.map((camera) => ({
        text: `${camera.name}`,
        value: camera.id,
      })) ?? []),
      ...(project?.previousCameras?.map((camera) => ({
        text: `${camera.name} (deleted)`,
        value: camera.id,
      })) ?? []),
    ];
    if (data.length > 0) {
      return data;
    } else {
      return [{ text: 'Aucune caméra disponible', value: null }];
    }
  }

  public get filteredBoundingBoxImages(): BoundingBoxImage[] {
    return this.boundingBoxImages.filter((img) => !img.key.endsWith('safety-segmentation.jpg'));
  }

  public get filteredSegmentationImages(): BoundingBoxImage[] {
    return this.boundingBoxImages;
  }

  public async mounted(): Promise<void> {
    try {
      this.loading = true;

      // Charger le projet si nécessaire
      if (!this.project) {
        this.project = this.projectWithId(this.id);
        this.setProject(this.project);
        this.isProjectLoading = false;
      }

      // Charger les photos de la caméra si cameraSelected est défini
      if (this.cameraSelected !== null) {
        await this.loadCameraPhotos();
      }

      this.getPhotoDates();
      if (this.firstPhotoDate) {
        this.startDate = this.formatDateForInput(this.firstPhotoDate);
      }
      if (this.lastPhotoDate) {
        // Ajuster la date de fin pour inclure toute la journée
        const endDate = new Date(this.lastPhotoDate);
        endDate.setHours(23, 59, 59, 999);
        this.endDate = this.formatDateForInput(endDate);
      }
    } catch (error) {
      console.error('Erreur lors du chargement:', error);
    } finally {
      this.loading = false;
    }
    await this.$nextTick();
    if (this.modeSelected === 'Sécurité') {
      this.createSecurityChart();
    } else {
      this.createChart();
    }

    // Définir les largeurs initiales
    const leftElement = this.$el.querySelector('.left') as HTMLElement;
    const galleryContainer = this.$el.querySelector('.gallery-container') as HTMLElement;
    if (leftElement && galleryContainer) {
      leftElement.style.width = '60vw';
      galleryContainer.style.width = '40vw';
    }
  }

  private formatDateForInput(date: Date): string {
    // Formate la date en 'YYYY-MM-DDTHH:mm:ss' pour inclure l'heure
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    const hours = ('0' + date.getHours()).slice(-2);
    const minutes = ('0' + date.getMinutes()).slice(-2);
    const seconds = ('0' + date.getSeconds()).slice(-2);
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  }

  private formatDate(dateStr: string, locale: string): string {
    const date = new Date(dateStr);
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false, // Format 24h
    };
    return date.toLocaleString(locale, options);
  }

  private async loadCameraPhotos(): Promise<void> {
    if (this.cameraSelected !== null) {
      const camera = this.project?.cameras?.find((cam) => cam.id === this.cameraSelected);
      const photos = await this.findPhotoAllForProject({ projectId: this.id, cameraId: this.cameraSelected });

      if (photos && photos.length > 0) {
        const newImages = photos.map((photo) => ({ data: Vue.set({}, 'data', photo) }));
        this.$set(this, 'dataImagesKey', newImages);
        await this.$nextTick(); // S'assurer que le DOM est mis à jour

        // Charger les URLs des images une seule fois ici
        let data = await Promise.all(
          this.dataImagesKey.map(async ({ data: photo }) => {
            // ici "photo" est de type Photo directement

            const imageUrl = await Storage.get(photo.smallKey);
            const rawKey = photo.key || photo.smallKey;
            const detected = photo.detectedLabels || {};

            // Pour Storage.list niveau "public", on enlève le préfixe public/
            let s3Key = rawKey.startsWith('public/') ? rawKey.substring('public/'.length) : rawKey;

            let safetyAnalysis: SafetyAnalysis | null = null;
            if (photo.safetyAnalysisJson) {
              try {
                safetyAnalysis = JSON.parse(photo.safetyAnalysisJson) as SafetyAnalysis;
              } catch (e) {
                console.error('Erreur parse safetyAnalysisJson', e);
              }
            }

            const baseName = s3Key.split('/').pop()!.split('.')[0];
            const directory = s3Key.substring(0, s3Key.lastIndexOf('/'));

            return {
              photoId: photo.id,
              date: new Date(photo.createdAt),

              toupie: Number(photo.detectedLabels?.toupie ?? 0),
              crane: Number(photo.detectedLabels?.crane ?? 0),
              nacelle: Number(photo.detectedLabels?.nacelle ?? 0),
              pelle: Number(photo.detectedLabels?.pelle ?? 0),
              person: Number(photo.detectedLabels?.Person ?? 0),
              benne: Number(photo.detectedLabels?.benne ?? 0),
              compacteuse: Number(photo.detectedLabels?.compateuse ?? 0),
              mobilecrane: Number(photo.detectedLabels?.gruemobile ?? 0),
              camion: Number(photo.detectedLabels?.camion ?? 0),
              foreuse: Number(photo.detectedLabels?.foreuse ?? 0),
              density: Number(photo.detectedLabels?.density ?? 0),
              movement: Number(photo.detectedLabels?.movement ?? 0),
              helmet: Number(photo.detectedLabels?.helmet ?? 0),
              vest: Number(photo.detectedLabels?.vest ?? 0),
              excavation: Number(photo.detectedLabels?.excavation ?? 0),
              filet: Number(photo.detectedLabels?.filet ?? 0),
              gc: Number(photo.detectedLabels?.gc ?? 0),
              heras: Number(photo.detectedLabels?.heras ?? 0),
              no_safety: Number(photo.detectedLabels?.no_safety ?? 0),
              rubalise: Number(photo.detectedLabels?.rubalise ?? 0),
              coactivity: Number(photo.detectedLabels?.coactivity ?? 0),
              fire: Number(photo.detectedLabels?.fire ?? 0),
              car: Number(photo.detectedLabels?.car ?? 0),

              imageUrl,
              s3Directory: directory,
              s3BaseName: baseName,

              safety_score: Number((detected.safety_score as any) ?? photo.safetyScore ?? 0),
              housekeeping_score: Number((detected.housekeeping_score as any) ?? photo.housekeepingScore ?? 0),
              workers_total: Number(detected.workers_total ?? 0),
              ppe_non_compliance_count: Number(detected.ppe_non_compliance_count ?? 0),
              hazards_count: Number(detected.hazards_count ?? 0),

              safetyAnalysis,
            };
          })
        );

        data = data.filter((d) => d.date && d.imageUrl && d.photoId);

        // Trier les données par date
        data.sort((a, b) => a.date.getTime() - b.date.getTime());

        // Stocker les données chargées dans this.originalData
        this.originalData = data;

        // Obtenir les dates des photos pour initialiser les sélecteurs de date
        this.getPhotoDates();
        if (this.firstPhotoDate) {
          this.startDate = this.formatDateForInput(this.firstPhotoDate);
        }
        if (this.lastPhotoDate) {
          this.endDate = this.formatDateForInput(this.lastPhotoDate);
        }
      } else {
        console.error('Aucune photo trouvée ou réponse invalide:', photos);
      }
    }
  }

  get currentSafetyAnalysis(): SafetyAnalysis | null {
    const photo = this.currentPhoto;

    if (!photo || !photo.safetyAnalysisJson) return null;

    try {
      return JSON.parse(photo.safetyAnalysisJson) as SafetyAnalysis;
    } catch (e) {
      console.error('Erreur parse safetyAnalysisJson', e);
      return null;
    }
  }

  get currentSafetyMeta() {
    const analysis = this.currentSafetyAnalysis;
    if (!analysis) return null;
    return analysis.meta;
  }

  private async getAnnotatedSafetyImageDataURL(photoId: string): Promise<string | null> {
    const record = this.originalData.find((d: any) => d.photoId === photoId);
    if (!record || !record.s3Directory || !record.s3BaseName) return null;

    // Dossier Segmentation, même logique que loadBoundingBoxImages
    const segFolder = `${record.s3Directory}/IA/${record.s3BaseName}/Segmentation/`;

    try {
      const files = (await Storage.list(segFolder, { level: 'public' })) as any[];

      if (!files || !files.length) return null;

      // Priorité à l’image "globale" annotée si tu l’as
      let best = files.find((f: any) => f.key.endsWith('safety-segmentation.jpg'));

      // Sinon on prend la première
      if (!best) {
        best = files[0];
      }

      const url = (await Storage.get(best.key, { level: 'public' })) as string;
      return await this.loadImageAsDataURL(url);
    } catch (e) {
      console.error('Erreur chargement image annotée pour le highlight :', e);
      return null;
    }
  }

  public openStartDatepicker(): void {
    (this.$refs.startDatepicker as any).showCalendar();
  }

  public openEndDatepicker(): void {
    (this.$refs.endDatepicker as any).showCalendar();
  }

  public beforeDestroy(): void {
    logger.info('beforeDestroy');
    // called when the route that renders this component is about to
    // be navigated away from.
    // has access to `this` component instance.
    this.disconnectSocket();
  }

  public refreshPhoto(): void {
    if (this.cameraSelected !== null) {
      this.findPhotoAllForProject({ projectId: this.id, cameraId: this.cameraSelected }).then(() => {
        this.newPhotoAvailable = false;
      });
    }
  }

  private async loadPolygonPhoto(): Promise<void> {
    if (this.preloadedImage) {
      this.backgroundImage = this.preloadedImage;
      if (this.polygonCtx && this.polygonCanvas) {
        const scale = Math.min(
          this.polygonCanvas.width / this.backgroundImage.width,
          this.polygonCanvas.height / this.backgroundImage.height
        );
        const x = (this.polygonCanvas.width - this.backgroundImage.width * scale) / 2;
        const y = (this.polygonCanvas.height - this.backgroundImage.height * scale) / 2;
        this.bgScale = scale;
        this.bgX = x;
        this.bgY = y;
        this.drawPolygon();
      }
    } else {
      // Fallback si l'image n'est pas préchargée
      let photo: Photo | null = null;
      if (this.selectedPhotos && this.selectedPhotos.length > 0) {
        photo = this.selectedPhotos[this.selectedPhotos.length - 1];
      } else if (this.dataImagesKey && this.dataImagesKey.length > 0) {
        photo = this.dataImagesKey[this.dataImagesKey.length - 1].data;
      }
      if (!photo) return;

      try {
        const key = photo.key || photo.smallKey;
        const photoUrl = await Storage.get(key);
        const img = new Image();
        img.crossOrigin = 'Anonymous';
        img.onload = () => {
          if (this.polygonCtx && this.polygonCanvas) {
            const scale = Math.min(this.polygonCanvas.width / img.width, this.polygonCanvas.height / img.height);
            const x = (this.polygonCanvas.width - img.width * scale) / 2;
            const y = (this.polygonCanvas.height - img.height * scale) / 2;
            this.backgroundImage = img;
            this.bgScale = scale;
            this.bgX = x;
            this.bgY = y;
            this.drawPolygon();
          }
        };
        img.src = photoUrl as string;
      } catch (error) {
        console.error("Erreur lors du chargement de l'image pour le traçage:", error);
      }
    }
  }

  public openPolygonModal(): void {
    // On suppose que vous avez ajouté dans votre template une modale avec la référence "polygonModal"
    (this.$refs.polygonModal as BModal).show();
  }

  private async loadPolygonPoints(): Promise<void> {
    try {
      const credentials = await Auth.currentCredentials();
      const dynamoDb = new AWS.DynamoDB.DocumentClient({
        region: 'eu-west-3', // Adaptez à votre région AWS
        credentials,
      });

      const params = {
        TableName: 'erige-cameras-prod',
        Key: {
          id: this.camera?.id, // L'ID de la caméra sélectionnée
        },
      };

      const result = await dynamoDb.get(params).promise();
      if (result.Item && result.Item.polygonPoints) {
        this.polygonPoints = result.Item.polygonPoints;
      } else {
        this.polygonPoints = []; // Réinitialiser uniquement si aucun point n'existe
      }
    } catch (error) {
      console.error('Erreur lors du chargement des points du polygone :', error);
      this.polygonPoints = [];
    }
  }

  // Méthode appelée lors de l'affichage de la modale (via l'événement @shown)
  public onPolygonModalShown(): void {
    this.originalPolygonPoints = [...this.polygonPoints]; // Sauvegarde des points originaux
    this.hasSavedPolygon = false;
    this.polygonCanvas = document.getElementById('polygon-canvas') as HTMLCanvasElement;
    if (this.polygonCanvas) {
      this.polygonCtx = this.polygonCanvas.getContext('2d');
      if (this.polygonCtx) {
        this.polygonCtx.clearRect(0, 0, this.polygonCanvas.width, this.polygonCanvas.height);
      }
      this.polygonDrawing = true;
      this.addPolygonCanvasListeners();
      this.loadPolygonPhoto();
    }
  }

  // Installation des écouteurs d'événements sur le canvas
  private addPolygonCanvasListeners(): void {
    if (this.polygonCanvas) {
      this.polygonCanvas.addEventListener('click', this.handlePolygonCanvasClick.bind(this));
      this.polygonCanvas.addEventListener('contextmenu', this.handlePolygonCanvasRightClick.bind(this));
    }
  }

  // Gestion du clic gauche sur le canvas : ajouter un point
  private handlePolygonCanvasClick(e: MouseEvent): void {
    if (!this.polygonCanvas) return;
    const rect = this.polygonCanvas.getBoundingClientRect();
    const xCanvas = ((e.clientX - rect.left) / (rect.right - rect.left)) * this.polygonCanvas.width;
    const yCanvas = ((e.clientY - rect.top) / (rect.bottom - rect.top)) * this.polygonCanvas.height;

    // Conversion des coordonnées vers celles de l'image
    const xImage = (xCanvas - this.bgX) / this.bgScale;
    const yImage = (yCanvas - this.bgY) / this.bgScale;
    this.polygonPoints.push({ x: Math.round(xImage), y: Math.round(yImage) });
    console.info('Point ajouté (coordonnées image):', { x: xImage, y: yImage });
    this.drawPolygon();
  }

  // Gestion du clic droit pour fermer le polygone
  private handlePolygonCanvasRightClick(e: MouseEvent): void {
    e.preventDefault();
    this.completePolygon();
  }

  // Ferme le polygone en reliant le dernier point au premier (si suffisamment de points)
  private completePolygon(): void {
    if (this.polygonPoints.length > 2) {
      // Fermer le polygone en réutilisant le premier point
      this.polygonPoints.push({ ...this.polygonPoints[0] });
      this.drawPolygon();
      this.polygonDrawing = false;
    } else {
      console.error('Nombre insuffisant de points pour fermer le polygone');
    }
  }

  // Fonction de dessin du polygone sur le canvas
  private drawPolygon(): void {
    if (!this.polygonCtx || !this.polygonCanvas) return;
    // Effacer le canvas
    this.polygonCtx.clearRect(0, 0, this.polygonCanvas.width, this.polygonCanvas.height);

    // 1. Dessiner l'image de fond (non floutée)
    if (this.backgroundImage) {
      this.polygonCtx.drawImage(
        this.backgroundImage,
        this.bgX,
        this.bgY,
        this.backgroundImage.width * this.bgScale,
        this.backgroundImage.height * this.bgScale
      );
    }

    // 2. Si au moins 3 points, appliquer le flou sur l'extérieur du polygone
    if (this.polygonPoints.length >= 3) {
      // Sauvegarder le contexte
      this.polygonCtx.save();
      this.polygonCtx.beginPath();
      // Dessiner un rectangle couvrant tout le canvas
      this.polygonCtx.rect(0, 0, this.polygonCanvas.width, this.polygonCanvas.height);
      // Dessiner le polygone (la zone à ne pas flouter)
      this.polygonCtx.moveTo(
        this.bgX + this.polygonPoints[0].x * this.bgScale,
        this.bgY + this.polygonPoints[0].y * this.bgScale
      );
      for (let i = 1; i < this.polygonPoints.length; i++) {
        this.polygonCtx.lineTo(
          this.bgX + this.polygonPoints[i].x * this.bgScale,
          this.bgY + this.polygonPoints[i].y * this.bgScale
        );
      }
      this.polygonCtx.closePath();
      // Utiliser la règle "evenodd" pour inverser le clipping
      this.polygonCtx.clip('evenodd');

      // Appliquer le flou et redessiner l'image dans la zone clipée (l'extérieur)
      this.polygonCtx.filter = 'blur(2px)'; // Ajustez la valeur du flou si nécessaire
      if (this.backgroundImage) {
        this.polygonCtx.drawImage(
          this.backgroundImage,
          this.bgX,
          this.bgY,
          this.backgroundImage.width * this.bgScale,
          this.backgroundImage.height * this.bgScale
        );
      }
      // Restaurer le contexte pour désactiver le clipping et le filtre
      this.polygonCtx.restore();
    }

    // 3. Tracer le contour du polygone (ou la polyline s'il y a moins de 3 points)
    if (this.polygonPoints.length > 0) {
      this.polygonCtx.beginPath();
      this.polygonCtx.moveTo(
        this.bgX + this.polygonPoints[0].x * this.bgScale,
        this.bgY + this.polygonPoints[0].y * this.bgScale
      );
      for (let i = 1; i < this.polygonPoints.length; i++) {
        this.polygonCtx.lineTo(
          this.bgX + this.polygonPoints[i].x * this.bgScale,
          this.bgY + this.polygonPoints[i].y * this.bgScale
        );
      }
      // Si au moins 3 points, fermer le chemin pour relier le dernier au premier
      if (this.polygonPoints.length >= 3) {
        this.polygonCtx.closePath();
      }
      this.polygonCtx.strokeStyle = '#FF0000';
      this.polygonCtx.lineWidth = 2;
      this.polygonCtx.stroke();
    }
  }

  // Méthode pour réinitialiser le tracé et commencer une nouvelle zone
  public startNewPolygon(): void {
    this.polygonPoints = [];
    this.polygonDrawing = true;
    this.drawPolygon();
  }

  // Méthode pour sauvegarder le polygone (ici, vous pouvez ensuite envoyer this.polygonPoints vers DynamoDB)
  public async savePolygon(): Promise<void> {
    console.info('Polygone enregistré :', this.polygonPoints);
    // Exemple d'enregistrement dans DynamoDB avec AWS SDK DocumentClient
    try {
      // Obtenir les credentials via Amplify
      const credentials = await Auth.currentCredentials();

      // Créer une instance du DocumentClient
      const dynamoDb = new AWS.DynamoDB.DocumentClient({
        region: 'eu-west-3', // Adaptez à votre région
        credentials,
      });

      // Préparer les paramètres pour l'insertion
      const params = {
        TableName: 'erige-cameras-prod',
        Key: {
          id: this.camera?.id, // supposé être la clé primaire de votre élément
        },
        UpdateExpression: 'SET polygonPoints = :p',
        ExpressionAttributeValues: {
          ':p': this.polygonPoints,
        },
      };
      // Enregistrer dans DynamoDB
      dynamoDb.update(params, (err, data) => {
        if (err) {
          console.error('Erreur lors de la mise à jour :', err);
        } else {
          console.log('Mise à jour réussie :', data);
        }
      });
      console.log('Coordonnées sauvegardées dans DynamoDB');
      this.hasSavedPolygon = true;
    } catch (error) {
      console.error("Erreur lors de l'enregistrement des coordonnées dans DynamoDB :", error);
    }
    // Fermer la modale
    this.closePolygonModal();
  }

  // Méthode pour fermer la modale de traçage
  public closePolygonModal(): void {
    if (!this.hasSavedPolygon) {
      this.polygonPoints = [...this.originalPolygonPoints]; // Restaurer les points originaux
    }
    (this.$refs.polygonModal as BModal).hide();
  }

  private triggerDatePicker(id: string): void {
    const inputElement = document.getElementById(id) as HTMLInputElement;
    if (inputElement) {
      inputElement.focus(); // Donne le focus à l'input
      inputElement.click(); // Simule un clic pour ouvrir le calendrier
    }
  }

  private loadImageAsDataURL(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'Anonymous'; // Pour éviter les problèmes CORS
      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d');
        if (ctx) {
          ctx.drawImage(img, 0, 0);
          const dataURL = canvas.toDataURL('image/png');
          resolve(dataURL);
        } else {
          reject('Canvas context not available');
        }
      };
      img.onerror = () => {
        reject('Failed to load image');
      };
      img.src = url;
    });
  }

  private async generateWeeklySafetyReportPDF() {
    if (!this.originalData || this.originalData.length === 0) {
      console.error('Aucune donnée disponible pour générer le rapport hebdomadaire.');
      if ((this as any).$bvToast) {
        this.$bvToast.toast(this.$t('ia.noDataForReport').toString(), {
          title: 'Info',
          variant: 'warning',
          solid: true,
        });
      }
      return;
    }

    // On force le mode sécurité (au cas où)
    this.modeSelected = 'Sécurité';

    // 👉 Date de référence :
    //  - si l’utilisateur a cliqué sur le graphique : weeklyClickedDate
    //  - sinon : dernière photo / dernier point
    const referenceDate =
      this.weeklyClickedDate ||
      this.lastPhotoDate ||
      this.originalData[this.originalData.length - 1].date ||
      new Date();

    const { start, end } = this.getWeeklyRangeFromDate(referenceDate);

    // Met à jour la plage de dates du composant (cohérence avec l’UI + graphique)
    this.startDate = this.formatDateForInput(start);
    this.endDate = this.formatDateForInput(end);

    // Filtrer et préparer les données sécurité
    const filtered = this.filterDataByDates(this.originalData);
    if (!filtered || filtered.length === 0) {
      // ...
    }

    const prepared = this.prepareSecurityData(filtered);
    const highlights = this.computeWeeklySafetyHighlights(prepared, 10);

    await this.generateWeeklySafetyHighlightsPDF(prepared, highlights, start, end);
  }

  private async generateWeeklySafetyHighlightsPDF(
    prepared: { xData: Date[]; aggregatedData: Record<string, number[]>; categories: any[] },
    highlights: SafetyHighlight[],
    start: Date,
    end: Date
  ) {
    // Logo
    const logoDataURL = await this.loadImageAsDataURL(logoImageWhite);

    const doc = new jsPDF({ orientation: 'landscape' });
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;
    const margin = 10;
    const totalPagesExp = '{total_pages_count_string}';
    const locale = (this as any).$i18n?.locale || 'fr';

    const projectName = this.project?.name || '-';
    const cameraName = this.camera?.name || '-';

    const addHeader = (pageDoc: jsPDF) => {
      // Bandeau haut de page
      pageDoc.setFillColor(0, 19, 38); // bleu foncé Erige
      pageDoc.rect(0, 0, pageWidth, 20, 'F');

      // Titre centré
      pageDoc.setFontSize(16);
      pageDoc.setTextColor(255, 255, 255);
      const titleStr = String(this.$t('ia.weeklySafetyReportTitle') || 'Rapport hebdomadaire sécurité');
      const titleWidth = pageWidth ? pageDoc.getTextWidth(titleStr) : 0;
      const xTitle = (pageWidth - titleWidth) / 2;
      pageDoc.text(titleStr, xTitle, 12);

      // Libellés projet / caméra (avec fallback au cas où la clé i18n n’existe pas)
      const projectLabel = String(this.$t('ia.project') || 'Projet');
      const cameraLabel = String(this.$t('ia.camera') || 'Caméra');

      // Projet à gauche
      pageDoc.setFontSize(10);
      pageDoc.text(`${projectLabel}: ${projectName}`, margin, 10);

      // Caméra juste en dessous
      pageDoc.text(`${cameraLabel}: ${cameraName}`, margin, 15);

      // Logo à droite
      const imgWidth = 40;
      const imgHeight = 12;
      const xPosition = pageWidth - imgWidth - margin;
      const yPosition = 4;
      pageDoc.addImage(logoDataURL, 'PNG', xPosition, yPosition, imgWidth, imgHeight);

      // Ligne colorée de séparation
      pageDoc.setDrawColor(95, 201, 228); // bleu clair
      pageDoc.setLineWidth(0.8);
      pageDoc.line(margin, 35, pageWidth - margin, 35);
    };

    const addFooter = (pageDoc: jsPDF, pageNumber: number) => {
      const currentDate = new Date().toLocaleDateString(locale);
      pageDoc.setFontSize(10);
      pageDoc.text(`${this.$t('ia.generatedOn')}: ${currentDate}`, margin, pageHeight - 10);
      const pageText = `${this.$t('ia.page')} ${pageNumber} / ${totalPagesExp}`;
      const pageTextWidth = pageDoc.getTextWidth(pageText);
      pageDoc.text(pageText, pageWidth - margin - pageTextWidth, pageHeight - 10);
    };

    addHeader(doc);
    addFooter(doc, 1);

    // ========= Résumé global + comparaisons =========
    const formattedStartDate = this.formatDate(start.toISOString(), locale);
    const formattedEndDate = this.formatDate(end.toISOString(), locale);

    // KPIs semaine courante
    const currentKpis = this.computeSecurityKPIsForRange(start, end);

    // Semaine précédente (J-7 à J-1)
    const prevWeekStart = new Date(start);
    prevWeekStart.setDate(prevWeekStart.getDate() - 7);
    prevWeekStart.setHours(0, 0, 0, 0);

    const prevWeekEnd = new Date(start);
    prevWeekEnd.setDate(prevWeekEnd.getDate() - 1);
    prevWeekEnd.setHours(23, 59, 59, 999);

    const previousKpis = this.computeSecurityKPIsForRange(prevWeekStart, prevWeekEnd);

    // Moyenne depuis le début de l’opération
    let opStart = this.firstPhotoDate
      ? new Date(this.firstPhotoDate)
      : this.originalData[0]?.date
      ? new Date(this.originalData[0].date)
      : new Date(start);
    opStart.setHours(0, 0, 0, 0);
    const operationKpis = this.computeSecurityKPIsForRange(opStart, end);

    const formatNumber = (value: number | null | undefined, decimals = 1): string => {
      if (value === null || value === undefined || isNaN(value as any)) {
        return 'N/A';
      }
      return value.toFixed(decimals);
    };

    const formatDelta = (
      current: number | null | undefined,
      reference: number | null | undefined,
      decimals = 1
    ): string => {
      if (
        current === null ||
        current === undefined ||
        reference === null ||
        reference === undefined ||
        reference === 0
      ) {
        return '–';
      }
      const diff = ((current - reference) / reference) * 100;
      const sign = diff > 0 ? '+' : '';
      return `${sign}${diff.toFixed(decimals)}%`;
    };

    doc.setFontSize(14);
    doc.setTextColor(0, 0, 128);
    doc.text(String(this.$t('ia.summary')), margin, 45);

    doc.setLineWidth(0.5);
    doc.line(margin, 50, pageWidth - margin, 50);

    doc.setFontSize(11);
    doc.setTextColor(0, 0, 0);
    doc.text(`${this.$t('ia.period')}: ${formattedStartDate} ${this.$t('ia.to')} ${formattedEndDate}`, margin, 60);

    // Tableau comparatif des KPI
    const bodyRows = [
      [
        String(this.$t('ia.averageNosafety')),
        currentKpis ? formatNumber(currentKpis.avgNoSafety) : 'N/A',
        previousKpis ? formatNumber(previousKpis.avgNoSafety) : 'N/A',
        formatDelta(currentKpis?.avgNoSafety, previousKpis?.avgNoSafety),
        operationKpis ? formatNumber(operationKpis.avgNoSafety) : 'N/A',
        formatDelta(currentKpis?.avgNoSafety, operationKpis?.avgNoSafety),
      ],
      [
        String(this.$t('ia.coactivity')),
        currentKpis ? formatNumber(currentKpis.avgCoactivity) : 'N/A',
        previousKpis ? formatNumber(previousKpis.avgCoactivity) : 'N/A',
        formatDelta(currentKpis?.avgCoactivity, previousKpis?.avgCoactivity),
        operationKpis ? formatNumber(operationKpis.avgCoactivity) : 'N/A',
        formatDelta(currentKpis?.avgCoactivity, operationKpis?.avgCoactivity),
      ],
      [
        String(this.$t('ia.totalFireEvents') || 'Événements feu/fumée'),
        currentKpis ? formatNumber(currentKpis.totalFire, 0) : 'N/A',
        previousKpis ? formatNumber(previousKpis.totalFire, 0) : 'N/A',
        formatDelta(currentKpis?.totalFire, previousKpis?.totalFire, 1),
        operationKpis ? formatNumber(operationKpis.totalFire, 0) : 'N/A',
        formatDelta(currentKpis?.totalFire, operationKpis?.totalFire, 1),
      ],
      [
        String(this.$t('ia.totalCarEvents') || 'Véhicules détectés'),
        currentKpis ? formatNumber(currentKpis.totalCar, 0) : 'N/A',
        previousKpis ? formatNumber(previousKpis.totalCar, 0) : 'N/A',
        formatDelta(currentKpis?.totalCar, previousKpis?.totalCar, 1),
        operationKpis ? formatNumber(operationKpis.totalCar, 0) : 'N/A',
        formatDelta(currentKpis?.totalCar, operationKpis?.totalCar, 1),
      ],
    ];

    (doc as any).autoTable({
      startY: 66,
      head: [
        [
          String(this.$t('ia.kpi') || 'KPI'),
          String(this.$t('ia.thisWeek') || 'Semaine en cours'),
          String(this.$t('ia.previousWeek') || 'Semaine précédente'),
          String(this.$t('ia.deltaVsPrevious') || 'Δ vs S-1'),
          String(this.$t('ia.sinceStartAvg') || 'Moy. depuis début'),
          String(this.$t('ia.deltaVsOperation') || 'Δ vs moy. op.'),
        ],
      ],
      body: bodyRows,
      theme: 'striped',
      styles: {
        fontSize: 9,
        cellPadding: 2,
      },
      headStyles: {
        fillColor: [0, 19, 38],
        textColor: [255, 255, 255],
      },
      alternateRowStyles: {
        fillColor: [240, 246, 255],
      },
      columnStyles: {
        0: { cellWidth: 45 },
      },
    });

    const lastTable = (doc as any).lastAutoTable;
    const afterTableY = lastTable && lastTable.finalY ? lastTable.finalY : 110;

    // ========= Petit graphique stacké sur la période =========
    if (prepared.xData.length > 0) {
      const safetyTraces = this.createSecurityTraces(prepared);
      const safetyLayout = this.createSecurityLayout();
      safetyLayout.title = {
        text: String(this.$t('ia.safetyTrends')),
        x: 0.5,
        xanchor: 'center',
      };
      safetyLayout.paper_bgcolor = 'white';
      safetyLayout.plot_bgcolor = 'white';

      const config = this.createConfig();

      const plotDiv = document.createElement('div');
      await Plotly.newPlot(plotDiv, safetyTraces as Plotly.Data[], safetyLayout, config);
      const safetyChartImage = await Plotly.toImage(plotDiv, {
        format: 'jpeg',
        width: 1600,
        height: 900,
      });

      const chartTitleY = afterTableY + 10;
      const chartLineY = chartTitleY + 3;
      const chartImageY = chartLineY + 5;
      const chartImageHeight = pageHeight - chartImageY - 15;

      doc.setFontSize(13);
      doc.setTextColor(0, 0, 128);
      doc.text(String(this.$t('ia.mainSafetyChart')), margin, chartTitleY);

      doc.setLineWidth(0.5);
      doc.line(margin, chartLineY, pageWidth - margin, chartLineY);

      doc.addImage(safetyChartImage, 'JPEG', margin, chartImageY, pageWidth - 2 * margin, chartImageHeight);
    }

    // ========= Page Highlights =========
    doc.addPage();
    addHeader(doc);
    addFooter(doc, doc.getNumberOfPages());

    doc.setFontSize(14);
    doc.setTextColor(0, 0, 128);
    doc.text(String(this.$t('ia.weeklyHighlightsTitle') || 'Moments clés de la semaine'), margin, 45);

    doc.setLineWidth(0.5);
    doc.line(margin, 48, pageWidth - margin, 48);

    if (!highlights || highlights.length === 0) {
      doc.setFontSize(12);
      doc.setTextColor(0, 0, 0);
      doc.text(
        String(this.$t('ia.noHighlights') || 'Aucun événement significatif détecté sur la période.'),
        margin,
        60
      );
    } else {
      const maxHighlights = 10;
      const trimmed = highlights.slice(0, maxHighlights);

      // Pré-chargement des images
      const highlightImages: (string | null)[] = await Promise.all(
        trimmed.map(async (h) => {
          try {
            if (!h.photoIds || h.photoIds.length === 0) return null;
            const photoId = h.photoIds[0];

            // 1️⃣ On tente d’abord la version annotée
            const annotated = await this.getAnnotatedSafetyImageDataURL(photoId);
            if (annotated) return annotated;

            // 2️⃣ Fallback sur la photo brute si rien trouvé
            const match = this.originalData.find((d: any) => d.photoId === photoId && d.imageUrl);
            if (!match || !match.imageUrl) return null;

            return await this.loadImageAsDataURL(match.imageUrl);
          } catch (e) {
            console.error('Erreur chargement image highlight :', e);
            return null;
          }
        })
      );

      // Configuration du tableau
      const colWidth = (pageWidth - margin * 2) / 2;
      const imageHeight = 90;
      const textHeight = 25;
      const cellHeight = imageHeight + textHeight + 6;

      // 2) On commence le tableau plus haut
      const highlightsStartY = 60; // au lieu de 70
      let currentY = highlightsStartY;

      // 3) Zone utile en bas (on garde 20mm de marge)
      const usableBottomY = pageHeight - 20;

      // Parcourir les highlights par paires (gauche/droite)
      for (let i = 0; i < trimmed.length; i += 2) {
        // Vérifier si on a besoin d'une nouvelle page
        if (currentY + cellHeight > usableBottomY) {
          doc.addPage();
          addHeader(doc);
          addFooter(doc, doc.getNumberOfPages());
          currentY = highlightsStartY; // on repart à la même hauteur sur la nouvelle page
        }

        // Highlight gauche
        const leftHighlight = trimmed[i];
        const leftImg = highlightImages[i];

        // Highlight droite (si existe)
        const rightHighlight = trimmed[i + 1];
        const rightImg = highlightImages[i + 1];

        // Dessiner les bordures des cellules
        doc.setDrawColor(200, 200, 200);
        doc.setLineWidth(0.5);

        // Cellule gauche
        doc.rect(margin, currentY, colWidth, cellHeight);

        // Cellule droite (si existe)
        if (rightHighlight) {
          doc.rect(margin + colWidth, currentY, colWidth, cellHeight);
        }

        // === CELLULE GAUCHE ===
        if (leftImg) {
          try {
            // Image centrée en haut de la cellule
            const imgX = margin + 2;
            const imgWidth = colWidth - 4;
            doc.addImage(leftImg, 'PNG', imgX, currentY + 2, imgWidth, imageHeight);
          } catch (e) {
            console.error('Erreur addImage highlight gauche :', e);
          }
        }

        // Texte en bas de la cellule gauche
        const leftDateLabel = this.formatDate(leftHighlight.date.toISOString(), locale);
        const leftTypeLabel = this.getHighlightTypeLabel(leftHighlight.type);
        const leftMetricsText =
          `no_safety: ${leftHighlight.metrics.no_safety.toFixed(1)} · ` +
          `coactivity: ${leftHighlight.metrics.coactivity.toFixed(1)}\n` +
          `fire: ${leftHighlight.metrics.fire.toFixed(1)} · ` +
          `car: ${leftHighlight.metrics.car.toFixed(1)}`;

        doc.setFontSize(9);
        doc.setTextColor(0, 0, 0);
        const leftTextY = currentY + imageHeight + 5;
        doc.text(`${i + 1}. ${leftDateLabel}`, margin + 2, leftTextY);
        doc.text(leftTypeLabel, margin + 2, leftTextY + 4);
        doc.setFontSize(8);
        doc.text(leftMetricsText, margin + 2, leftTextY + 8, {
          maxWidth: colWidth - 4,
        });

        // === CELLULE DROITE ===
        if (rightHighlight) {
          if (rightImg) {
            try {
              const imgX = margin + colWidth + 2;
              const imgWidth = colWidth - 4;
              doc.addImage(rightImg, 'PNG', imgX, currentY + 2, imgWidth, imageHeight);
            } catch (e) {
              console.error('Erreur addImage highlight droit :', e);
            }
          }

          const rightDateLabel = this.formatDate(rightHighlight.date.toISOString(), locale);
          const rightTypeLabel = this.getHighlightTypeLabel(rightHighlight.type);
          const rightMetricsText =
            `no_safety: ${rightHighlight.metrics.no_safety.toFixed(1)} · ` +
            `coactivity: ${rightHighlight.metrics.coactivity.toFixed(1)}\n` +
            `fire: ${rightHighlight.metrics.fire.toFixed(1)} · ` +
            `car: ${rightHighlight.metrics.car.toFixed(1)}`;

          doc.setFontSize(9);
          doc.setTextColor(0, 0, 0);
          const rightTextY = currentY + imageHeight + 5;
          doc.text(`${i + 2}. ${rightDateLabel}`, margin + colWidth + 2, rightTextY);
          doc.text(rightTypeLabel, margin + colWidth + 2, rightTextY + 4);
          doc.setFontSize(8);
          doc.text(rightMetricsText, margin + colWidth + 2, rightTextY + 8, {
            maxWidth: colWidth - 4,
          });
        }

        // Passer à la ligne suivante
        currentY += cellHeight + 2;
      }
    }

    if (typeof (doc as any).putTotalPages === 'function') {
      (doc as any).putTotalPages(totalPagesExp);
    }

    const startStr = `${start.getFullYear()}-${('0' + (start.getMonth() + 1)).slice(-2)}-${(
      '0' + start.getDate()
    ).slice(-2)}`;
    const endStr = `${end.getFullYear()}-${('0' + (end.getMonth() + 1)).slice(-2)}-${('0' + end.getDate()).slice(-2)}`;

    const fileName = `rapport-securite-hebdo-${startStr}-${endStr}.pdf`;
    doc.save(fileName);
  }

  private computeSecurityKPIsForRange(start: Date, end: Date): SecurityKPIs | null {
    if (!this.originalData || !this.originalData.length) {
      return null;
    }

    const slice = this.originalData.filter((d: any) => {
      const date = d.date instanceof Date ? d.date : new Date(d.date);
      return date >= start && date <= end;
    });

    if (!slice.length) {
      return null;
    }

    let sumNoSafety = 0;
    let sumCoactivity = 0;
    let sumFire = 0;
    let sumCar = 0;

    slice.forEach((d: any) => {
      sumNoSafety += Number(d.no_safety ?? 0);
      sumCoactivity += Number(d.coactivity ?? 0);
      sumFire += Number(d.fire ?? 0);
      sumCar += Number(d.car ?? 0);
    });

    const n = slice.length;

    return {
      avgNoSafety: n ? sumNoSafety / n : 0,
      avgCoactivity: n ? sumCoactivity / n : 0,
      totalFire: sumFire,
      totalCar: sumCar,
    };
  }

  private async generateReportPDF() {
    if (!this.originalData || this.originalData.length === 0) {
      console.error('Aucune donnée disponible pour générer le rapport.');
      return;
    }

    // Importation du logo
    const logoDataURL = await this.loadImageAsDataURL(logoImage);

    // Initialisation de jsPDF en mode paysage
    const doc = new jsPDF({ orientation: 'landscape' });
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;
    const margin = 10;

    const totalPagesExp = '{total_pages_count_string}';

    // Déterminer la locale pour le formatage des dates
    const locale = this.$i18n.locale; // Par exemple, 'fr', 'en', 'it', 'de', 'es'

    // Fonctions pour ajouter l'en-tête et le pied de page
    const addHeader = (doc: jsPDF) => {
      doc.setFontSize(18);
      doc.setTextColor(0, 0, 128);
      const title =
        this.modeSelected === 'Sécurité' ? this.$t('ia.securityReportTitle') : this.$t('ia.activityReportTitle');
      const titleStr = String(title);
      const titleWidth = doc.getTextWidth(titleStr);
      const xTitle = (pageWidth - titleWidth) / 2;
      doc.text(titleStr, xTitle, 20);
      doc.setFontSize(12);
      doc.setTextColor(0, 0, 0);
      doc.text(`${this.$t('ia.project')}: ${this.project?.name}`, margin, 20);

      // Ajout du logo en haut à droite
      const imgWidth = 40;
      const imgHeight = 10;
      const xPosition = pageWidth - imgWidth - margin;
      const yPosition = margin;
      doc.addImage(logoDataURL, 'PNG', xPosition, yPosition, imgWidth, imgHeight);

      // Ligne séparatrice
      doc.setLineWidth(0.5);
      doc.line(margin, 45, pageWidth - margin, 45);
    };

    const addFooter = (doc: jsPDF, pageNumber: number) => {
      const currentDate = new Date().toLocaleDateString(locale);
      doc.setFontSize(10);
      doc.text(`${this.$t('ia.generatedOn')}: ${currentDate}`, margin, pageHeight - 10);
      const pageText = `${this.$t('ia.page')} ${pageNumber} / ${totalPagesExp}`;
      const pageTextWidth = doc.getTextWidth(pageText);
      doc.text(pageText, pageWidth - margin - 20, pageHeight - 10);
    };

    // Ajout de l'en-tête et du pied de page à la première page
    addHeader(doc);
    addFooter(doc, 1);

    // Préparation des données pour le rapport
    const preparedData = this.prepareData(this.originalData);
    const { xData, aggregatedData, categories } = preparedData;

    if (this.modeSelected === 'Sécurité') {
      // --- Rapport pour le mode Sécurité ---
      // Calcul des statistiques pour le résumé exécutif
      const totalSafetyDetections = this.originalData.reduce((total, item) => {
        return total + (item.no_safety || 0) + (item.fire || 0) + (item.coactivity || 0) + (item.car || 0);
      }, 0);

      const safetyLabelCounts = {
        no_safety: aggregatedData['no_safety']?.reduce((sum: number, val: number) => sum + val, 0) || 0,
        fire: aggregatedData['fire']?.reduce((sum: number, val: number) => sum + val, 0) || 0,
        coactivity: aggregatedData['coactivity']?.reduce((sum: number, val: number) => sum + val, 0) || 0,
        car: aggregatedData['car']?.reduce((sum: number, val: number) => sum + val, 0) || 0,
      };

      const topSafetyLabels = Object.entries(safetyLabelCounts)
        .sort((a, b) => b[1] - a[1])
        .slice(0, 4)
        .map(([label]) => this.$t(`ia.${label}`))
        .join(', ');

      // Résumé exécutif
      doc.setFontSize(14);
      doc.setTextColor(0, 0, 128);
      doc.text(String(this.$t('ia.summary')), margin, 55);

      doc.setLineWidth(0.5);
      doc.line(margin, 60, pageWidth - margin, 60);

      doc.setFontSize(12);
      doc.setTextColor(0, 0, 0);
      const formattedStartDate = this.formatDate(this.startDate ?? '', locale);
      const formattedEndDate = this.formatDate(this.endDate ?? '', locale);
      doc.text(`${this.$t('ia.period')}: ${formattedStartDate} ${this.$t('ia.to')} ${formattedEndDate}`, margin, 68);
      doc.text(`${this.$t('ia.totalSafetyDetections')}: ${totalSafetyDetections.toFixed(0)}`, margin, 78);
      doc.text(`${this.$t('ia.topSafetyLabels')}: ${topSafetyLabels || this.$t('ia.none')}`, margin, 88);

      // Scores de sécurité
      doc.setFontSize(13);
      doc.setTextColor(0, 0, 128);
      doc.text(String(this.$t('ia.scores')), margin, 108);

      doc.setLineWidth(0.5);
      doc.line(margin, 111, pageWidth - margin, 111);

      doc.setFontSize(12);
      doc.setTextColor(0, 0, 0);
      doc.text(
        `${this.$t('ia.no_safety')}: ${this.lastNosafetyScore?.toFixed(1) || 'N/A'} / ${
          this.leftNosafetyScore?.toFixed(1) || 'N/A'
        } (${this.nosafetyVariation > 0 ? '+' : ''}${this.nosafetyVariation.toFixed(1)}%)`,
        margin,
        121
      );
      doc.text(
        `${this.$t('ia.fire')}: ${this.lastFireScore?.toFixed(1) || 'N/A'} / ${
          this.leftFireScore?.toFixed(1) || 'N/A'
        } (${this.fireVariation > 0 ? '+' : ''}${this.fireVariation.toFixed(1)}%)`,
        margin,
        131
      );
      doc.text(
        `${this.$t('ia.coactivity')}: ${this.lastCoactivityScore?.toFixed(1) || 'N/A'} / ${
          this.leftCoactivityScore?.toFixed(1) || 'N/A'
        } (${this.coactivityVariation > 0 ? '+' : ''}${this.coactivityVariation.toFixed(1)}%)`,
        margin,
        141
      );
      doc.text(`${this.$t('ia.car')}: ${safetyLabelCounts.car}`, margin, 151);

      // Saut de page
      doc.addPage();
      addHeader(doc);
      addFooter(doc, doc.getNumberOfPages());

      // Graphique principal pour la sécurité
      const safetyTraces = [
        this.createLabelTrace(preparedData, 'no_safety'),
        this.createLabelTrace(preparedData, 'fire'),
        this.createLabelTrace(preparedData, 'coactivity'),
        this.createLabelTrace(preparedData, 'car'),
      ].filter((trace) => Array.isArray(trace.y) && trace.y.some((val: any) => typeof val === 'number' && val > 0)); // Filtrer les traces vides
      const safetyLayout = this.createLayout();
      safetyLayout.title = { text: String(this.$t('ia.safetyTrends')), x: 0.5, xanchor: 'center' };
      safetyLayout.paper_bgcolor = 'white';
      safetyLayout.plot_bgcolor = 'white';
      const config = this.createConfig();

      const plotDiv = document.createElement('div');
      await Plotly.newPlot(plotDiv, safetyTraces as Plotly.Data[], safetyLayout, config);
      const safetyChartImage = await Plotly.toImage(plotDiv, {
        format: 'jpeg',
        width: 2000,
        height: 1200,
      });

      doc.setFontSize(13);
      doc.setTextColor(0, 0, 128);
      doc.text(String(this.$t('ia.mainSafetyChart')), margin, 50);

      doc.setLineWidth(0.5);
      doc.line(margin, 53, pageWidth - margin, 53);

      doc.addImage(safetyChartImage, 'JPEG', margin, 60, pageWidth - 2 * margin, pageHeight - 80);

      // Graphiques individuels pour chaque métrique de sécurité
      const safetyLabels = ['no_safety', 'fire', 'coactivity', 'car'];
      for (const label of safetyLabels) {
        doc.addPage();
        addHeader(doc);
        addFooter(doc, doc.getNumberOfPages());

        const labelTrace = this.createLabelTrace(preparedData, label);
        const labelLayout = this.createLayoutForLabel(label);
        await Plotly.newPlot(plotDiv, [labelTrace as Plotly.Data], labelLayout, config);

        const labelImage = await Plotly.toImage(plotDiv, {
          format: 'jpeg',
          width: 2000,
          height: 1200,
        });

        doc.setFontSize(13);
        doc.setTextColor(0, 0, 128);
        doc.text(`${this.$t('ia.labelTrend')} ${this.$t(`ia.${label}`)}`, margin, 50);

        doc.setLineWidth(0.5);
        doc.line(margin, 53, pageWidth - margin, 53);

        doc.addImage(labelImage, 'JPEG', margin, 60, pageWidth - 2 * margin, pageHeight - 80);
      }

      // Conclusion
      doc.addPage();
      addHeader(doc);
      addFooter(doc, doc.getNumberOfPages());

      doc.setFontSize(14);
      doc.setTextColor(0, 0, 128);
      doc.text(String(this.$t('ia.conclusion')), margin, 50);

      doc.setLineWidth(0.5);
      doc.line(margin, 53, pageWidth - margin, 53);

      doc.setFontSize(12);
      doc.setTextColor(0, 0, 0);
      doc.text(String(this.$t('ia.safetyConclusion')), margin, 63, { maxWidth: pageWidth - 2 * margin });
    } else {
      // --- Rapport pour le mode Activité/Détection (logique existante) ---

      // Calcul des statistiques pour le résumé exécutif
      let averageActivityScore = 0;
      if (this.lastActivityScore !== null && this.leftActivityScore !== null) {
        averageActivityScore = (this.lastActivityScore + this.leftActivityScore) / 2;
      }

      const activityVariation =
        this.leftActivityScore !== null && this.leftActivityScore !== 0 && this.lastActivityScore !== null
          ? ((this.lastActivityScore - this.leftActivityScore) / this.leftActivityScore) * 100
          : 0;

      const totalDetections = this.originalData.reduce((total, item) => {
        return (
          total +
          categories.reduce((sum, { key }) => {
            return sum + item[key];
          }, 0)
        );
      }, 0);
      const labelCounts = categories.reduce((acc, { key }) => {
        acc[key] = aggregatedData[key].reduce((sum: number, val: number) => sum + val, 0);
        return acc;
      }, {} as Record<string, number>);

      const topLabels = Object.entries(labelCounts)
        .sort((a, b) => b[1] - a[1])
        .slice(0, 5)
        .map(([label]) => label)
        .join(', ');

      // Résumé exécutif
      doc.setFontSize(14);
      doc.setTextColor(0, 0, 128);
      doc.text(String(this.$t('ia.summary')), margin, 55);

      doc.setLineWidth(0.5);
      doc.line(margin, 60, pageWidth - margin, 60);

      doc.setFontSize(12);
      doc.setTextColor(0, 0, 0);
      const formattedStartDate = this.formatDate(this.startDate ?? '', locale);
      const formattedEndDate = this.formatDate(this.endDate ?? '', locale);
      doc.text(`${this.$t('ia.period')}: ${formattedStartDate} ${this.$t('ia.to')} ${formattedEndDate}`, margin, 68);
      doc.text(`${this.$t('ia.averageActivityScore')}: ${averageActivityScore.toFixed(2)}`, margin, 78);
      doc.text(`${this.$t('ia.totalDetections')}: ${totalDetections.toFixed(0)}`, margin, 88);
      doc.text(`${this.$t('ia.topLabels')}: ${topLabels}`, margin, 98);

      // Scores
      doc.setFontSize(13);
      doc.setTextColor(0, 0, 128);
      doc.text(String(this.$t('ia.scores')), margin, 123);

      doc.setLineWidth(0.5);
      doc.line(margin, 126, pageWidth - margin, 126);

      doc.setFontSize(12);
      doc.setTextColor(0, 0, 0);
      doc.text(
        `${this.$t('ia.activityScore')}: ${this.lastActivityScore?.toFixed(1)} / ${this.leftActivityScore?.toFixed(1)}`,
        margin,
        136
      );
      doc.text(
        `${this.$t('ia.densityScore')}: ${this.lastDensityScore?.toFixed(1)} / ${this.leftDensityScore?.toFixed(1)}`,
        margin,
        146
      );
      doc.text(
        `${this.$t('ia.personScore')}: ${this.lastPersonScore?.toFixed(1)} / ${this.leftPersonScore?.toFixed(1)}`,
        margin,
        156
      );
      doc.text(
        `${this.$t('ia.helmetScore')}: ${this.lastHelmetScore?.toFixed(1)}% / ${this.leftHelmetScore?.toFixed(1)}%`,
        margin,
        166
      );

      // Saut de page
      doc.addPage();
      addHeader(doc);
      addFooter(doc, doc.getNumberOfPages());

      // Graphique principal
      const fullTraces = this.createTraces(preparedData, true);
      const fullLayout = this.createLayout();
      fullLayout.paper_bgcolor = 'white';
      fullLayout.plot_bgcolor = 'white';
      const config = this.createConfig();

      const plotDiv = document.createElement('div');
      await Plotly.newPlot(plotDiv, fullTraces as Plotly.Data[], fullLayout, config);
      const fullChartImage = await Plotly.toImage(plotDiv, {
        format: 'jpeg',
        width: 2000,
        height: 1200,
      });

      doc.setFontSize(13);
      doc.setTextColor(0, 0, 128);
      doc.text(String(this.$t('ia.mainChart')), margin, 50);

      doc.setLineWidth(0.5);
      doc.line(margin, 53, pageWidth - margin, 53);

      doc.addImage(fullChartImage, 'JPEG', margin, 60, pageWidth - 2 * margin, pageHeight - 80);

      // Graphique Activité & Densité
      doc.addPage();
      addHeader(doc);
      addFooter(doc, doc.getNumberOfPages());

      let yOffset = 50;

      const activityDensityTraces = this.createActivityDensityTraces(preparedData);
      const activityDensityLayout = this.createLayout();
      activityDensityLayout.paper_bgcolor = 'white';
      activityDensityLayout.plot_bgcolor = 'white';
      await Plotly.newPlot(plotDiv, activityDensityTraces, activityDensityLayout, config);
      const activityDensityImage = await Plotly.toImage(plotDiv, {
        format: 'jpeg',
        width: 2000,
        height: 1200,
      });

      doc.setFontSize(13);
      doc.setTextColor(0, 0, 128);
      doc.text(this.$t('ia.activityDensityChart').toString(), margin, yOffset);

      doc.setLineWidth(0.5);
      doc.line(margin, yOffset + 3, pageWidth - margin, yOffset + 3);

      yOffset += 10;

      doc.addImage(activityDensityImage, 'JPEG', margin, yOffset, pageWidth - 2 * margin, pageHeight - yOffset - 30);

      // Graphique Personnes & Ratio Casque/Personne
      doc.addPage();
      addHeader(doc);
      addFooter(doc, doc.getNumberOfPages());

      yOffset = 50;

      const personAndHelmetRatioTraces = this.createPersonAndHelmetRatioGraph(preparedData);
      const personAndHelmetRatioLayout = this.createLayoutForPersonAndHelmetRatio();
      await Plotly.newPlot(plotDiv, personAndHelmetRatioTraces, personAndHelmetRatioLayout, config);
      const personAndHelmetRatioImage = await Plotly.toImage(plotDiv, {
        format: 'jpeg',
        width: 2000,
        height: 1200,
      });

      doc.setFontSize(13);
      doc.setTextColor(0, 0, 128);
      doc.text(this.$t('ia.personHelmetChart').toString(), margin, yOffset);

      doc.setLineWidth(0.5);
      doc.line(margin, yOffset + 3, pageWidth - margin, yOffset + 3);

      yOffset += 10;

      doc.addImage(
        personAndHelmetRatioImage,
        'JPEG',
        margin,
        yOffset,
        pageWidth - 2 * margin,
        pageHeight - yOffset - 30
      );

      // Graphiques individuels pour chaque label
      const labels = [
        'toupie',
        'crane',
        'nacelle',
        'pelle',
        'person',
        'benne',
        'compacteuse',
        'mobilecrane',
        'camion',
        'foreuse',
      ];

      for (const label of labels) {
        doc.addPage();
        addHeader(doc);
        addFooter(doc, doc.getNumberOfPages());

        const labelTrace = this.createLabelTrace(preparedData, label);
        const labelLayout = this.createLayoutForLabel(label);
        await Plotly.newPlot(plotDiv, [labelTrace as Plotly.Data], labelLayout, config);

        const labelImage = await Plotly.toImage(plotDiv, {
          format: 'jpeg',
          width: 2000,
          height: 1200,
        });

        doc.setFontSize(13);
        doc.setTextColor(0, 0, 128);
        doc.text(`${this.$t('ia.labelTrend')} ${label}`, margin, yOffset);

        doc.setLineWidth(0.5);
        doc.line(margin, yOffset + 3, pageWidth - margin, yOffset + 3);

        yOffset += 10;

        doc.addImage(labelImage, 'JPEG', margin, yOffset, pageWidth - 2 * margin, pageHeight - yOffset - 30);
      }

      // Conclusion
      doc.addPage();
      addHeader(doc);
      addFooter(doc, doc.getNumberOfPages());

      doc.setFontSize(14);
      doc.setTextColor(0, 0, 128);
      doc.text(this.$t('ia.conclusion').toString(), margin, 50);

      doc.setLineWidth(0.5);
      doc.line(margin, 53, pageWidth - margin, 53);

      doc.setFontSize(12);
      doc.text(this.$t('ia.activityConclusion').toString(), margin, 63, { maxWidth: pageWidth - 2 * margin });
    }

    // Finalisation du PDF
    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp);
    }

    // Sauvegarde et téléchargement du PDF
    const fileName =
      this.modeSelected === 'Sécurité'
        ? `rapport-securite-${this.startDate}-${this.endDate}.pdf`
        : `rapport-activite-${this.startDate}-${this.endDate}.pdf`;
    doc.save(fileName);
  }

  private createActivityDensityTraces(data: { xData: Date[]; aggregatedData: any; categories: any[] }): Plotly.Data[] {
    const { xData, aggregatedData } = data;

    // Trace pour l'activité pondérée
    const weightedActivityTrace: Partial<Plotly.ScatterData> = {
      x: xData,
      y: aggregatedData['weightedActivity'],
      type: 'scatter',
      mode: 'lines',
      name: 'Activité',
      line: {
        color: '#d8ff00',
        width: 3,
        shape: 'spline',
        smoothing: 0.5,
      },
      hovertemplate: 'Activité: %{y}<extra></extra>',
    };

    // Trace pour la densité
    const densityTrace: Partial<Plotly.ScatterData> = {
      x: xData,
      y: aggregatedData['density'],
      type: 'scatter',
      mode: 'lines',
      name: 'Densité',
      line: {
        color: '#ff4d4d',
        width: 3,
        shape: 'spline',
        smoothing: 0.5,
      },
      hovertemplate: 'Densité: %{y}<extra></extra>',
    };

    // Trace pour le mouvement
    const movementTrace: Partial<Plotly.ScatterData> = {
      x: xData,
      y: aggregatedData['movement'],
      type: 'scatter',
      mode: 'lines',
      name: 'Mouvement',
      line: {
        color: '#ff4d4d',
        width: 3,
        shape: 'spline',
        smoothing: 0,
      },
      hovertemplate: 'Mouvement: %{y}<extra></extra>',
      yaxis: 'y2',
    };

    return [weightedActivityTrace, densityTrace, movementTrace] as Plotly.Data[];
  }

  private createLabelTrace(
    data: { xData: Date[]; aggregatedData: any; categories: any[] },
    label: string
  ): Partial<Plotly.PlotData> {
    const labelColors: { [key: string]: string } = {
      toupie: '#0DFF72',
      crane: '#00D2FF',
      nacelle: '#ff8915',
      pelle: '#d8ff5a',
      person: '#4dffcd',
      benne: '#FF007F',
      compacteuse: '#00FFCC',
      mobilecrane: '#AA00FF',
      camion: '#4e7bff',
      foreuse: '#33FF00',
      density: '#FF00B3',
      movement: '#3c7eff',
      helmet: '#ffffff',
      excavation: '#FF9900',
      filet: '#00FF00',
      gc: '#0000FF',
      heras: '#00FFFF',
      no_safety: '#FF0000',
      rubalise: '#FFD700',
      coactivity: '#FFA500',
      fire: '#ff0000',
      car: '#00BFFF',
    };
    return {
      x: data.xData,
      y: data.aggregatedData[label],
      type: 'bar',
      name: label,
      marker: {
        color: labelColors[label] || '#000000',
      }, // Now using 'label' to access the correct color
    };
  }

  private createLayoutForLabel(label: string): Partial<Plotly.Layout> {
    return {
      title: `Évolution du label : ${label}`,
      xaxis: {
        title: 'Date',
        type: 'date' as Plotly.AxisType,
      },
      yaxis: {
        title: 'Nombre',
      },
      bargap: 0.05,
      autosize: true,
      margin: { l: 50, r: 50, t: 50, b: 50 },
    };
  }

  private createPersonAndHelmetRatioGraph(data: { xData: Date[]; aggregatedData: any }): Plotly.Data[] {
    const { xData, aggregatedData } = data;

    // Barres des personnes
    const personBarTrace: Partial<Plotly.PlotData> = {
      x: xData,
      y: aggregatedData['person'], // Nombre de personnes détectées
      type: 'bar',
      name: 'Personnes',
      hovertemplate: 'Personnes: %{y}<extra></extra>',
      marker: {
        color: '#FFFF33', // Jaune fluo pour les personnes
      },
    };

    // Courbe du ratio casque/personne en pointillé
    const helmetPersonRatio = aggregatedData['person'].map((personCount: number, index: number) => {
      const helmetCount = aggregatedData['helmet'][index];
      const vestCount = aggregatedData['vest'][index];

      if (personCount > 0) {
        return ((helmetCount * 2 + vestCount) / (3 * personCount)) * 100;
      } else {
        // Lorsque aucune personne n'est détectée
        if (helmetCount > 0) {
          // Cas improbable où aucun individu n'est détecté mais des casques le sont
          return 100;
        } else {
          // Aucune personne et aucun casque détectés
          return 100;
        }
      }
    });

    const helmetPersonRatioTrace: Partial<Plotly.ScatterData> = {
      x: xData,
      y: helmetPersonRatio,
      type: 'scatter',
      mode: 'lines',
      name: 'Ratio Casque/Personne',
      line: {
        color: '#FFA500', // Orange néon pour la courbe
        width: 2,
        dash: 'dash', // Ligne pointillée
        shape: 'spline',
        smoothing: 0.5,
      },
      hovertemplate: 'Sécurité EPI: %{y} %<extra></extra>',
      yaxis: 'y2', // Utiliser un axe secondaire
    };

    // Retourner les deux traces dans un tableau avec le bon typage
    return [personBarTrace, helmetPersonRatioTrace] as Plotly.Data[];
  }

  private createLayoutForPersonAndHelmetRatio() {
    return {
      barmode: 'stack',
      bargap: 0.05,
      modebar: {
        orientation: 'v',
        bgcolor: '#001a35',
        color: '#6c757d',
        activecolor: '#5fc9e4',
      },
      xaxis: {
        color: '#5fc9e4',
        gridcolor: '#314a644a',
        type: 'date',
        tickformat: '%d/%m/%Y',
      },
      yaxis: {
        color: '#5fc9e4',
        gridcolor: '#314a644a',
        title: {
          text: 'Nombre total de personnes',
        },
        anchor: 'x',
        domain: [0, 1],
      },
      yaxis2: {
        title: 'Port EPI (%)',
        overlaying: 'y',
        side: 'right',
        tickformat: '.2f',
        range: [0, 120],
        showgrid: false,
        color: 'cyan',
        anchor: 'x',
        domain: [0, 1],
      },
      autosize: true,
      margin: {
        l: 50,
        r: 100,
        b: 31,
        t: 10,
        pad: 0,
      },
      paper_bgcolor: 'white',
      plot_bgcolor: 'white',
      legend: {
        x: 0,
        xanchor: 'left' as const,
        y: 1.04,
        yanchor: 'middle' as const,
        orientation: 'h' as const,
        font: {
          color: '#5fc9e4',
        },
      },
    } as Partial<Plotly.Layout>;
  }

  private setDateRange(days: number): void {
    this.updatingFromDateRange = true;
    this.selectedRange = days.toString(); // Met à jour la variable pour montrer le bouton actif
    if (this.lastPhotoDate) {
      const startDate = new Date(this.lastPhotoDate);
      startDate.setDate(startDate.getDate() - days);
      this.startDate = this.formatDateForInput(startDate);

      // Ajuster la date de fin pour inclure toute la journée
      const endDate = new Date(this.lastPhotoDate);
      endDate.setHours(23, 59, 59, 999);
      this.endDate = this.formatDateForInput(endDate);

      if (this.modeSelected === 'Sécurité') {
        this.createSecurityChart();
      } else {
        this.createChart();
      }
    }
    this.updatingFromDateRange = false;
  }

  private resetButtonSelection(): void {
    this.selectedRange = null;
  }

  get currentPhoto(): Photo | null {
    if (this.selectedPhotos && this.selectedPhotos.length > 0) {
      return this.selectedPhotos[0];
    }
    if (this.dataImagesKey.length > 0) {
      return this.dataImagesKey[this.dataImagesKey.length - 1].data;
    }
    return null;
  }

  get currentPhotoDateLabel(): string | null {
    const photo = this.currentPhoto;
    if (!photo) return null;

    const locale = (this as any).$i18n?.locale || 'fr';
    const d = new Date(photo.createdAt);

    return d.toLocaleString(locale, {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  }

  private async loadBoundingBoxImages(selectedPhoto: Photo): Promise<void> {
    this.selectedPhotos = [selectedPhoto];
    if (!selectedPhoto?.key) {
      console.warn('Pas de photo sélectionnée');
      return;
    }

    let photoKey = selectedPhoto.key;
    if (photoKey.startsWith('public/')) {
      photoKey = photoKey.substring('public/'.length);
    }
    const baseName = photoKey.split('/').pop()!.split('.')[0];
    const directory = photoKey.substring(0, photoKey.lastIndexOf('/'));

    try {
      let allFiles: { key: string }[] = [];

      if (this.modeSelected === 'Sécurité') {
        // Lister à la fois Segmentation ET coactivity
        const segFolder = `${directory}/IA/${baseName}/Segmentation/`;
        const coactivityFolder = `${directory}/IA/${baseName}/coactivity/`;

        const segFiles = (await Storage.list(segFolder, { level: 'public' })) as any[];
        const coactivityFiles = (await Storage.list(coactivityFolder, { level: 'public' })) as any[];

        // Taguer la provenance (Segmentation ou Coactivity)
        allFiles = [
          ...segFiles.map((f) => ({ ...f, _type: 'segmentation' })),
          ...coactivityFiles.map((f) => ({ ...f, _type: 'coactivity' })),
        ];
      } else {
        // Mode Détection = tout sauf Segmentation et Coactivity
        const iaFolder = `${directory}/IA/${baseName}/`;
        const iaFiles = (await Storage.list(iaFolder, { level: 'public' })) as any[];
        allFiles = iaFiles.filter((f) => !f.key.includes('/Segmentation/') && !f.key.includes('/coactivity/'));
      }

      // Préparer le mapping label
      const labelMap: { [key: string]: string } = {
        background: 'Compacteuse',
        helmet: 'Casque',
        vest: 'Gilet',
        Person: 'Personne',
        gruemobile: 'Grue mobile',
        crane: 'Grue à tour',
        camion: 'Camion',
        pelle: 'Pelle',
        chariot: 'Chariot',
        nacelle: 'Nacelle',
        toupie: 'Toupie',
        benne: 'Benne',
        goutte: 'Goutte',
        foreuse: 'Foreuse',
        no_safety: 'Non sécurisé',
        coactivity: 'Coactivité',
        fire: 'Feu',
        Smoke: 'Fumée',
        Bonfire: 'Feu',
        car: 'Voiture',
      };

      // Charger les URLs et parser label/confidence
      const images: BoundingBoxImage[] = await Promise.all(
        allFiles.map(async (file) => {
          const url = (await Storage.get(file.key, { level: 'public' })) as string;
          const filename = file.key
            .split('/')
            .pop()!
            .replace(/\.[^.]+$/, '');

          if ((file as any)._type === 'coactivity') {
            // Ex: coactivity-p0-egruemobile-1
            const parts = filename.split('-');
            // parts[1] => p0 (= personne 0), parts[2] => egruemobile (= engin grue mobile), parts[3] => n° éventuel
            const personLabel = 'Personne';
            // Retirer le préfixe éventuel 'e' sur l’engin (egruemobile => gruemobile)
            let enginKey = parts[2];
            if (enginKey.startsWith('e')) enginKey = enginKey.slice(1);
            const enginLabel = labelMap[enginKey] || enginKey;
            const label = `Coactivité : ${personLabel} & ${enginLabel}`;
            return { url, label, confidence: '', key: file.key };
          } else {
            // Segmentation ou IA standard
            const nameParts = filename.split('-');
            const rawLabel = nameParts[nameParts.length - 2];
            const confidence = nameParts[nameParts.length - 1];
            const label = labelMap[rawLabel] || rawLabel;
            return { url, label, confidence, key: file.key };
          }
        })
      );

      this.boundingBoxImages = images;
    } catch (err) {
      console.error('Erreur chargement IA images :', err);
    }
  }

  private createChart() {
    // Vérifier que this.originalData est initialisé
    if (!this.originalData || this.originalData.length === 0) {
      console.warn('Aucune donnée disponible pour le graphique.');
      return;
    }

    // Copier les données originales pour le filtrage
    let data = [...this.originalData];

    // Filtrer les données en fonction des dates sélectionnées
    if (this.startDate) {
      const start = new Date(this.startDate);
      data = data.filter((d) => d.date >= start);
    }

    if (this.endDate) {
      const end = new Date(this.endDate);
      // Ajuster la date de fin pour inclure toute la journée
      end.setHours(23, 59, 59, 999);
      data = data.filter((d) => d.date <= end);
    }

    this.chartReady = true;
    this.chartInitialized = true;
    // S'assurer que l'élément DOM existe avant d'appeler updateChart
    this.$nextTick(() => {
      const plotDiv: any = document.getElementById('chart');
      if (!plotDiv) {
        console.error("L'élément #chart n'est pas présent dans le DOM.");
        return;
      }
      this.updateChart(data);
    });
  }

  private createSecurityChart(): void {
    if (!this.originalData?.length) {
      console.warn('Aucune donnée disponible pour le graphique de sécurité.');
      return;
    }

    // 1) Filtrer / préparer …
    const filteredData = this.filterDataByDates(this.originalData);
    const prepared = this.prepareSecurityData(filteredData);
    const { xData, aggregatedData, categories } = prepared;

    // 2) Construire traces, layout et config
    const traces = this.createSecurityTraces(prepared);
    const layout = this.createSecurityLayout();
    const config = this.createConfig();

    // 3) Récupérer la div
    const plotDiv: any = document.getElementById('chart');
    if (!plotDiv) {
      console.error("L'élément #chart n'est pas présent dans le DOM.");
      return;
    }

    // fonction utilitaire pour attacher le handler de zoom **à chaque fois**
    const attachRelayout = () => {
      plotDiv.removeAllListeners?.('plotly_relayout');

      plotDiv.on('plotly_relayout', (eventData: any) => {
        // reset zoom
        if (eventData['xaxis.autorange']) {
          this.updatingFromChart = true;
          this.resetToOriginalDates();

          if (this.firstPhotoDate && this.lastPhotoDate) {
            this.currentXRange = [this.firstPhotoDate.getTime(), this.lastPhotoDate.getTime()];
          }

          this.$nextTick(() => {
            this.updatingFromChart = false;
            this.scheduleChartUpdate(); // ✅ important
          });
          return;
        }

        const range0 = eventData['xaxis.range[0]'];
        const range1 = eventData['xaxis.range[1]'];
        if (!range0 || !range1) return;

        const newStart = new Date(range0);
        const newEnd = new Date(range1);
        if (isNaN(newStart.getTime()) || isNaN(newEnd.getTime()) || newStart >= newEnd) return;

        this.currentXRange = [newStart.getTime(), newEnd.getTime()];

        this.updatingFromChart = true;
        this.startDate = this.formatDateWithTime(newStart);
        this.endDate = this.formatDateWithTime(newEnd);

        this.$nextTick(() => {
          this.updatingFromChart = false;
          this.scheduleChartUpdate(); // ✅ re-agrège en fonction du nouveau range
        });
      });
    };

    const bindClick = () => {
      plotDiv.on('plotly_click', this.handleChartClick.bind(this));
    };

    if (!this.isChartInitialized) {
      Plotly.newPlot(plotDiv, traces, layout, config).then(() => {
        this.isChartInitialized = true;
        attachRelayout();
        bindClick(); // ← on ajoute le click ici
        this.calculateSecurityScores(prepared);
      });
    } else {
      Plotly.react(plotDiv, traces, layout, config).then(() => {
        attachRelayout();
        bindClick(); // ← et aussi ici après react
        this.calculateSecurityScores(prepared);
      });
    }
  }

  private filterDataByDates(data: any[]) {
    let d = [...data];
    if (this.startDate) {
      const s = new Date(this.startDate);
      d = d.filter((p) => p.date >= s);
    }
    if (this.endDate) {
      const e = new Date(this.endDate);
      e.setHours(23, 59, 59, 999);
      d = d.filter((p) => p.date <= e);
    }
    return d;
  }

  private async updateChart(data: any[]) {
    const preparedData = this.prepareData(data);
    const traces = this.createTraces(preparedData, true);
    const layout = this.createLayout();
    const config = this.createConfig();

    const plotDiv: any = document.getElementById('chart');
    const hoverInfoDiv = document.getElementById('hoverinfo');

    if (!this.isChartInitialized) {
      await Plotly.newPlot(plotDiv, traces, layout, config);
      this.isChartInitialized = true;
      this.bindPlotEvents(plotDiv, hoverInfoDiv);
    } else {
      await Plotly.react(plotDiv, traces, layout, config);
      // Pas besoin de re-bind : react garde les handlers existants
    }

    this.calculateSecondHalfAverage(preparedData);
  }

  private resetToOriginalDates() {
    if (this.firstPhotoDate && this.lastPhotoDate) {
      this.updatingFromChart = true;
      this.startDate = this.formatDateForInput(this.firstPhotoDate);
      this.endDate = this.formatDateForInput(this.lastPhotoDate);
      this.updatingFromChart = false;
    }
  }

  private bindPlotEvents(plotDiv: any, hoverInfoDiv: HTMLElement | null) {
    // On nettoie tout : évite les doublons
    plotDiv.removeAllListeners?.();

    // CLICK → sélection de photo
    plotDiv.on('plotly_click', this.handleChartClick.bind(this));

    // ZOOM → met à jour startDate / endDate mais sans recréer le graphe
    plotDiv.on('plotly_relayout', (eventData: any) => {
      if (eventData['xaxis.autorange']) {
        this.updatingFromChart = true;
        this.resetToOriginalDates();
        this.updatingFromChart = false;
        return;
      }

      const range0 = eventData['xaxis.range[0]'];
      const range1 = eventData['xaxis.range[1]'];
      if (!range0 || !range1) return;

      const newStart = new Date(range0);
      const newEnd = new Date(range1);
      if (isNaN(newStart.getTime()) || isNaN(newEnd.getTime()) || newStart >= newEnd) return;

      this.updatingFromChart = true;
      this.startDate = this.formatDateWithTime(newStart);
      this.endDate = this.formatDateWithTime(newEnd);
      this.updatingFromChart = false;
    });

    if (!hoverInfoDiv) return;

    // HOVER → affiche la preview d’image
    plotDiv.on('plotly_hover', (data: any) => {
      const infotext = data.points.map((d: any) => `<img src="${d.customdata}" style="height: 100px; width: auto;">`);
      this.hoverInfoPosition.x = data.event.clientX;
      this.hoverInfoPosition.y = data.event.clientY;
      hoverInfoDiv.innerHTML = infotext.join('');
    });

    plotDiv.on('plotly_unhover', () => {
      hoverInfoDiv.innerHTML = '';
    });

    plotDiv.on('mousemove', (e: any) => {
      hoverInfoDiv.style.left = `${e.clientX}px`;
      hoverInfoDiv.style.top = `${e.clientY}px`;
    });
  }

  private formatDateWithTime(date: Date) {
    // Formater la date avec heure pour les inputs date+time HTML
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    const hours = ('0' + date.getHours()).slice(-2);
    const minutes = ('0' + date.getMinutes()).slice(-2);
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  private calculateSecondHalfAverage(preparedData: any) {
    const { xData, aggregatedData, categories } = preparedData;

    // Obtenir la seconde moitié des indices visibles
    const halfIndex = Math.floor(xData.length / 2);
    const secondHalfXData = xData.slice(halfIndex);
    const secondHalfYData = secondHalfXData.map((_: any, index: number) => {
      return categories.reduce((sum: number, { key }: { key: string }) => {
        return sum + aggregatedData[key][halfIndex + index];
      }, 0);
    });

    // Calculer la moyenne de la seconde moitié
    if (secondHalfYData.length > 0) {
      const total = secondHalfYData.reduce((acc: number, value: number) => acc + value, 0);
      const average = total / secondHalfYData.length;
      this.lastActivityScore = average; // Mettre à jour le score affiché
    }

    // Calculer la moyenne pour la moitié gauche
    const firstHalfXData = xData.slice(0, halfIndex);
    const firstHalfYData = firstHalfXData.map((_: any, index: number) => {
      return categories.reduce((sum: number, { key }: { key: string }) => {
        return sum + aggregatedData[key][index];
      }, 0);
    });

    if (firstHalfYData.length > 0) {
      const total = firstHalfYData.reduce((acc: number, value: number) => acc + value, 0);
      const average = total / firstHalfYData.length;
      this.leftActivityScore = average; // Score de la moitié gauche
    }

    // Calcul pour la moyenne des personnes détectées
    const secondHalfPersonData = aggregatedData['person'].slice(halfIndex);
    if (secondHalfPersonData.length > 0) {
      const total = secondHalfPersonData.reduce((acc: number, value: number) => acc + value, 0);
      this.lastPersonScore = total / secondHalfPersonData.length;
    }

    // Calcul de la première moitié pour les personnes détectées
    const firstHalfPersonData = aggregatedData['person'].slice(0, halfIndex);
    if (firstHalfPersonData.length > 0) {
      const total = firstHalfPersonData.reduce((acc: number, value: number) => acc + value, 0);
      this.leftPersonScore = total / firstHalfPersonData.length;
    }

    const secondHalfDensityData = aggregatedData['density'].slice(halfIndex);
    if (secondHalfDensityData.length > 0) {
      const total = secondHalfDensityData.reduce((acc: number, value: number) => acc + value, 0);
      this.lastDensityScore = total / secondHalfDensityData.length;
    }

    const firstHalfDensityData = aggregatedData['density'].slice(0, halfIndex);
    if (firstHalfDensityData.length > 0) {
      const total = firstHalfDensityData.reduce((acc: number, value: number) => acc + value, 0);
      this.leftDensityScore = total / firstHalfDensityData.length;
    }

    // Initialisation des scores de sécurité EPI à 100%
    this.lastHelmetScore = 100;
    this.leftHelmetScore = 100;

    // Calcul pour la seconde moitié
    const secondHalfHelmetData = aggregatedData['helmet'].slice(halfIndex);
    const secondHalfVestData = aggregatedData['vest'].slice(halfIndex);
    const totalHelmets = secondHalfHelmetData.reduce((acc: number, value: number) => acc + value, 0);
    const totalVests = secondHalfVestData.reduce((acc: number, value: number) => acc + value, 0);
    const totalPersons = aggregatedData['person']
      .slice(halfIndex)
      .reduce((acc: number, value: number) => acc + value, 0);

    if (totalPersons > 0) {
      this.lastHelmetScore = ((2 * totalHelmets + totalVests) / (3 * totalPersons)) * 100;
    } else {
      this.lastHelmetScore = 100;
    }

    // Calcul pour la première moitié
    const firstHalfHelmetData = aggregatedData['helmet'].slice(0, halfIndex);
    const firstHalfVestData = aggregatedData['vest'].slice(0, halfIndex);
    const totalHelmetsLeft = firstHalfHelmetData.reduce((acc: number, value: number) => acc + value, 0);
    const totalVestsLeft = firstHalfVestData.reduce((acc: number, value: number) => acc + value, 0);
    const totalPersonsLeft = aggregatedData['person']
      .slice(0, halfIndex)
      .reduce((acc: number, value: number) => acc + value, 0);

    if (totalPersonsLeft > 0) {
      this.leftHelmetScore = ((2 * totalHelmetsLeft + totalVestsLeft) / (3 * totalPersonsLeft)) * 100;
    } else {
      this.leftHelmetScore = 100;
    }
  }

  private calculateSecurityScores(prepared: { xData: Date[]; aggregatedData: Record<string, number[]> }) {
    const { xData, aggregatedData } = prepared;
    const halfIndex = Math.floor(xData.length / 2);

    // Calcul pour no_safety
    const noSafetyArr: number[] = aggregatedData['no_safety'] || [];
    const noSafetyFirstHalf = noSafetyArr.slice(0, halfIndex);
    const noSafetySecondHalf = noSafetyArr.slice(halfIndex);

    this.leftNosafetyScore = noSafetyFirstHalf.length
      ? noSafetyFirstHalf.reduce((a, b) => a + b, 0) / noSafetyFirstHalf.length
      : null;

    this.lastNosafetyScore = noSafetySecondHalf.length
      ? noSafetySecondHalf.reduce((a, b) => a + b, 0) / noSafetySecondHalf.length
      : null;

    // Calcul pour fire
    const fireArr: number[] = aggregatedData['fire'] || [];
    const fireFirstHalf = fireArr.slice(0, halfIndex);
    const fireSecondHalf = fireArr.slice(halfIndex);

    this.leftFireScore = fireFirstHalf.length ? fireFirstHalf.reduce((a, b) => a + b, 0) : null;

    this.lastFireScore = fireSecondHalf.length ? fireSecondHalf.reduce((a, b) => a + b, 0) : null;

    // Calcul pour car
    const carArr: number[] = aggregatedData['car'] || [];
    const carFirstHalf = carArr.slice(0, halfIndex);
    const carSecondHalf = carArr.slice(halfIndex);

    this.leftCarScore = carFirstHalf.length ? carFirstHalf.reduce((a, b) => a + b, 0) : null;

    this.lastCarScore = carSecondHalf.length ? carSecondHalf.reduce((a, b) => a + b, 0) : null;

    // Calcul pour coactivity
    const coactivityArr: number[] = aggregatedData['coactivity'] || [];
    const coactivityFirstHalf = coactivityArr.slice(0, halfIndex);
    const coactivitySecondHalf = coactivityArr.slice(halfIndex);

    this.leftCoactivityScore = coactivityFirstHalf.length
      ? coactivityFirstHalf.reduce((a, b) => a + b, 0) / coactivityFirstHalf.length
      : null;

    this.lastCoactivityScore = coactivitySecondHalf.length
      ? coactivitySecondHalf.reduce((a, b) => a + b, 0) / coactivitySecondHalf.length
      : null;
  }

  private prepareData(data: any[]) {
    const xRange: [number, number] = [
      this.startDate ? new Date(this.startDate).getTime() : data[0].date.getTime(),
      this.endDate ? new Date(this.endDate).getTime() : data[data.length - 1].date.getTime(),
    ];

    this.currentXRange = xRange;

    // Filtrer les données en fonction de la plage visible
    const filteredData = data.filter((d) => {
      const time = d.date.getTime();
      return time >= xRange[0] && time <= xRange[1];
    });

    this.photoIdsByDay = {};
    filteredData.forEach((d) => {
      const key = d.date.toDateString(); // même logique que ton getPhotoIdsForDate actuel
      if (!this.photoIdsByDay[key]) this.photoIdsByDay[key] = [];
      this.photoIdsByDay[key].push(d.photoId);
    });

    const dataPointCount = filteredData.length;

    // Calcul de la durée de la plage visible (en millisecondes)
    const rangeDuration = xRange[1] - xRange[0];
    const dayDuration = 24 * 60 * 60 * 1000; // Durée d'un jour en millisecondes
    const weekDuration = 7 * dayDuration; // Durée d'une semaine en millisecondes

    // Seuils pour les différents niveaux d'agrégation
    const shouldAggregateByWeek = rangeDuration > 15 * weekDuration; // Agrégation par semaine si plage > 15 semaines
    const shouldAggregateByDay = rangeDuration > 7 * dayDuration && !shouldAggregateByWeek; // Agrégation par jour si > 7 jours

    let xData: Date[] = [];
    let aggregatedData: { [key: string]: number[] } = {};
    type Category = {
      key: string;
      label: string;
    };

    let categories: Category[];
    if (this.modeSelected === 'Sécurité') {
      categories = [
        { key: 'no_safety', label: 'Non sécurisé' },
        { key: 'fire', label: 'Feu' },
        { key: 'coactivity', label: 'Coactivité' },
        { key: 'car', label: 'Voiture' },
      ];
    } else {
      // mode Détection
      categories = [
        { key: 'toupie', label: 'timelapseedition.toupie' },
        { key: 'crane', label: 'timelapseedition.crane' },
        { key: 'nacelle', label: 'timelapseedition.nacelle' },
        { key: 'pelle', label: 'timelapseedition.pelle' },
        { key: 'person', label: 'timelapseedition.person' },
        { key: 'benne', label: 'timelapseedition.benne' },
        { key: 'compacteuse', label: 'timelapseedition.compacteuse' },
        { key: 'mobilecrane', label: 'timelapseedition.mobilecrane' },
        { key: 'camion', label: 'timelapseedition.camion' },
        { key: 'foreuse', label: 'timelapseedition.foreuse' },
        { key: 'density', label: 'Densité' },
        { key: 'movement', label: 'Mouvement' },
        { key: 'helmet', label: 'Casque' },
        { key: 'vest', label: 'Gilet' },
        // PAS de fire, car, no_safety ni coactivity ici !
      ];
    }

    if (dataPointCount <= 2) {
      // Toujours utiliser les données non agrégées si 2 points ou moins
      xData = filteredData.map((d) => d.date);
      aggregatedData = {};
      categories.forEach((category: Category) => {
        aggregatedData[category.key] = filteredData.map((d) => d[category.key]);
      });
    } else if (shouldAggregateByWeek) {
      // Agrégation par semaine
      const groupedData = d3Array.groups(filteredData, (d) => d3.timeWeek(d.date));

      xData = [];
      aggregatedData = {};
      categories.forEach((category: Category) => {
        aggregatedData[category.key] = [];
      });

      groupedData.forEach(([dateStr, items]) => {
        const date = new Date(dateStr);
        xData.push(date);

        categories.forEach((category: Category) => {
          const total = items.reduce((sum, d) => sum + d[category.key], 0) / items.length;
          aggregatedData[category.key].push(total);
        });
      });
    } else if (shouldAggregateByDay) {
      // Agrégation par jour
      const groupedData = d3Array.groups(filteredData, (d) => d3.timeDay(d.date));

      xData = [];
      aggregatedData = {};
      categories.forEach((category: Category) => {
        aggregatedData[category.key] = [];
      });

      groupedData.forEach(([dateStr, items]) => {
        const date = new Date(dateStr);
        xData.push(date);

        categories.forEach((category: Category) => {
          const total = items.reduce((sum, d) => sum + d[category.key], 0) / items.length;
          aggregatedData[category.key].push(total);
        });
      });
    } else {
      // Afficher chaque point sans agrégation
      xData = filteredData.map((d) => d.date);
      aggregatedData = {};
      categories.forEach((category: Category) => {
        aggregatedData[category.key] = filteredData.map((d) => d[category.key]);
      });
    }

    // **Calcul de weightedActivity**
    const labelWeights = {
      toupie: 2.0,
      crane: 1.0,
      nacelle: 1.5,
      pelle: 1.5,
      person: 1.0,
      benne: 0.3,
      compacteuse: 1.5,
      mobilecrane: 2.5,
      camion: 1.8,
      helmet: 0.0,
    };

    const weightedActivity = xData.map((_, index) => {
      return categories.reduce((sum: number, category: Category) => {
        const key = category.key;
        const weight = labelWeights[key as keyof typeof labelWeights] || 1;
        return sum + (aggregatedData[key][index] * weight) / 2;
      }, 0);
    });

    aggregatedData['weightedActivity'] = weightedActivity;

    return { xData, aggregatedData, categories };
  }

  private prepareSecurityData(data: any[]) {
    const xRange: [number, number] = [
      this.startDate ? new Date(this.startDate).getTime() : data[0].date.getTime(),
      this.endDate ? new Date(this.endDate).getTime() : data[data.length - 1].date.getTime(),
    ];

    this.currentXRange = xRange;

    // Filtrer les données en fonction de la plage visible
    const filteredData = data.filter((d) => {
      const time = d.date.getTime();
      return time >= xRange[0] && time <= xRange[1];
    });

    // mapping date -> photoIds (pour le click sur le graphe)
    this.photoIdsByDay = {};
    filteredData.forEach((d) => {
      const key = d.date.toDateString();
      if (!this.photoIdsByDay[key]) this.photoIdsByDay[key] = [];
      this.photoIdsByDay[key].push(d.photoId);
    });

    const dataPointCount = filteredData.length;

    const dayDuration = 24 * 60 * 60 * 1000;
    const weekDuration = 7 * dayDuration;
    const rangeDuration = xRange[1] - xRange[0];

    // Catégories de sécurité (y compris tes 5 nouvelles colonnes)
    const categories = [
      { key: 'excavation', label: 'Excavation' },
      { key: 'filet', label: 'Filet' },
      { key: 'gc', label: 'Garde-corps' },
      { key: 'heras', label: 'Heras' },
      { key: 'no_safety', label: 'Non sécurisé' },
      { key: 'rubalise', label: 'Rubalise' },
      { key: 'coactivity', label: 'Coactivité' },
      { key: 'fire', label: 'Feu' },
      { key: 'car', label: 'Voiture' },
      { key: 'safety_score', label: 'Score sécurité' },
      { key: 'housekeeping_score', label: 'Housekeeping' },
      { key: 'workers_total', label: 'Nb travailleurs' },
      { key: 'ppe_non_compliance_count', label: 'Non-conformités EPI' },
      { key: 'hazards_count', label: 'Dangers détectés' },
    ];

    // Clés à agréger par moyenne (scores / niveaux moyens)
    const AVERAGE_KEYS = ['safety_score', 'housekeeping_score', 'workers_total'];

    const aggregateValues = (items: any[], key: string): number => {
      const values = items.map((d) => Number(d[key] ?? 0));
      if (!values.length) return 0;
      const sum = values.reduce((s, v) => s + v, 0);
      // Scores & nb travailleurs → moyenne, le reste → somme
      if (AVERAGE_KEYS.includes(key)) {
        return sum / values.length;
      }
      return sum;
    };

    let xData: Date[] = [];
    let aggregatedData: { [key: string]: number[] } = {};

    if (dataPointCount <= 2) {
      // Pas d’agrégation si peu de points
      xData = filteredData.map((d) => d.date);
      aggregatedData = {};
      categories.forEach((category) => {
        aggregatedData[category.key] = filteredData.map((d) => Number(d[category.key] ?? 0));
      });
    } else if (rangeDuration > 15 * weekDuration) {
      // Agrégation par semaine
      const groupedData = d3Array.groups(filteredData, (d) => d3.timeWeek(d.date));
      xData = [];
      aggregatedData = {};
      categories.forEach((category) => {
        aggregatedData[category.key] = [];
      });

      groupedData.forEach(([dateStr, items]) => {
        const date = new Date(dateStr);
        xData.push(date);
        categories.forEach((category) => {
          aggregatedData[category.key].push(aggregateValues(items, category.key));
        });
      });
    } else if (rangeDuration > 7 * dayDuration) {
      // Agrégation par jour
      const groupedData = d3Array.groups(filteredData, (d) => d3.timeDay(d.date));
      xData = [];
      aggregatedData = {};
      categories.forEach((category) => {
        aggregatedData[category.key] = [];
      });

      groupedData.forEach(([dateStr, items]) => {
        const date = new Date(dateStr);
        xData.push(date);
        categories.forEach((category) => {
          aggregatedData[category.key].push(aggregateValues(items, category.key));
        });
      });
    } else {
      // Pas d’agrégation (point par point)
      xData = filteredData.map((d) => d.date);
      aggregatedData = {};
      categories.forEach((category) => {
        aggregatedData[category.key] = filteredData.map((d) => Number(d[category.key] ?? 0));
      });
    }

    return { xData, aggregatedData, categories };
  }

  private computeWeeklySafetyHighlights(
    prepared: { xData: Date[]; aggregatedData: Record<string, number[]>; categories: any[] },
    maxHighlights = 10
  ): SafetyHighlight[] {
    const { xData, aggregatedData } = prepared;

    // Reprendre les données brutes sur la période courante
    const rawSlice = this.filterDataByDates(this.originalData);

    const highlights: SafetyHighlight[] = xData.map((date, idx) => {
      const no_safety = aggregatedData['no_safety']?.[idx] || 0;
      const coactivity = aggregatedData['coactivity']?.[idx] || 0;
      const fire = aggregatedData['fire']?.[idx] || 0;
      const car = aggregatedData['car']?.[idx] || 0;

      // Score de sévérité
      const score = no_safety * 2 + coactivity * 1.5 + fire * 3 + car * 1;

      // Type principal
      let type: SafetyHighlight['type'] = 'NO_SAFETY_SPIKE';
      if (fire > 0) {
        type = 'FIRE';
      } else if (coactivity > 0 && coactivity >= no_safety) {
        type = 'COACTIVITY';
      } else if (car > 0 && no_safety === 0 && coactivity === 0 && fire === 0) {
        type = 'CAR';
      }

      // ⇨ Chercher la photo dont l'heure est la plus proche de "date"
      let closest: any | null = null;
      let closestDiff = Infinity;

      for (const sample of rawSlice) {
        const diff = Math.abs(sample.date.getTime() - date.getTime());
        if (diff < closestDiff) {
          closestDiff = diff;
          closest = sample;
        }
      }

      // Si on a trouvé une photo "la plus proche", on l’utilise
      let effectiveDate = date;
      let photoIds: string[] = [];

      if (closest) {
        effectiveDate = closest.date;
        photoIds = [closest.photoId];
      } else {
        // fallback : même logique qu’avant, par jour
        photoIds = this.getPhotoIdsForDate(date);
      }

      return {
        date: effectiveDate,
        type,
        score,
        metrics: { no_safety, coactivity, fire, car },
        photoIds,
      };
    });

    // On garde seulement les points où il se passe quelque chose
    const filtered = highlights.filter((h) => h.score > 0);

    // Tri du plus critique au moins critique
    filtered.sort((a, b) => b.score - a.score);

    this.weeklySafetyHighlights = filtered.slice(0, maxHighlights);
    return this.weeklySafetyHighlights;
  }

  private getHighlightTypeLabel(type: SafetyHighlight['type']): string {
    switch (type) {
      case 'FIRE':
        return this.$t('ia.highlightFire') as string;
      case 'COACTIVITY':
        return this.$t('ia.highlightCoactivity') as string;
      case 'CAR':
        return this.$t('ia.highlightCar') as string;
      case 'NO_SAFETY_SPIKE':
      default:
        return this.$t('ia.highlightNoSafety') as string;
    }
  }

  private downsampleAggregated(
    xData: Date[],
    aggregatedData: { [key: string]: number[] },
    categoryKeys: string[],
    maxPoints: number
  ): { xData: Date[]; aggregatedData: { [key: string]: number[] } } {
    if (xData.length <= maxPoints) {
      return { xData, aggregatedData };
    }

    const factor = Math.ceil(xData.length / maxPoints); // taille d'un paquet
    const dsX: Date[] = [];
    const dsAgg: { [key: string]: number[] } = {};

    categoryKeys.forEach((key) => {
      dsAgg[key] = [];
    });

    for (let i = 0; i < xData.length; i += factor) {
      const sliceEnd = Math.min(i + factor, xData.length);
      const sliceLen = sliceEnd - i;
      const midIndex = i + Math.floor(sliceLen / 2);

      // X "représentatif" du paquet
      dsX.push(xData[midIndex]);

      categoryKeys.forEach((key) => {
        const src = aggregatedData[key] || [];
        let sum = 0;
        for (let j = i; j < sliceEnd; j++) {
          sum += src[j] ?? 0;
        }
        dsAgg[key].push(sliceLen > 0 ? sum / sliceLen : 0);
      });
    }

    return { xData: dsX, aggregatedData: dsAgg };
  }

  private createSecurityTraces(data: { xData: Date[]; aggregatedData: any; categories: any[] }): Plotly.Data[] {
    const { categories } = data;

    // Couleurs par série
    const labelColors: { [key: string]: string } = {
      excavation: '#FF9900',
      filet: '#00FF00',
      gc: '#0000FF',
      heras: '#00FFFF',
      no_safety: '#FF0000',
      rubalise: '#FFD700',
      coactivity: '#FFA500',
      fire: '#FF3300',
      car: '#00BFFF',
      safety_score: '#00FF99',
      housekeeping_score: '#3399FF',
      workers_total: '#FFFFFF',
      ppe_non_compliance_count: '#FF00FF',
      hazards_count: '#00FFFF',
    };

    const MAX_POINTS = 1500;

    // 1) Copie locale pour le downsample (on ne touche pas à data.aggregatedData)
    let xData: Date[] = data.xData.slice();
    const keysForDownsample: string[] = categories.map((c: any) => c.key);
    const aggregatedCopy: { [key: string]: number[] } = {};
    keysForDownsample.forEach((key) => {
      aggregatedCopy[key] = (data.aggregatedData[key] || []).slice();
    });

    const downsampled = this.downsampleAggregated(xData, aggregatedCopy, keysForDownsample, MAX_POINTS);
    xData = downsampled.xData;
    const aggregatedData: { [key: string]: number[] } = {
      ...data.aggregatedData,
      ...downsampled.aggregatedData,
    };

    // customdata = liste de photoIds pour chaque x (pour le click sur une date)
    const customDataPerX = xData.map((date) => this.getPhotoIdsForDate(date));

    // Quelles clés sur quel type d’axe / trace
    const BAR_KEYS = ['no_safety', 'coactivity', 'fire', 'car'];
    const LINE_Y_KEYS = ['workers_total', 'ppe_non_compliance_count', 'hazards_count'];
    const LINE_Y2_KEYS = ['safety_score', 'housekeeping_score'];

    const traces: Partial<Plotly.PlotData>[] = [];

    // === 1) Barres empilées des risques (no_safety / coactivity / fire / car) ===
    categories
      .filter(({ key }: any) => BAR_KEYS.includes(key) && this.hasNonZeroValues(aggregatedData[key] || []))
      .forEach(({ key, label }: any) => {
        const yData = aggregatedData[key] || [];
        const textData = yData.map((value: number, index: number) => {
          return `${label}: ${value.toFixed(1)}<br>${d3.timeFormat('%d/%m/%Y %H:%M:%S')(xData[index])}`;
        });

        traces.push({
          x: xData,
          y: yData,
          type: 'bar',
          name: label,
          text: textData,
          hovertemplate: '%{text}<extra></extra>',
          marker: {
            color: labelColors[key] || '#000000',
          },
          customdata: customDataPerX,
        } as Partial<Plotly.PlotData>);
      });

    // === 2) Courbes sur l’axe Y principal (volumes) ===
    categories
      .filter(({ key }: any) => LINE_Y_KEYS.includes(key) && this.hasNonZeroValues(aggregatedData[key] || []))
      .forEach(({ key, label }: any) => {
        traces.push({
          x: xData,
          y: aggregatedData[key] || [],
          type: 'scatter',
          mode: 'lines+markers',
          name: label,
          yaxis: 'y',
          line: {
            width: 2,
            dash: 'dot',
            color: labelColors[key] || '#CCCCCC',
            shape: 'spline',
            smoothing: 0.5,
          },
          hovertemplate: `${label}: %{y:.1f}<extra></extra>`,
          customdata: customDataPerX,
        } as Partial<Plotly.PlotData>);
      });

    // === 3) Courbes de scores sur l’axe Y2 (0–100) ===
    categories
      .filter(({ key }: any) => LINE_Y2_KEYS.includes(key) && this.hasNonZeroValues(aggregatedData[key] || []))
      .forEach(({ key, label }: any) => {
        traces.push({
          x: xData,
          y: aggregatedData[key] || [],
          type: 'scatter',
          mode: 'lines+markers',
          name: label,
          yaxis: 'y2',
          line: {
            width: 3,
            shape: 'spline',
            smoothing: 0.6,
            color: labelColors[key] || '#00FFFF',
          },
          hovertemplate: `${label}: %{y:.1f} / 100<extra></extra>`,
          customdata: customDataPerX,
        } as Partial<Plotly.PlotData>);
      });

    return traces as Plotly.Data[];
  }

  private createSecurityLayout(): Partial<Plotly.Layout> {
    return {
      barmode: 'stack',
      bargap: 0.05,
      modebar: {
        orientation: 'v',
        bgcolor: '#001a35',
        color: '#6c757d',
        activecolor: '#5fc9e4',
      },
      xaxis: {
        color: '#5fc9e4',
        gridcolor: '#314a644a',
        type: 'date',
        tickformat: '%d/%m/%Y',
        autorange: !this.currentXRange,
        range: this.currentXRange
          ? [new Date(this.currentXRange[0]).toISOString(), new Date(this.currentXRange[1]).toISOString()]
          : undefined,
        showgrid: true,
        automargin: true,
      },
      yaxis: {
        autorange: true,
        rangemode: 'tozero',
        color: '#5fc9e4',
        gridcolor: '#314a644a',
        title: {
          text: 'Occurrences / volumes',
          standoff: 100,
        },
        anchor: 'x',
        zeroline: true,
      },
      yaxis2: {
        title: 'Scores (0–100)',
        overlaying: 'y',
        side: 'right',
        range: [0, 100], // 0 en bas aussi
        tickformat: '.0f',
        showgrid: false,
        color: '#5fc9e4',
        anchor: 'x',
      },
      margin: {
        l: 50,
        r: 80,
        b: 31,
        t: 10,
        pad: 0,
      },
      paper_bgcolor: 'transparent',
      plot_bgcolor: 'transparent',
      legend: {
        x: 0,
        xanchor: 'left',
        y: 1.04,
        yanchor: 'middle',
        orientation: 'h',
        font: { color: '#5fc9e4' },
      },
    };
  }

  private hasNonZeroValues(dataArray: number[]): boolean {
    return dataArray.some((value) => value !== 0);
  }

  private createTraces(
    data: { xData: Date[]; aggregatedData: any; categories: any[] },
    includeBars = true
  ): Plotly.Data[] {
    const labelColors: { [key: string]: string } = {
      toupie: '#0DFF72',
      crane: '#00D2FF',
      nacelle: '#ff8915',
      pelle: '#d8ff5a',
      person: '#4dffcd',
      benne: '#FF007F',
      compacteuse: '#00FFCC',
      mobilecrane: '#AA00FF',
      camion: '#4e7bff',
      foreuse: '#33FF00',
      density: '#FF00B3',
      movement: '#3c7eff',
      helmet: '#ffffff',
    };

    const labelWeights: { [key: string]: number } = {
      toupie: 2.0,
      crane: 1.0,
      nacelle: 1.5,
      pelle: 1.5,
      person: 1.0,
      benne: 0.3,
      compacteuse: 1.5,
      mobilecrane: 2.5,
      camion: 1.8,
      helmet: 0.0,
    };

    const MAX_POINTS = 1500; // limite de points pour l'affichage
    const categories = data.categories;

    // 1) Copie locale des données pour ne PAS toucher à data.aggregatedData
    let xData: Date[] = data.xData.slice();

    const keysForDownsample: string[] = categories.map((c: any) => c.key);

    // On ajoute les séries utilisées dans les courbes (même si pas dans categories)
    ['density', 'movement', 'person', 'helmet', 'vest'].forEach((k) => {
      if (data.aggregatedData[k] && !keysForDownsample.includes(k)) {
        keysForDownsample.push(k);
      }
    });

    const aggregatedCopy: { [key: string]: number[] } = {};
    keysForDownsample.forEach((key) => {
      aggregatedCopy[key] = (data.aggregatedData[key] || []).slice();
    });

    // 2) Downsampling uniquement pour l'affichage
    const downsampled = this.downsampleAggregated(xData, aggregatedCopy, keysForDownsample, MAX_POINTS);
    xData = downsampled.xData;
    const aggregatedData: { [key: string]: number[] } = {
      ...data.aggregatedData,
      ...downsampled.aggregatedData,
    };

    // 3) Recalcul de l'activité pondérée à partir des données downsamplées
    const weightedActivity = xData.map((_, index) => {
      return categories.reduce((sum: number, c: any) => {
        const key = c.key as string;
        const weight = labelWeights[key] ?? 1;
        const arr = aggregatedData[key] || [];
        const val = arr[index] ?? 0;
        return sum + (val * weight) / 2;
      }, 0);
    });

    aggregatedData['weightedActivity'] = weightedActivity;
    this.lastActivityScore = weightedActivity.length ? weightedActivity[weightedActivity.length - 1] : null;

    // 4) Traces de courbes (activité, densité, mouvement, ratio EPI)
    const weightedActivityTrace: Partial<Plotly.ScatterData> = {
      x: xData,
      y: weightedActivity,
      type: 'scatter',
      mode: 'lines',
      name: 'Activité',
      line: {
        color: '#d8ff00',
        width: 3,
        shape: 'spline',
        smoothing: 0.5,
      },
      hovertemplate: 'Activité: %{y}<extra></extra>',
    };

    const densityTrace: Partial<Plotly.ScatterData> = {
      x: xData,
      y: aggregatedData['density'],
      type: 'scatter',
      mode: 'lines',
      name: 'Densité',
      line: {
        color: '#ff9e03',
        width: 3,
        shape: 'spline',
        smoothing: 0.5,
      },
      hovertemplate: 'Densité: %{y}<extra></extra>',
    };

    const movementTrace: Partial<Plotly.ScatterData> = {
      x: xData,
      y: aggregatedData['movement'],
      type: 'scatter',
      mode: 'lines',
      name: 'Mouvement',
      line: {
        color: '#3c7eff',
        width: 3,
        shape: 'spline',
      },
      hovertemplate: 'Mouvement: %{y}<extra></extra>',
      yaxis: 'y2',
    };

    // Ratio casque/personne
    const helmetPersonRatio = (aggregatedData['person'] || []).map((personCount: number, index: number) => {
      const helmetCount = aggregatedData['helmet']?.[index] ?? 0;
      const vestCount = aggregatedData['vest']?.[index] ?? 0;

      if (personCount > 0) {
        return ((helmetCount * 2 + vestCount) / (3 * personCount)) * 100;
      } else {
        return 100;
      }
    });

    const helmetPersonRatioTrace: Partial<Plotly.ScatterData> = {
      x: xData,
      y: helmetPersonRatio,
      type: 'scatter',
      mode: 'lines',
      name: 'Port EPI',
      line: {
        color: 'cyan',
        width: 3,
        dash: 'dashdot',
        shape: 'spline',
        smoothing: 0.5,
      },
      hovertemplate: 'Sécurité EPI: %{y} %<extra></extra>',
      yaxis: 'y2',
    };

    const traces: Partial<Plotly.PlotData>[] = [
      weightedActivityTrace,
      densityTrace,
      movementTrace,
      helmetPersonRatioTrace,
    ];

    // 5) customdata aligné sur le xData downsamplé
    const customDataPerX = xData.map((date) => this.getPhotoIdsForDate(date));

    // 6) Ajout des barres de détection si demandé
    if (includeBars) {
      const detectionTraces = categories
        .filter(
          ({ key }: any) =>
            key !== 'density' &&
            key !== 'movement' &&
            key !== 'no_safety' &&
            key !== 'coactivity' &&
            this.hasNonZeroValues(aggregatedData[key])
        )
        .map(({ key, label }: any) => {
          const yData = aggregatedData[key] || [];
          const textData = yData.map((value: number, index: number) => {
            return `${this.$t(label)}: ${value}<br>${d3.timeFormat('%d/%m/%Y %H:%M:%S')(xData[index])}`;
          });

          return {
            x: xData,
            y: yData,
            type: 'bar',
            name: this.$t(label) as string,
            text: textData,
            hovertemplate: '%{text}<extra></extra>',
            marker: {
              color: labelColors[key] || '#000000',
            },
            customdata: customDataPerX,
          } as Partial<Plotly.PlotData>;
        });

      traces.push(...detectionTraces);
    }

    return traces as Plotly.Data[];
  }

  private getWeeklyRangeFromDate(refDate: Date): { start: Date; end: Date } {
    const d = new Date(refDate);
    d.setHours(12, 0, 0, 0); // éviter les surprises de fuseau

    const day = d.getDay(); // 0 = dimanche, 1 = lundi, ..., 6 = samedi

    // Lundi de la semaine "courante" (celle qui contient la date cliquée)
    const diffToMonday = (day + 6) % 7; // 0 pour lundi
    const mondayThisWeek = new Date(d);
    mondayThisWeek.setDate(d.getDate() - diffToMonday);
    mondayThisWeek.setHours(0, 0, 0, 0);

    let start: Date;

    if (day >= 1 && day <= 4) {
      // 👉 clic entre lundi (1) et jeudi (4) → semaine d'avant
      start = new Date(mondayThisWeek);
      start.setDate(start.getDate() - 7); // lundi de la semaine précédente
    } else {
      // 👉 clic vendredi / samedi / dimanche → semaine courante
      start = mondayThisWeek;
    }

    start.setHours(0, 0, 0, 0);

    const end = new Date(start);
    end.setDate(start.getDate() + 6); // dimanche de la semaine
    end.setHours(23, 59, 59, 999);

    return { start, end };
  }

  private getPhotoIdsForDate(date: Date): string[] {
    return this.photoIdsByDay[date.toDateString()] || [];
  }

  private extractS3KeyFromUrl(url: string): string | null {
    // Prend tout après ".com/" jusqu'au "?" (ou fin)
    const match = url.match(/\.com\/([^?]+)/);
    return match ? match[1] : null;
  }

  private async reportFalseDetectionroboflow(index: number) {
    const falseDetection = this.boundingBoxImages[index];
    console.log('False detection', falseDetection);
    try {
      // Récupérer l’URL publique de l’image depuis S3
      const imageUrl = await Storage.get(falseDetection.key, { level: 'public' });
      // Télécharger l’image et la convertir en Blob
      const response = await fetch(imageUrl as string);
      const blob = await response.blob();

      // Créer un FormData pour l’envoi vers Roboflow
      const formData = new FormData();
      // On génère un nom de fichier basé sur l’heure et le label (à adapter selon vos besoins)
      const fileName = `reported-${Date.now()}-${falseDetection.label}.jpg`;
      formData.append('name', fileName);
      formData.append('file', blob, fileName);
      // On peut indiquer le split (par exemple "train")
      formData.append('split', 'train');

      // Configuration de Roboflow : remplacez par vos informations
      const ROBOFLOW_API_KEY = 'sMvFYAUEXICXjfJaPDAs';
      const ROBOFLOW_DATASET = 'erige';

      // Envoyer l'image à Roboflow via axios
      const axiosResponse = await axios.post(`https://api.roboflow.com/dataset/${ROBOFLOW_DATASET}/upload`, formData, {
        params: {
          api_key: ROBOFLOW_API_KEY,
        },
      });

      // === SUPPRESSION S3 ===
      let s3Key = falseDetection.key;
      if (!s3Key.startsWith('public/')) {
        s3Key = 'public/' + s3Key;
      }
      // Extraction photoId et label depuis le nom du fichier
      const matches = s3Key.match(/\/([a-f0-9-]{36})-([a-zA-Z0-9_]+)-/);

      let photoId: string | null = null;
      let label: string | null = null;
      if (matches) {
        photoId = matches[1];
        label = matches[2];
      }

      if (!photoId || !label) {
        this.$bvToast.toast('Impossible d’identifier la photo à signaler.', {
          title: 'Erreur',
          variant: 'danger',
          solid: true,
        });
        return;
      }

      // Appel API
      const apiResp = await axios.post('https://vamg432ym2.execute-api.eu-west-3.amazonaws.com/prod/delete-photo', {
        s3Key,
        photoId,
        label,
      });

      console.log(axiosResponse.data);
      this.$bvToast.toast('Fausse détection signalée avec succès.', {
        title: 'Succès',
        variant: 'success',
        solid: true,
      });
      // Optionnel : Supprimer l'image de la liste après signalement
      this.boundingBoxImages = this.boundingBoxImages.filter((_, i) => i !== index);
    } catch (error) {
      // Vérifier si l'erreur contient "Network Error"
      const errorStr = error && error.toString ? error.toString() : '';
      if (errorStr.includes('Network Error')) {
        console.log("Network Error détecté, mais l'upload semble réussi d'après les logs réseau.");
        this.$bvToast.toast('Fausse détection signalée avec succès.', {
          title: 'Succès',
          variant: 'success',
          solid: true,
        });
        // Optionnel : Supprimer l'image de la liste après signalement
        this.boundingBoxImages = this.boundingBoxImages.filter((_, i) => i !== index);
        try {
          await axios.post('https://ncv8s6bnc5.execute-api.eu-west-3.amazonaws.com/prod/send-email', {});
          console.log('Email de notification envoyé via Lambda.');
        } catch (emailError) {
          console.error("Erreur lors de l'envoi de l'email :", emailError);
        }
      } else {
        console.error('Erreur lors du signalement:', error);
        this.$bvToast.toast('Erreur lors du signalement.', {
          title: 'Erreur',
          variant: 'danger',
          solid: true,
        });
      }
    }
  }

  private getRoboflowDataset(label: string): string {
    if (label === 'Voiture' || label === 'car') {
      return 'test-y8s9t';
    }
    if (label === 'Non sécurisé' || label === 'no_safety') {
      return 'excavation-2';
    }
    // Ajoute d'autres cas si besoin
    return 'excavation-2'; // dataset par défaut
  }

  private async reportFalseDetectionroboflowseg(index: number, dataset: string) {
    const falseDetection = this.boundingBoxImages[index];
    console.log('False detection', falseDetection);
    try {
      // Récupérer l’URL publique de l’image depuis S3
      const imageUrl = await Storage.get(falseDetection.key, { level: 'public' });
      // Télécharger l’image et la convertir en Blob
      const response = await fetch(imageUrl as string);
      const blob = await response.blob();

      // Créer un FormData pour l’envoi vers Roboflow
      const formData = new FormData();
      // On génère un nom de fichier basé sur l’heure et le label (à adapter selon vos besoins)
      const fileName = `reported-${Date.now()}-${falseDetection.label}.jpg`;
      formData.append('name', fileName);
      formData.append('file', blob, fileName);
      // On peut indiquer le split (par exemple "train")
      formData.append('split', 'train');

      // Configuration de Roboflow : remplacez par vos informations
      const ROBOFLOW_API_KEY = 'sMvFYAUEXICXjfJaPDAs';
      const ROBOFLOW_DATASET = dataset;

      // Envoyer l'image à Roboflow via axios
      const axiosResponse = await axios.post(`https://api.roboflow.com/dataset/${ROBOFLOW_DATASET}/upload`, formData, {
        params: {
          api_key: ROBOFLOW_API_KEY,
        },
      });

      // === SUPPRESSION S3 ===
      let s3Key = falseDetection.key;
      if (!s3Key.startsWith('public/')) {
        s3Key = 'public/' + s3Key;
      }
      const matches = s3Key.match(/Segmentation\/([a-z0-9-]{36})-([a-zA-Z0-9_]+)-/);

      let photoId: string | null = null;
      let label: string | null = null;
      if (matches) {
        photoId = matches[1];
        label = matches[2];
      }

      if (!photoId || !label) {
        this.$bvToast.toast('Impossible d’identifier la photo à signaler.', {
          title: 'Erreur',
          variant: 'danger',
          solid: true,
        });
        return;
      }

      const apiResp = await axios.post('https://vamg432ym2.execute-api.eu-west-3.amazonaws.com/prod/delete-photo', {
        s3Key,
        photoId,
        label,
      });

      this.$bvToast.toast('Fausse détection signalée avec succès.', {
        title: 'Succès',
        variant: 'success',
        solid: true,
      });
      // Optionnel : Supprimer l'image de la liste après signalement
      this.boundingBoxImages = this.boundingBoxImages.filter((_, i) => i !== index);
    } catch (error) {
      // Vérifier si l'erreur contient "Network Error"
      const errorStr = error && error.toString ? error.toString() : '';
      if (errorStr.includes('Network Error')) {
        console.log("Network Error détecté, mais l'upload semble réussi d'après les logs réseau.");
        this.$bvToast.toast('Fausse détection signalée avec succès.', {
          title: 'Succès',
          variant: 'success',
          solid: true,
        });
        // Optionnel : Supprimer l'image de la liste après signalement
        this.boundingBoxImages = this.boundingBoxImages.filter((_, i) => i !== index);
        try {
          await axios.post('https://ncv8s6bnc5.execute-api.eu-west-3.amazonaws.com/prod/send-email', {});
          console.log('Email de notification envoyé via Lambda.');
        } catch (emailError) {
          console.error("Erreur lors de l'envoi de l'email :", emailError);
        }
      } else {
        console.error('Erreur lors du signalement:', error);
        this.$bvToast.toast('Erreur lors du signalement.', {
          title: 'Erreur',
          variant: 'danger',
          solid: true,
        });
      }
    }
  }

  private async reportFalseDetection(index: number) {
    const falseDetection = this.boundingBoxImages[index];
    try {
      // Récupérer la clé S3 de l'image à signaler
      const imageKey = falseDetection.key;

      // Télécharger l'image en tant que Blob
      const imageUrl = (await Storage.get(imageKey, { download: true })) as string;
      // Utiliser fetch pour obtenir l'image en tant que Blob
      const response = await fetch(imageUrl);
      const blob = await response.blob();

      // Créer un nom de fichier unique pour l'image signalée
      const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
      const fileExtension = imageKey.split('.').pop()?.split('?')[0] || 'jpg'; // Extraire l'extension depuis la clé
      const fileName = `false-detections-bucket/${this.id}/${this.cameraSelected}/${timestamp}-${falseDetection.label}.${fileExtension}`;

      // Télécharger l'image vers le bucket S3 dédié
      await Storage.put(fileName, blob, {
        contentType: blob.type,
        level: 'public', // Utilisez 'private' si vous souhaitez restreindre l'accès
      });

      // Optionnel : Sauvegarder des métadonnées sur le signalement
      const reportData = {
        label: falseDetection.label,
        confidence: falseDetection.confidence,
        originalImageKey: imageKey,
        reportedAt: new Date().toISOString(),
        projectId: this.id,
        cameraId: this.cameraSelected,
        userId: this.$store.state.user?.id || 'unknown',
        userName: this.$store.state.user?.name || 'unknown',
      };

      // Créer un fichier JSON de métadonnées
      const metadataFileName = `false-detections/${this.id}/${this.cameraSelected}/${timestamp}-${falseDetection.label}.json`;
      const metadataBlob = new Blob([JSON.stringify(reportData, null, 2)], { type: 'application/json' });

      await Storage.put(metadataFileName, metadataBlob, {
        contentType: 'application/json',
        level: 'public', // Ou 'private'
      });

      await Storage.remove(imageKey, { level: 'public' });

      // Ajouter la détection signalée à la liste des fausses détections
      this.falseDetections.push(falseDetection);

      // Afficher un message de succès
      this.$bvToast.toast('Fausse détection signalée avec succès.', {
        title: 'Succès',
        variant: 'success',
        solid: true,
      });

      // Optionnel : Supprimer la détection de l'affichage
      // this.boundingBoxImages.splice(index, 1);
      // Si vous utilisez `filteredBoundingBoxImages`, mettez à jour `boundingBoxImages` en conséquence
      this.boundingBoxImages = this.boundingBoxImages.filter((_, i) => i !== index);
    } catch (error) {
      console.error('Erreur lors du signalement:', error);
      this.$bvToast.toast('Erreur lors du signalement.', {
        title: 'Erreur',
        variant: 'danger',
        solid: true,
      });
    }
  }

  private handleChartClick(eventData: any): void {
    if (eventData.points && eventData.points.length > 0) {
      const point = eventData.points[0];

      // Récupérer l'heure de l'objet `Date` de `point.x`
      const clickedDate = new Date(point.x);

      // Vérifier si l'heure est `00:00:00`
      // Vérifier si l'heure est exactement à minuit en comparant la différence de temps
      const isMidnight = clickedDate.getTime() % (24 * 60 * 60 * 1000) === 0;

      if (isMidnight) {
        // Si l'heure est `00:00:00`, la définir à `12:00:00`
        clickedDate.setHours(12, 0, 0, 0);
      }

      this.weeklyClickedDate = clickedDate;

      // Récupérer les `photoIds` depuis `customdata`
      const photoIds: string[] = Array.isArray(point.customdata) ? point.customdata : [point.customdata];

      // Trouver les photos correspondantes dans le store des photos
      const selectedPhotos = this.dataImagesKey
        .map((item) => item.data) // extraire les Photo
        .filter((photo) => photoIds.includes(photo.id));

      // Sélectionner la photo la plus proche en heure si plusieurs photos existent pour une même date
      if (selectedPhotos.length > 0) {
        const closestPhoto = selectedPhotos.reduce((closest, photo) => {
          const photoTime = new Date(photo.createdAt).getTime();
          const clickedTime = clickedDate.getTime();
          const closestTime = new Date(closest.createdAt).getTime();

          return Math.abs(photoTime - clickedTime) < Math.abs(closestTime - clickedTime) ? photo : closest;
        }, selectedPhotos[0]);

        // Mettre à jour la photo sélectionnée avec celle qui correspond le mieux
        this.selectedPhotos = [closestPhoto];
      } else {
        console.warn('Aucune photo correspondante trouvée.');
        this.selectedPhotos = [];
      }
    }
  }

  private async updateChartForActivityReport(data: any[]): Promise<void> {
    const preparedData = this.prepareData(data);

    // Seules les courbes de densité et d'activité
    const traces: Partial<Plotly.PlotData>[] = this.createTraces(preparedData, false) as Partial<Plotly.PlotData>[]; // false désactive l'affichage des barres

    // Explicitly set the trace type as "scatter" if not already defined within `createTraces`
    traces.forEach((trace) => {
      if (!trace.type) {
        trace.type = 'scatter';
      }
    });

    const layout = this.createLayout();
    const config = this.createConfig();

    const plotDiv: any = document.getElementById('chart');
    await Plotly.react(plotDiv, traces as Plotly.Data[], layout, config);
  }

  private createLayout() {
    return {
      barmode: 'stack',
      bargap: 0.05,
      modebar: {
        orientation: 'v',
        bgcolor: '#001a35',
        color: '#6c757d',
        activecolor: '#5fc9e4',
      },
      xaxis: {
        color: '#5fc9e4',
        gridcolor: '#314a644a',
        type: 'date',
        tickformat: '%d/%m/%Y',
        autorange: !this.currentXRange, // si pas de range connu, on laisse Plotly gérer
        range: this.currentXRange
          ? [new Date(this.currentXRange[0]).toISOString(), new Date(this.currentXRange[1]).toISOString()]
          : undefined,
      },
      yaxis: {
        autorange: true,
        color: '#5fc9e4',
        gridcolor: '#314a644a',
        title: {
          text: 'Nombre total',
          standoff: 100, // Ajoute de l'espace entre l'axe et la légende
        },
        anchor: 'x',
      },
      yaxis2: {
        title: {
          text: 'Port EPI (%) & Mouvement (%)',
          standoff: 10, // Ajoute de l'espace entre l'axe et la légende
        },
        overlaying: 'y',
        side: 'right',
        tickformat: '.2f',
        showgrid: false,
        color: 'cyan',
        anchor: 'x',
        autorange: true,
      },
      margin: {
        l: 50,
        r: 100,
        b: 31,
        t: 10,
        pad: 0,
      },
      paper_bgcolor: 'transparent',
      plot_bgcolor: 'transparent',
      legend: {
        x: 0,
        xanchor: 'left' as const,
        y: 1.04,
        yanchor: 'middle' as const,
        orientation: 'h' as const,
        font: {
          color: '#5fc9e4',
        },
      },
    } as Partial<Plotly.Layout>;
  }

  private createConfig() {
    return {
      responsive: true,
      scrollZoom: true,
      displaylogo: false,
      doubleClick: 'reset',
      displayModeBar: true,
      modeBarButtonsToRemove: ['lasso2d', 'select2d'] as Plotly.ModeBarDefaultButtons[],
    } as Partial<Plotly.Config>;
  }

  private triggerLogoUpload() {
    (this.$refs.logoInput as HTMLInputElement).click();
  }

  private async handleLogoUpload(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) {
      console.error('❌ Aucun fichier sélectionné.');
      return;
    }

    try {
      const region = 'eu-west-3';
      const credentials = await Auth.currentCredentials();
      const s3 = new AWS.S3({ region, credentials });

      const ownerID = this.project?.owner?.id;
      const projectID = this.project?.id;
      if (!ownerID || !projectID) {
        console.error("❌ Impossible de récupérer l'ID du projet ou du propriétaire.");
        return;
      }

      const fileName = `logo-${Date.now()}.${file.name.split('.').pop()}`;
      const key = `public/${ownerID}/${projectID}/Logo/${fileName}`;

      const fileBuffer = await file.arrayBuffer();

      await s3
        .putObject({
          Bucket: 'erige-main-store-prod',
          Key: key,
          Body: Buffer.from(fileBuffer),
          ContentType: file.type,
          ACL: 'public-read',
        })
        .promise();

      console.log('✅ Logo uploadé avec succès:', key);
      this.fetchLogoUrl(); // Met à jour l'affichage après upload
    } catch (error) {
      console.error("❌ Erreur lors de l'upload du logo:", error);
    }
  }

  public async fetchLogoUrl() {
    try {
      if (!this.project || !this.project.owner) {
        console.warn('❌ `project` ou `project.owner` est indéfini. Attente...');
        return;
      }

      const region = 'eu-west-3';
      const credentials = await Auth.currentCredentials();
      const s3 = new AWS.S3({ region, credentials });

      const ownerID = this.project.owner.id;
      const projectID = this.project.id;

      console.log('🔹 Récupération du logo pour ownerID:', ownerID, 'projectID:', projectID);

      const prefix = `public/${ownerID}/${projectID}/Logo/`;

      const response = await s3
        .listObjectsV2({
          Bucket: 'erige-main-store-prod',
          Prefix: prefix,
        })
        .promise();

      if (response.Contents && response.Contents.length > 0) {
        const lastFile = response.Contents.sort(
          (a, b) => (b.LastModified?.getTime() || 0) - (a.LastModified?.getTime() || 0)
        )[0];

        if (lastFile && lastFile.Key) {
          this.logoUrl = s3.getSignedUrl('getObject', {
            Bucket: 'erige-main-store-prod',
            Key: lastFile.Key,
            Expires: 3600,
          });

          console.log('✅ URL du logo récupérée :', this.logoUrl);
        }
      } else {
        console.warn('❌ Aucun logo trouvé dans le bucket.');
      }
    } catch (error) {
      console.error('Erreur lors de la récupération du logo :', error);
    }
  }

  private async deleteAllLogos() {
    try {
      if (!this.project || !this.project.owner) return;

      const region = 'eu-west-3';
      const credentials = await Auth.currentCredentials();
      const s3 = new AWS.S3({ region, credentials });

      const ownerID = this.project.owner.id;
      const projectID = this.project.id;
      const prefix = `public/${ownerID}/${projectID}/Logo/`;

      // Liste des fichiers à supprimer
      const response = await s3.listObjectsV2({ Bucket: 'erige-main-store-prod', Prefix: prefix }).promise();
      if (!response.Contents || response.Contents.length === 0) {
        console.warn('❌ Aucun logo à supprimer.');
        return;
      }

      const deleteParams = {
        Bucket: 'erige-main-store-prod',
        Delete: { Objects: response.Contents.map((item) => ({ Key: item.Key! })) },
      };

      await s3.deleteObjects(deleteParams).promise();
      this.logoUrl = null; // Supprime l'affichage du logo après suppression
      console.log('✅ Tous les logos ont été supprimés.');
    } catch (error) {
      console.error('❌ Erreur lors de la suppression des logos:', error);
    }
  }

  @Watch('projects')
  public onProjectsLoaded(val: Project[], oldVal: Project[]): void {
    logger.info('onProjectsLoaded', { val, oldVal });
    this.project = this.projectWithId(this.id);
    this.setProject(this.project);
    this.isProjectLoading = false; // Le chargement est terminé
  }
  @Watch('project')
  public async onProjectLoaded(val: Project | null, oldVal: Project | null): Promise<void> {
    logger.info('onProjectLoaded', { val, oldVal });
    if (val !== null) {
      this.onCameraSelectedChange();
    }
    await this.fetchLogoUrl();
  }

  @Watch('camera')
  @Watch('project')
  private async onDependenciesReady() {
    if (this.camera && this.project && this.dataImagesKey.length > 0) {
      await this.$nextTick();
      if (this.modeSelected === 'Sécurité') {
        this.createSecurityChart();
      } else {
        this.createChart();
      }
    }
  }

  @Watch('socketMessage.message')
  public onSocketMessageChange(val: NotificationMessage): void {
    if (val.timelapse !== undefined && val.projectId === this.id && val.cameraId === this.cameraSelected) {
      switch (val.timelapse) {
        case 'ready':
          logger.info('ready');
          this.timelapseRending = false;
          this.loadTimelapse().then(() => {
            this.disconnectSocket();
          });
          break;
      }
    }
  }

  @Watch('cameraSelected')
  public async onCameraSelectedChange(): Promise<void> {
    if (this.cameraSelected && !this.loadingTimelapse) {
      await this.loadCameraPhotos();
      this.scheduleChartUpdate();
    }
    await this.loadPolygonPoints();
    await this.preloadBackgroundImage();
  }

  private async preloadBackgroundImage(): Promise<void> {
    let photo: Photo | null = null;
    if (this.selectedPhotos && this.selectedPhotos.length > 0) {
      photo = this.selectedPhotos[this.selectedPhotos.length - 1];
    } else if (this.dataImagesKey && this.dataImagesKey.length > 0) {
      photo = this.dataImagesKey[this.dataImagesKey.length - 1].data;
    }
    if (!photo) return;

    try {
      const key = photo.key || photo.smallKey;
      const photoUrl = await Storage.get(key);
      const img = new Image();
      img.crossOrigin = 'Anonymous';
      img.onload = () => {
        this.preloadedImage = img;
      };
      img.src = photoUrl as string;
    } catch (error) {
      console.error("Erreur lors du préchargement de l'image:", error);
    }
  }

  @Watch('startDate')
  private onStartDateChange(): void {
    if (this.updatingFromChart) return;
    if (!this.updatingFromDateRange) this.resetButtonSelection();
    this.scheduleChartUpdate();
  }

  @Watch('endDate')
  private onEndDateChange(): void {
    if (this.updatingFromChart) return;
    if (!this.updatingFromDateRange) this.resetButtonSelection();
    this.scheduleChartUpdate();
  }

  @Watch('modeSelected')
  private async onModeChanged(newMode: string) {
    this.isChartInitialized = false;
    this.scheduleChartUpdate();
  }

  @Watch('modeSelected')
  onModeSelectedChanged(newMode: string): void {
    if (this.isDetectionMode(newMode)) {
      this.manualAnnoDataset = 'erige';
    }
  }

  private activateDetectionMode() {
    this.createChart();
    this.showBoundingBoxes = true;
  }

  private activateSecurityMode() {
    this.createSecurityChart();
    this.showBoundingBoxes = false;
  }

  // drapeau pour le template
  private showBoundingBoxes = true;
}
